
<!--地球页面Globe混入方法：影像中心地球录制相关-->

<script>

import html2canvas from "html2canvas";
import mapboxgl from "mapbox-gl";
import * as turf from '@turf/turf'
import positionIcon from "@/assets/mapbox/icon.png";

export default {
  name: "GlobeScene",

  data(){
    return{

      //地球操作-录屏
      globeOperationScene:false,


      //截屏中
      cutScreening:false,

      //退出录屏弹窗
      quitScenePageDialogShow:false,


      //样例
      sceneExampleDialogShow:false,

      //动效蒙层
      animationAllScreenMantleShow:false,
      animationAllScreenMantleName:"",
      animationAllScreenMantleDuration:"",
      animationAllScreenBackground:"",

      animationAllScreenMantleCenterShow:false,
      animationAllScreenMantleCenterName:"",
      animationAllScreenMantleCenterDuration:"",
      animationAllScreenCenterBackground:"",

      animationWindowMantleShow:false,
      animationWindowMantleDuration:"",
      animationWindowBackground:"",

      animationAllScreenMapMantleName:"",
      animationAllScreenMapMantleDuration:"",


      //预览中   全屏播放中的记录也使用预览中的记录
      previewing:false,
      previewIntervalTemp:"",
      previewTemp:"",
      previewingType:"",
      //飞行预览停止
      previewAnimationFrameStop:false,

      fullScreenPlayBeginMantle:false,
      fullScreenPlayBeginMantleSecond:3,
      fullScreenPlaySceneIndex:0,   //当前全屏播放到哪个点 index
      fullScreenHiddenPath:false,   //进入全屏播放时是否隐藏了路径

      screenPlaySpeed:1,   //播放速度，默认1



      //录制/////////////////////////////////////////////////////////////////////////////////////////
      sceneRecommendedAnimationList:[],

      //视野点位
      viewPointerListOpen:true,
      //拖拽 源对象的下标
      viewPointItemDragIndex: '',
      //拖拽 目标对象的下标（也是经过对象下标）
      viewPointItemEndIndex: '',
      viewPointItemEndDirection:"",   //被拖拽项要插入目标项的上方top或下方bottom

      //视野点位重命名
      editViewItemNameShow:false,

      //切换录制点时 视野点弹窗处于编辑状态提示
      chooseNextSceneItem_notSaveDialogShow:false,
      nextChooseSceneItemType:"",   //sceneItem,flyAnimation
      nextChooseSceneItem:"",
      nextChooseSceneItemIndex:"",


      //素材
      materialListOpen:false,
      editMaterialItemNameShow:false,   //素材重命名
      //素材-点出现动画
      materialShowAnimationList_point:[
        {
          name:"无",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com/202310121710000493112.png"
        },
        {
          name:"淡出",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310201517000269308.png"
        },
        {
          name:"浮入",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310201521000298519.png"
        },
        {
          name:"扩展",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310201519000181776.png"
        },
        {
          name:"翻跳",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310201519000347797.png"
        },
      ],
      materialShowAnimationList_line:[
        {
          name:"无",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com/202310121710000493112.png"
        },
        {
          name:"沿线出现",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310201519000347797.png"
        },
      ],
      materialShowAnimationList_polygon:[
        {
          name:"无",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com/202310121710000493112.png"
        }
      ],
      //素材-点消失动画
      materialHideAnimationList:[
        {
          name:"无",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com/202310121710000493112.png"
        },
        {
          name:"淡出",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310201520000192575.png"
        },
        {
          name:"浮入",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310201521000145904.png"
        },
        {
          name:"扩展",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310201521000001902.png"
        },
        {
          name:"翻跳",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310201520000466959.png"
        }




      ],

      //时间轴下方文字位置
      setMaterialRangeSliderBeginLeft:"",
      setMaterialRangeSliderEndLeft:"",

      //素材重新定位项
      resetMaterialItemPositionItem:"",



      //添加视野点过程中的marker数据
      sceneViewMarkerSelectingList:[],


      //引导蒙层
      sceneGuideMantle_mapAvailable:false,   //仅地图区域亮起
      sceneGuideMantle_viewFinishBtnAvailable:false,   //仅视野点完成按钮可用
      sceneGuideMantle_viewFinishBtnAvailable_clipPathStyle:"",
      sceneGuideMantle_arrowPositionTop:"",
      sceneGuideMantle_arrowPositionLeft:"",
      sceneGuideMantle_arrowShow:false,


      //点击创建录制点时 是否自动添加视野点
      addScenePointAddFirstViewPoint:true,
      addDefaultFirstViewPointIng:false,


      //样例
      chooseExampleItem_notSaveDialogShow:false,
      nextExampleItemId:"",



      //添加素材弹窗
      addSceneMaterialShow:false,



      //播放中
      playing:false,    //整体播放中
      playMaterialInfo:{
        materialList:[],
        materialMarkerData:{
          pointList:[],
          lineList:{    //素材-线
            //线
            line:{
              'type': 'FeatureCollection',
              'features': []
            },
            //线名
            lineName:{
              'type': 'FeatureCollection',
              'features': []
            },
            //线拐点
            linePoint:{
              'type': 'FeatureCollection',
              'features': []
            },

          },
          polygonList:{
            //多边形
            polygon:{
              'type': 'FeatureCollection',
              'features': []
            },
            //多边形名
            polygonName:{
              'type': 'FeatureCollection',
              'features': []
            },
            //多边形拐点
            polygonPoint:{
              'type': 'FeatureCollection',
              'features': []
            },

          },
          imageList:[],

        }
      },


      sceneItemPlaying:false,   //标识某录制点自身播放中，用于监听录制点内素材是否应该结束动效
      clickPreviewBtnBubble:false,



      //3d模型
      sceneRoute3DModelShow:false,
      sceneRoute3DModelCurrentPosition:[],


      //临时 njh 配合本地缓存瓦片exe
      // FlyToFunToMinZoom:false,

      //旧版本///////////////////////////////////////////////////////////////
      // //地球操作-录屏
      // globeOperationScene:false,
      //
      // //截屏按钮说明展示
      // // addFlyPointBtnPsShow:false,
      //
      // //截屏中
      // cutScreening:false,
      //
      // //退出录屏弹窗
      // quitScenePageDialogShow:false,
      //
      //
      // //样例
      // // globeOperationSceneExampleShow:true,
      // // globeOperationSceneExampleList:[],
      // sceneExampleDialogShow:false,
      // //场景列表
      // // globeOperationSceneList:[],
      // // globeOperationSceneListShow:true,
      //
      // // 当前选中的场景index
      // // currClickItemIndex:-1,
      // //展开面板的场景index
      // // currOpenPanelItemIndex:-1,
      //
      //
      // //编辑场景名称
      // // editSceneNameShow:false,
      //
      //
      // // //飞行效果列表
      // // flyPanelList:[
      // //   {
      // //     name:"跳转",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303011104000027858.png"
      // //   },
      // //   {
      // //     name:"平移",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303011106000455801.png"
      // //   },
      // //   {
      // //     name:"切换",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/20230301110700030789.png"
      // //   },
      // //   {
      // //     name:"无效果",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303011110000485975.png"
      // //   },
      // // ],
      // // flyPanelParamShow:false,    //飞行面板更多参数展开
      // // flyPanelParam_flyParamMinZoomList:[
      // //   {
      // //     text:"高",
      // //     value:2
      // //   },
      // //   {
      // //     text:"中",
      // //     value:6
      // //   },
      // //   {
      // //     text:"低",
      // //     value:10
      // //   },
      // //
      // // ],
      // // flyPanelParam_jumpParamTypeList:[
      // //   {
      // //     name:"淡出",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/20230302113000004804.png"
      // //   },
      // //   {
      // //     name:"浮出",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303021130000164713.png"
      // //   },
      // //   {
      // //     name:"缩放",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303021130000288496.png"
      // //   },
      // //   {
      // //     name:"百叶窗",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303021416000529834.png"
      // //   }
      // // ],
      //
      //
      // // //点位效果列表
      // // pointPanelList:[
      // //   {
      // //     name:"旋转",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/2023030314390002757.png"
      // //   },
      // //   {
      // //     name:"俯视",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303031440000101755.png"
      // //   },
      // //   {
      // //     name:"路径",
      // //     // thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303031440000244253.png"   //白色
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202306091641000024200.png"  //灰色
      // //   },
      // //   {
      // //     name:"无效果",
      // //     thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303011110000485975.png"
      // //   },
      // //
      // // ],
      // // //点位面板更多参数展开
      // // pointPanelParamShow:false,
      // // pointPanelParam_rotateParamSpeedList:[
      // //   {
      // //     text:"快",
      // //     value:0.2
      // //   },
      // //   {
      // //     text:"中",
      // //     value:0.1
      // //   },
      // //   {
      // //     text:"慢",
      // //     value:0.05
      // //   },
      // // ],
      // // pointPanelParam_rotateParamDirectionList:[
      // //   {
      // //     text:"顺时针",
      // //     value:1
      // //   },
      // //   {
      // //     text:"逆时针",
      // //     value:0
      // //   }
      // // ],
      // // pointPanelParam_pitchParamPitchValueList:[
      // //   {
      // //     text:"高",
      // //     value:80
      // //   },
      // //   {
      // //     text:"中",
      // //     value:60
      // //   },
      // //   {
      // //     text:"低",
      // //     value:40
      // //   },
      // // ],
      // // pointPanelParam_pathParamSpeedList:[
      // //   {
      // //     text:"快",
      // //     value:3000
      // //   },
      // //   {
      // //     text:"中",
      // //     value:5000
      // //   },
      // //   {
      // //     text:"慢",
      // //     value:8000
      // //   },
      // // ],
      // // pointPanelParam_pathParamHeightList:[
      // //   {
      // //     text:"高",
      // //     value:12000
      // //   },
      // //   {
      // //     text:"中",
      // //     value:8000
      // //   },
      // //   {
      // //     text:"低",
      // //     value:4000
      // //   },
      // // ],
      //
      //
      // //动效蒙层
      // animationAllScreenMantleShow:false,
      // animationAllScreenMantleName:"",
      // animationAllScreenMantleDuration:"",
      // animationAllScreenBackground:"",
      //
      // animationAllScreenMantleCenterShow:false,
      // animationAllScreenMantleCenterName:"",
      // animationAllScreenMantleCenterDuration:"",
      // animationAllScreenCenterBackground:"",
      //
      // animationWindowMantleShow:false,
      // animationWindowMantleDuration:"",
      // animationWindowBackground:"",
      //
      //
      //
      // // //初始提示 跟随鼠标提示
      // // globeOperationSceneTip:false,
      // // globeOperationSceneTipTop:"",
      // // globeOperationSceneTipLeft:"",
      // // globeOperationSceneTipContent:"",
      //
      // //记录进入录屏时的地球视角
      // // mapCameraOptions:"",
      //
      //
      // //绘制中
      // // drawingLine:false,
      // //预览中   全屏播放中的记录也使用预览中的记录
      // previewing:false,
      // previewIntervalTemp:"",
      // previewTemp:"",
      // previewingType:"",
      // //飞行预览停止
      // previewAnimationFrameStop:false,
      //
      // fullScreenPlayBeginMantle:false,
      // fullScreenPlayBeginMantleSecond:3,
      // fullScreenPlaySceneIndex:0,   //当前全屏播放到哪个点 index
      // fullScreenHiddenPath:false,   //进入全屏播放时是否隐藏了路径
      //
      // screenPlaySpeed:1,   //播放速度，默认1

      // //项目中常显的素材地图数据
      // allShowInSceneMaterialMarkerData:{
      //   pointList:[],
      //   lineList:{    //素材-线
      //     //线
      //     line:{
      //       'type': 'FeatureCollection',
      //       'features': []
      //     },
      //     //线名
      //     lineName:{
      //       'type': 'FeatureCollection',
      //       'features': []
      //     },
      //     //线拐点
      //     linePoint:{
      //       'type': 'FeatureCollection',
      //       'features': []
      //     },
      //
      //   },
      //   polygonList:{
      //     //多边形
      //     polygon:{
      //       'type': 'FeatureCollection',
      //       'features': []
      //     },
      //     //多边形名
      //     polygonName:{
      //       'type': 'FeatureCollection',
      //       'features': []
      //     },
      //     //多边形拐点
      //     polygonPoint:{
      //       'type': 'FeatureCollection',
      //       'features': []
      //     },
      //
      //   },
      //   imageList:[],
      //
      // },


    }

  },
  computed:{
    scenePointEditingStore() {
      return this.$store.state.scenePointEditing;
    },
    sceneMaterialShowStore() {
      return this.$store.state.sceneMaterialShow;
    },
    currChooseSceneItemIdStore() {
      return this.$store.state.currChooseSceneItemId;
    },


    setMaterialAreaShowStore() {
      return this.$store.state.setMaterialAreaShow;
    },


    //素材刻度尺上方点位显示
    materialAreaRangeSliderPointShow(){
      return function(index){
        let currViewPointNum = this.$store.state.scenePointEditing
            ? this.$store.state.tempViewPointList.length
            : this.$store.state.currChooseSceneItemIndex !== ''
                ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length
                : 0;

        if(currViewPointNum <10){
          //10个点以内，全显示
          return true;
        }
        else{
          //显示间隔
          let spaceNum = Math.round((currViewPointNum-1) / 4)
          //要显示的index
          let showPointIndex = [0,spaceNum,spaceNum*2,spaceNum*3,currViewPointNum-1]

          if(showPointIndex.indexOf(index) !== -1){
            return true
          }
          else{
            return false
          }
        }
      }

    },
    materialAreaRangeSliderPointLeft(){
      return function(index){
        let currViewPointNum = this.$store.state.scenePointEditing
            ? this.$store.state.tempViewPointList.length
            : this.$store.state.currChooseSceneItemIndex !== ''
                ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length
                : 0;

        //显示间隔
        let spaceWidth = 340 / currViewPointNum;
        return spaceWidth*index - spaceWidth/5/2 * index + 'px'
      }
    }


  },

  watch:{
    // //录屏的进入和退出
    // globeOperationScene(){
    //   this.$store.state.globeOperationScene = true;
    //   if(this.globeOperationScene){
    //
    //
    //   }
    //   else{
    //
    //   }
    //
    // },


    //使用！！监听是否进入录制点编辑状态
    scenePointEditingStore() {
      if(this.$store.state.scenePointEditing){
        //进入编辑，展示添加视野点过程中的icon
        this.sceneViewMarkerSelectingList = []
        this.sceneViewMarkerSelectingList.push({
          center:this.map.getCenter()
        })
        this.$store.state.sceneViewMarkerSelectingShow = true;

        this.$store.state.sceneViewMarkerShow = true;
      }
      else{
        this.sceneViewMarkerSelectingList = [];
        this.$store.state.sceneViewMarkerSelectingShow = false;
      }
    },


    //使用！！监听选中录制点变化，控制素材加载
    currChooseSceneItemIdStore(){
      console.log("监听选中录制点变化")
      console.log(this.clickPreviewBtnBubble)
      if(this.$store.state.currChooseSceneItemId !== ""){
        if(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].flyAnimationShow){
          //当前显示转场，地球上没有素材marker
          this.clearMaterialMarkerLayer()
          this.$store.state.sceneViewMarkerShow = false;
        }
        else{
          //解析素材地图marker数据
          if(!this.clickPreviewBtnBubble){
            //通过点击预览按钮造成的录制点变化，不需要处理素材，预览中有处理逻辑
            this.createMaterialMarkerLayer()
            if(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerUpdate){
              //需要更新素材
              this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
            }
            this.$store.state.sceneViewMarkerShow = true;
          }

        }
      }
      else{
        if(this.$store.state.scenePointEditing){
          //在编辑，有临时数据
          //解析素材地图marker数据
          this.createMaterialMarkerLayer()
          this.getMaterialMarkerData(this.$store.state.tempMaterialInfo);
          this.$store.state.sceneViewMarkerShow = true;
        }
        else{
          //清空数据
          this.clearMaterialMarkerLayer()
          this.$store.state.sceneViewMarkerShow = false;
        }
      }
    },


    //使用！！监听素材显示设置弹窗出现，调整刻度尺的填充区域宽度
    setMaterialAreaShowStore(){
      if(this.$store.state.setMaterialAreaShow){
        setTimeout(()=>{
          this.rangeSliderChangeFun()
        },50)

      }
      else{
        //没有当前选中的素材，清空上次选中素材的图层，恢复原本显示
        //有两种可能隐藏素材显示弹窗：1是普通隐藏；2是删除素材造成的隐藏

        console.log(this.$store.state.currChooseMaterialItem)
        //根据上次选中的素材类型，清除上次选中样式
        this.hideChooseMaterialMarker();
        this.showMaterialMarker();

        this.$store.state.currChooseMaterialItem = "";
        this.$store.state.currChooseMaterialItemId = "";
        this.$store.state.currChooseMaterialItemIndex = "";

      }
    },




  },

  methods:{


    //使用！！打开场景新手引导视频  更换视频njh
    openSceneGuideVideo(){
      this.isPreviewing(()=>{
        this.fullScreenVideoSrc = "https://market.obs.cn-north-4.myhuaweicloud.com/webGuide/web/luzhi.mp4";
        this.fullScreenVideoFrom = "scene"
        this.fullScreenVideoShow = true;
        this.fullScreenVideoVIf = true;

        // //停止监听退出录屏
        // document.removeEventListener('keyup', this.keyUpInScene);
      })
    },

    //使用！！关闭引导视频
    closeFullScreenVideo(){
      // if(this.fullScreenVideoFrom === "scene"){
      //   //来自录屏，继续监听退出录屏
      //   document.addEventListener('keyup', this.keyUpInScene);
      // }
      this.fullScreenVideoFrom = ""
      this.fullScreenVideoShow = false;
      setTimeout(()=>{
        this.fullScreenVideoVIf = false;
        this.fullScreenVideoOrigin = "center"
      },200)
    },


    //进入录屏
    intoGlobeOperationScene(){


      this.cleanMapOnEvent()
      this.clearAllMeasure()
      this.closeEditCard()
      this.drawToolsChoose='selectTool'
      this.drawToolsOldChose = 'selectTool'

      this.clearDataListEffect()
      // this.closeLayerCardShow()
      this.layerCardShow = false
      this.layerCardTypeSelect = ''
      this.$store.state.selectLayerTreeNode = ''
      this.hideLayer('none')


      this.animationAllScreenMantleShow = false;
      this.animationAllScreenMantleName = "";
      this.animationAllScreenMantleDuration = "";
      this.animationAllScreenBackground = "";
      this.animationAllScreenMantleCenterShow = false;
      this.animationAllScreenMantleCenterName = "";
      this.animationAllScreenMantleCenterDuration = "";
      this.animationAllScreenCenterBackground = "";
      this.animationWindowMantleShow = false;
      this.animationWindowMantleDuration = "";
      this.animationWindowBackground = "";

      // //关闭地球设置弹窗
      // if(this.globeSetShow){
      //   this.globeSetShow = false;
      // }

    },



    //录制点///////////////////////////////////////////////////////////////////////////////////////

    //使用！！点击添加录制点按钮
    beginAddScenePoint(){
      this.isPreviewing(()=>{
        this.isSceneItemDragging(()=>{
          this.isSceneItemMultipleChoosing(()=>{
            //开始添加初始视野点
            this.isMaterialShow(()=>{
              //不选择任何录制点
              this.$store.state.currChooseSceneItemId = "";
              this.$store.state.currChooseSceneItemIndex = "";
              this.$store.state.tempMaterialInfo = {
                materialList:[],
                materialMarkerData:this.$store.state.defaultMaterialMarkerData
              };
            })

            //显示视野点弹窗
            this.$store.state.scenePointEditing = true;
            this.$store.state.tempViewPointList = [];
            this.$store.state.tempSceneZoomBasis = "";
            this.$store.state.sceneViewPointAreaShow = true;
            //开始添加视野点引导
            this.$store.state.sceneOperationState_addViewPointGuideState = "firstViewPoint";
            this.$store.state.sceneOperationState_addViewPointRecommendedAnimationShow = false;
            //视野点栏折叠，自动打开
            if(!this.viewPointerListOpen){
              this.changeViewPointerListOpenState()
            }

            this.loadingDialogText = "录制点位添加中……";
            this.showLoadingDialog = true;

            //点击创建录制点可能自动添加视野点
            if(this.addScenePointAddFirstViewPoint){
              this.addDefaultFirstViewPointIng = true;
              this.addViewPoint()
            }
            else{
              this.addScenePointAddFirstViewPoint = true;
            }

          })

        })

      })
    },


    //使用！！录制点预览
    previewSceneItem(item){
      console.log(item)
      this.isPreviewing(()=>{
        //记录是点击预览按钮冒泡到点击视野点
        this.clickPreviewBtnBubble = true;

        this.sceneItemPlaying = true;

        //如果有选中的素材，需要先恢复素材图层再操作
        this.isMaterialShow(()=>{

          //修改当前播放到的录制点
          this.$store.state.sceneCurrPlayItem = item;

          //加载该录制点的素材
          this.playMaterialInfo = JSON.parse(JSON.stringify(item.materialInfo))
          this.getMaterialMarkerData_play(this.playMaterialInfo)
          //素材点销毁重新加载，以开始素材-点素材动画
          this.$store.state.sceneMaterialShow = false;
          setTimeout(()=>{
            this.$store.state.sceneMaterialShow = true;
          },0)

          //解析显示常显素材数据
          this.createMaterialMarkerLayer_allShow()
          this.getAllShowInSceneMaterialMarkerData()

          // //素材清除
          // this.$store.state.sceneMaterialShow = false;
          // let currMaterialInfo = JSON.parse(JSON.stringify(item.materialInfo))
          // currMaterialInfo.materialMarkerData.pointList = [];
          // currMaterialInfo.materialMarkerData.lineList = {    //素材-线
          //   //线
          //   line:{
          //     'type': 'FeatureCollection',
          //     'features': []
          //   },
          //   //线名
          //   lineName:{
          //     'type': 'FeatureCollection',
          //     'features': []
          //   },
          //   //线拐点
          //   linePoint:{
          //     'type': 'FeatureCollection',
          //     'features': []
          //   },
          //
          // };
          // currMaterialInfo.materialMarkerData.polygonList = {
          //   //多边形
          //   polygon:{
          //     'type': 'FeatureCollection',
          //     'features': []
          //   },
          //   //多边形名
          //   polygonName:{
          //     'type': 'FeatureCollection',
          //     'features': []
          //   },
          //   //多边形拐点
          //   polygonPoint:{
          //     'type': 'FeatureCollection',
          //     'features': []
          //   },
          //
          // };
          // currMaterialInfo.materialMarkerData.imageList = [];
          // this.map.getSource('sceneMaterialLine').setData(currMaterialInfo.materialMarkerData.lineList.line)
          // this.map.getSource('sceneMaterialLinePoint').setData(currMaterialInfo.materialMarkerData.lineList.linePoint)
          // this.map.getSource('sceneMaterialLineName').setData(currMaterialInfo.materialMarkerData.lineList.lineName)
          // this.map.getSource('sceneMaterialPolygon').setData(currMaterialInfo.materialMarkerData.polygonList.polygon)
          // this.map.getSource('sceneMaterialPolygonPoint').setData(currMaterialInfo.materialMarkerData.polygonList.polygonPoint)
          // this.map.getSource('sceneMaterialPolygonName').setData(currMaterialInfo.materialMarkerData.polygonList.polygonName)

          //根据点位动效不同，执行点位动效前不一定飞到改点位视角
          switch(item.pointAnimation){
            case "高空悬停":{
              //上一点位飞到当前点位的center+pitch+bearing+加大zoom
              let jumpItem = {
                sceneCenter:item.sceneCenter,
                sceneZoom:item.sceneZoom < 16.9 ? item.sceneZoom + 0.1 : 17,
                sceneBearing:item.sceneBearing,
                scenePitch:item.scenePitch,
              }
              this.jumpToSceneItem(jumpItem)
              break;
            }
            case "螺旋靠近":{
              //上一点位飞到当前点位的center+pitch+bearing+减小zoom
              let jumpItem = {
                sceneCenter:item.sceneCenter,
                sceneZoom:item.sceneZoom > 3 ? item.sceneZoom - 2 : 1,
                sceneBearing:item.sceneBearing,
                scenePitch:item.scenePitch,
              }
              this.jumpToSceneItem(jumpItem)
              break;
            }
            case "俯冲环绕":{
              //上一点位飞到当前点位的center+pitch=0+bearing+减小zoom
              let jumpItem = {
                sceneCenter:item.sceneCenter,
                sceneZoom:item.sceneZoom > 3 ? item.sceneZoom - 2 : 1,
                sceneBearing:item.sceneBearing,
                scenePitch:0,
              }
              this.jumpToSceneItem(jumpItem)
              break;
            }
            case "俯冲观测":{
              //上一点位飞到当前点位的center+pitch=0+bearing+减小zoom
              let jumpItem = {
                sceneCenter:item.sceneCenter,
                sceneZoom:item.sceneZoom > item.pointAnimationParam.zoomAddAndHovering.zoomChange+1 ? item.sceneZoom - item.pointAnimationParam.zoomAddAndHovering.zoomChange : 1,
                sceneBearing:item.sceneBearing,
                scenePitch:0,
              }
              this.jumpToSceneItem(jumpItem)
              break;
            }



            case "空中游览":{
              //上一点位飞到当前点位的center+pitch=0+bearing=0+减小zoom
              let jumpItem = {
                sceneCenter:item.sceneCenter,
                sceneZoom:item.zoomBasis > 2 ? item.zoomBasis - 1 : 1,
                sceneBearing:0,
                scenePitch:0,
              }
              this.jumpToSceneItem(jumpItem)
              break;
            }
            case "侧向跟踪":{
              //上一点位飞到当前点位的center+pitch=0+bearing=0+减小zoom
              let jumpItem = {
                sceneCenter:item.sceneCenter,
                sceneZoom:item.zoomBasis,
                sceneBearing:0,
                scenePitch:60,
              }
              this.jumpToSceneItem(jumpItem)
              break;
            }
            case "模拟驾驶":{
              //上一点位飞到当前点位的center+pitch=60+bearing=0+减小zoom
              let jumpItem = {
                sceneCenter:item.sceneCenter,
                sceneZoom:item.zoomBasis < 16 ? item.zoomBasis + 1 : 17,
                sceneBearing:0,
                scenePitch:60,
              }
              this.jumpToSceneItem(jumpItem)
              break;
            }





            default:{
              this.jumpToSceneItem(item)
              break;
            }
          }

          setTimeout(()=>{
            this.previewing = true;
            //解除 记录是点击预览按钮冒泡到点击视野点
            this.clickPreviewBtnBubble = false;

            this.previewingType = "point+"+item.pointAnimation

            //隐藏视野点
            this.$store.state.sceneViewMarkerShow = false;

            switch(item.pointAnimation){
              //单点
              case "螺旋凝视":{
                this.previewAnimationFrameStop = false;
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  this.rotateToByDuration(0.1,1,item.pointAnimationParam.rotate.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      }
                  )
                },item.pointAnimationParam.rotate.timeout*1000)

                break;
              }
              case "太空俯冲":{
                this.previewAnimationFrameStop = false;
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  this.flyToSlide(item.sceneZoom,item.pointAnimationParam.slide.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)



                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      }
                  )
                },item.pointAnimationParam.slide.timeout*1000)

                break;
              }
              case "地球自转":{
                this.previewAnimationFrameStop = false;
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  this.earthRotation(item.pointAnimationParam.earthRotation.direction,item.pointAnimationParam.earthRotation.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      }
                  )

                },item.pointAnimationParam.earthRotation.timeout*1000)

                break;
              }
              case "高空悬停":{
                this.previewAnimationFrameStop = false;
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  this.zoomSubAndHovering(item.pointAnimationParam.zoomSubAndHovering.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      }
                  )

                },item.pointAnimationParam.zoomSubAndHovering.timeout*1000)

                break;
              }
              case "螺旋环绕":{
                this.previewAnimationFrameStop = false;
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  this.zoomAddAndPitchAddAndRotate(item.pointAnimationParam.zoomAddAndPitchAddAndRotate.direction,item.pointAnimationParam.zoomAddAndPitchAddAndRotate.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      }
                  )

                },item.pointAnimationParam.zoomAddAndPitchAddAndRotate.timeout*1000)

                break;
              }
              case "螺旋靠近":{
                this.previewAnimationFrameStop = false;
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  this.zoomAddAndPitchAddAndRotateZoomAdd(item.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.direction,item.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      }
                  )

                },item.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.timeout*1000)

                break;
              }
              case "俯冲环绕":{
                this.previewAnimationFrameStop = false;
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  this.zoomAddAndRotate(item.pointAnimationParam.zoomAddAndRotate.direction,item.pointAnimationParam.zoomAddAndRotate.zoomChange,item.pointAnimationParam.zoomAddAndRotate.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      }
                  )

                },item.pointAnimationParam.zoomAddAndRotate.timeout*1000)

                break;
              }
              case "俯冲观测":{
                this.previewAnimationFrameStop = false;
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  this.zoomAddAndHovering(item.pointAnimationParam.zoomAddAndHovering.zoomChange,item.pointAnimationParam.zoomAddAndHovering.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      }
                  )

                },item.pointAnimationParam.zoomAddAndHovering.timeout*1000)

                break;
              }

              //多点
              case "平移跟踪":{
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  let routePoints = [];
                  for(let i=0;i<item.viewPointList.length;i++){
                    routePoints.push([item.viewPointList[i].lng,item.viewPointList[i].lat])
                  }
                  this.previewAnimationFrameStop = false;

                  this.flyByPath(routePoints,item.pointAnimationParam.route.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      })
                },item.pointAnimationParam.route.timeout*1000)


                break;
              }
              case "侧向跟踪":{
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  let routePoints = [];
                  for(let i=0;i<item.viewPointList.length;i++){
                    routePoints.push([item.viewPointList[i].lng,item.viewPointList[i].lat])
                  }
                  this.previewAnimationFrameStop = false;

                  this.flyByPathWithChangeBearing(routePoints,item.pointAnimationParam.flyByPathWithChangeBearing.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      })
                },item.pointAnimationParam.flyByPathWithChangeBearing.timeout*1000)


                break;
              }
              case "空中游览":{
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  let routePoints = [];
                  for(let i=0;i<item.viewPointList.length;i++){
                    routePoints.push([item.viewPointList[i].lng,item.viewPointList[i].lat])
                  }
                  this.previewAnimationFrameStop = false;

                  this.zoomAddAndFlyByPath(routePoints,item.pointAnimationParam.zoomAddAndFlyByPath.duration,
                      ()=>{

                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
                      })
                },item.pointAnimationParam.zoomAddAndFlyByPath.timeout*1000)


                break;
              }
              case "模拟驾驶":{
                clearTimeout(this.previewTemp)
                this.previewTemp = setTimeout(()=>{
                  let routePoints = [];
                  for(let i=0;i<item.viewPointList.length;i++){
                    routePoints.push([item.viewPointList[i].lng,item.viewPointList[i].lat])
                  }
                  this.previewAnimationFrameStop = false;

                  this.flyByPathWithWatchNextPoint(routePoints,item.pointAnimationParam.flyByPathWithWatchNextPoint.duration,
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      })
                },item.pointAnimationParam.flyByPathWithWatchNextPoint.timeout*1000)

                break;
              }


              case "无效果":{
                console.log("无效果预览")
                this.previewAnimationFrameStop = false;
                setTimeout(()=>{
                  this.pointNoAnimation(
                      ()=>{
                        this.previewing = false;

                        setTimeout(()=>{
                          //当前录制点素材显隐（更新该录制点的素材地图标记文件）
                          this.$store.state.sceneCurrPlayItem = "";
                          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

                          //隐藏常显素材地图数据
                          this.$store.state.sceneMaterialShow_allShow = false;
                          this.clearMaterialMarkerLayer_allShow()

                          this.sceneItemPlaying = false;
                          //加载当前选择录制点的素材
                          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
                          //素材点销毁重新加载，以开始素材动画
                          setTimeout(()=>{
                            this.$store.state.sceneMaterialShow = true;
                          },0)

                          //显示视野点
                          this.$store.state.sceneViewMarkerShow = true;

                        },0)

                        // this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                      }
                  )
                },0)

                break;
              }

            }
          },0)

        })

      })
    },


    //从素材显示设置弹窗进入当前录制点预览
    previewSceneItemFromSetMaterialArea(){
      if(this.$store.state.currChooseSceneItemIndex !== ''){
        this.previewSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
      }
      else{
        console.log("未创建录制点，不能预览")
      }
    },

    //地球视角跳到某个场景
    jumpToSceneItem(item){
      console.log(item)
      this.map.jumpTo({
        center:[item.sceneCenter[0],item.sceneCenter[1]],
        zoom:item.sceneZoom,
        bearing:item.sceneBearing,
        pitch:item.scenePitch,
      });
    },


    //转场预览
    previewFlyAnimation(sceneItems){
      console.log(sceneItems)
      this.isPreviewing(()=>{

        let currSceneItem = sceneItems.currSceneItem;
        let nextSceneItem = sceneItems.nextSceneItem;

        this.previewingType = "fly+" + currSceneItem.flyAnimation + "+" + currSceneItem.flyAnimationParam.jumpTo.type
        this.previewing = true;

        this.jumpToSceneItem(currSceneItem)
        setTimeout(()=>{
          switch(currSceneItem.flyAnimation){
            case "跳跃":{
              // 临时njh 配合本地缓存瓦片exe
              // this.FlyToFunToMinZoom = false
              this.flyToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                  nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.flyTo.duration / this.screenPlaySpeed,currSceneItem.flyAnimationParam.flyTo.minZoom,
                  ()=>{this.previewing = false}
              )
              break;
            }
            case "平移":{
              this.easeToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                  nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.easeTo.duration / this.screenPlaySpeed,
                  ()=>{this.previewing = false}
              )
              break;
            }
            case "切换":{

              switch(currSceneItem.flyAnimationParam.jumpTo.type){
                case "淡出":{
                  // this.pageAnimationAllScreen("blackToTransparent",currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
                  //     ()=>{this.previewing = false;this.pointChange(i+1)}
                  // )
                  // this.jumpToSceneItem(nextSceneItem)

                  this.pageAnimationOperationChnage("mapOpacityChange",currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,nextSceneItem,
                      ()=>{this.previewing = false;}
                  )

                  break;
                }
                case "浮入":{
                  this.pageAnimationAllScreen("height100To0",currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
                      ()=>{this.previewing = false;}
                  )
                  this.jumpToSceneItem(nextSceneItem)

                  break;
                }
                case "扩展":{
                  this.pageAnimationAllScreenCenter("allScreenToCenter",currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
                      ()=>{this.previewing = false;}
                  )
                  this.jumpToSceneItem(nextSceneItem)

                  break;
                }
                case "百叶窗":{
                  this.pageAnimationWindowClose(currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
                      ()=>{this.previewing = false;}
                  )
                  this.jumpToSceneItem(nextSceneItem)

                  break;
                }
                case "无":{
                  this.jumpToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                      nextSceneItem.scenePitch,
                      ()=>{this.previewing = false;}
                  )
                  break;
                }

              }


              break;
            }


              //新动效
            case "旋转跳跃":{
              this.rotateAndFlyTo(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                  nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.rotateAndFlyTo.duration / this.screenPlaySpeed,
                  ()=>{this.previewing = false;}
              )
              break;
            }
            case "穿梭":{
              this.easeToWithSpeed(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                  nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.easeToWithSpeed.duration / this.screenPlaySpeed,
                  ()=>{this.previewing = false;}
              )
              break;
            }
            case "回太空":{
              this.flyToBetweenGlobal(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                  nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.flyToBetweenGlobal.duration / this.screenPlaySpeed,
                  ()=>{this.previewing = false;}
              )
              break;
            }

            case "无":{
              this.jumpToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                  nextSceneItem.scenePitch,
                  ()=>{this.previewing = false;}
              )
              break;
            }
          }

        },0)



      })

    },



    //全屏播放
    scenePlay(){
      console.log("播放")
      this.createExample()

      //如果地球设置打开，需要关闭
      if(this.globeSetShow){
        this.globeSetShow = false;
      }

      this.isPreviewing(()=>{
        //如果有选中的素材，需要先恢复素材图层再操作
        this.isMaterialShow(()=>{

          if(this.$store.state.sceneList.length > 0){

            //没有选中视野点时 或 刚点击转场后，地图上可能没有图层
            this.createMaterialMarkerLayer()
            this.createMaterialMarkerLayer_allShow()

            this.playing = true;

            document.addEventListener('keyup', this.escQuitFullScreen);

            //正在编辑视野点，取消编辑
            if(this.$store.state.scenePointEditing){
              this.viewPointerListCancel()
            }

            //隐藏地图icon等
            //解析空素材列表，即清空地图上标记
            this.playMaterialInfo = {
              materialList:[],
              materialMarkerData:this.$store.state.defaultMaterialMarkerData
            }
            this.getMaterialMarkerData(this.playMaterialInfo)
            this.$store.state.sceneViewMarkerShow = false;

            //解析显示常显素材数据
            this.getAllShowInSceneMaterialMarkerData()


            //隐藏比例尺
            document.querySelector('.mapboxgl-ctrl-scale').style.visibility = 'hidden'

            //屏蔽mapbox的鼠标交互
            this.map.boxZoom.disable();
            this.map.scrollZoom.disable();
            this.map.dragPan.disable();
            this.map.dragRotate.disable();
            this.map.doubleClickZoom.disable();
            this.map.touchZoomRotate.disable();

            this.$store.state.globeSceneFullScreen = true
            setTimeout(()=>{
              this.map.resize()
            },0)

            //跳转到第一个点位
            let firstItem = this.$store.state.sceneList[0];
            //根据点位动效不同，执行点位动效前不一定飞到改点位视角
            switch(firstItem.pointAnimation){
              case "高空悬停":{
                //上一点位飞到当前点位的center+pitch+bearing+加大zoom
                firstItem = {
                  sceneCenter:firstItem.sceneCenter,
                  sceneZoom:firstItem.sceneZoom < 16.9 ? firstItem.sceneZoom + 0.1 : 17,
                  sceneBearing:firstItem.sceneBearing,
                  scenePitch:firstItem.scenePitch,
                }
                this.jumpToSceneItem(firstItem)
                break;
              }
              case "螺旋靠近":{
                //上一点位飞到当前点位的center+减小pitch+增大（根据旋转方向来）bearing+减小zoom
                firstItem = {
                  sceneCenter:firstItem.sceneCenter,
                  sceneZoom:firstItem.sceneZoom > 3 ? firstItem.sceneZoom - 2 : 1,
                  sceneBearing:firstItem.sceneBearing,
                  scenePitch:firstItem.scenePitch,
                }
                this.jumpToSceneItem(firstItem)
                break;
              }
              case "俯冲环绕": case "俯冲观测":{
                //上一点位飞到当前点位的center+pitch=0+bearing+减小zoom
                firstItem = {
                  sceneCenter:firstItem.sceneCenter,
                  sceneZoom:firstItem.sceneZoom > 3 ? firstItem.sceneZoom - 2 : 1,
                  sceneBearing:firstItem.sceneBearing,
                  scenePitch:0,
                }
                this.jumpToSceneItem(firstItem)
                break;
              }


              case "空中游览":{
                //上一点位飞到当前点位的center+pitch=0+bearing=0+减小zoom
                firstItem = {
                  sceneCenter:firstItem.sceneCenter,
                  sceneZoom:firstItem.zoomBasis > 2 ? firstItem.zoomBasis - 1 : 1,
                  sceneBearing:0,
                  scenePitch:0,
                }
                this.jumpToSceneItem(firstItem)
                break;
              }
              case "侧向跟踪":{
                //上一点位飞到当前点位的center+pitch=0+bearing=0+减小zoom
                firstItem = {
                  sceneCenter:firstItem.sceneCenter,
                  sceneZoom:firstItem.zoomBasis,
                  sceneBearing:0,
                  scenePitch:60,
                }
                this.jumpToSceneItem(firstItem)
                break;
              }
              case "模拟驾驶":{
                //上一点位飞到当前点位的center+pitch=0+bearing=0+减小zoom
                firstItem = {
                  sceneCenter:firstItem.sceneCenter,
                  sceneZoom:firstItem.zoomBasis < 16 ? firstItem.zoomBasis + 1 : 17,
                  sceneBearing:0,
                  scenePitch:0,
                }
                this.jumpToSceneItem(firstItem)
                break;
              }

              default:{
                this.jumpToSceneItem(firstItem)
                break;
              }
            }

            //显示即将开始蒙层
            this.fullScreenPlayBeginMantleSecond = 3;
            this.fullScreenPlayBeginMantle = true;

            //倒计时
            clearInterval(this.previewIntervalTemp)
            this.previewIntervalTemp = setInterval(()=>{
              if(this.fullScreenPlayBeginMantleSecond === 1){
                clearInterval(this.previewIntervalTemp);
              }
              this.fullScreenPlayBeginMantleSecond = this.fullScreenPlayBeginMantleSecond - 1;
            },1000)

            clearTimeout(this.previewTemp)
            this.previewTemp = setTimeout(()=>{
              this.fullScreenPlayBeginMantle = false;
              //开始全屏飞行
              clearTimeout(this.previewTemp)
              this.previewTemp = setTimeout(()=>{
                this.pointChange(0)
              },1000)


            },3000)


          }
          else{
            this.$store.state.snackbarText = "当前无可播放内容，请至少添加1个内容"
            this.$store.state.snackbarType = 'error'
            this.$store.state.snackbarShow=true
          }

        })



      })

    },
    //全屏播放 点位效果
    pointChange(i){
      console.log("pointChange" + i)
      if(i < this.$store.state.sceneList.length){

        this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

        this.sceneItemPlaying = true;

        let currSceneItem = this.$store.state.sceneList[i];   //当前录制点

        //当前录制点素材显隐（更新该录制点的素材地图标记文件）

        //修改当前播放到的录制点
        this.$store.state.sceneCurrPlayItem = currSceneItem;
        //加载该录制点的素材
        this.playMaterialInfo = JSON.parse(JSON.stringify(currSceneItem.materialInfo))
        this.getMaterialMarkerData_play(this.playMaterialInfo)
        //素材点销毁重新加载，以开始素材-点动画
        setTimeout(()=>{
          this.$store.state.sceneMaterialShow = true;
        },0)


        //进行点位效果
        this.previewing = true;
        this.previewingType = "point+"+currSceneItem.pointAnimation
        console.log(this.previewingType)


        switch(currSceneItem.pointAnimation){
          //单点
          case "螺旋凝视":{
            this.previewAnimationFrameStop = false;
            this.previewTemp = setTimeout(()=>{
              clearTimeout(this.previewTemp)
              this.rotateToByDuration(0.1,1,currSceneItem.pointAnimationParam.rotate.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";
                    this.flyChange(i)
                  }
              )
            },currSceneItem.pointAnimationParam.rotate.timeout*1000)

            break;
          }
          case "太空俯冲":{
            this.previewAnimationFrameStop = false;
            this.previewTemp = setTimeout(()=>{
              clearTimeout(this.previewTemp)
              this.flyToSlide(currSceneItem.sceneZoom,currSceneItem.pointAnimationParam.slide.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  }
              )
            },currSceneItem.pointAnimationParam.slide.timeout*1000)

            break;
          }
          case "地球自转":{
            this.previewAnimationFrameStop = false;
            this.previewTemp = setTimeout(()=>{
              clearTimeout(this.previewTemp)
              this.earthRotation(currSceneItem.pointAnimationParam.earthRotation.direction,currSceneItem.pointAnimationParam.earthRotation.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  }
              )
            },currSceneItem.pointAnimationParam.earthRotation.timeout*1000)

            break;
          }
          case "高空悬停":{
            this.previewAnimationFrameStop = false;
            this.previewTemp = setTimeout(()=>{
              clearTimeout(this.previewTemp)
              this.zoomSubAndHovering(currSceneItem.pointAnimationParam.zoomSubAndHovering.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  }
              )
            },currSceneItem.pointAnimationParam.zoomSubAndHovering.timeout*1000)

            break;
          }
          case "螺旋环绕":{
            this.previewAnimationFrameStop = false;
            this.previewTemp = setTimeout(()=>{
              clearTimeout(this.previewTemp)
              this.zoomAddAndPitchAddAndRotate(currSceneItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.direction,currSceneItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  }
              )
            },currSceneItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.timeout*1000)

            break;
          }
          case "螺旋靠近":{
            this.previewAnimationFrameStop = false;
            this.previewTemp = setTimeout(()=>{
              clearTimeout(this.previewTemp)
              this.zoomAddAndPitchAddAndRotateZoomAdd(currSceneItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.direction,currSceneItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  }
              )
            },currSceneItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.timeout*1000)
            break;
          }
          case "俯冲环绕":{
            this.previewAnimationFrameStop = false;
            this.previewTemp = setTimeout(()=>{
              clearTimeout(this.previewTemp)
              this.zoomAddAndRotate(currSceneItem.pointAnimationParam.zoomAddAndRotate.direction,currSceneItem.pointAnimationParam.zoomAddAndRotate.zoomChange,currSceneItem.pointAnimationParam.zoomAddAndRotate.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  }
              )
            },currSceneItem.pointAnimationParam.zoomAddAndRotate.timeout*1000)

            break;
          }
          case "俯冲观测":{
            this.previewAnimationFrameStop = false;
            this.previewTemp = setTimeout(()=>{
              clearTimeout(this.previewTemp)
              this.zoomAddAndHovering(currSceneItem.pointAnimationParam.zoomAddAndHovering.zoomChange,currSceneItem.pointAnimationParam.zoomAddAndHovering.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  }
              )
            },currSceneItem.pointAnimationParam.zoomAddAndHovering.timeout*1000)

            break;
          }

          //多点
          case "平移跟踪":{
            this.previewTemp = setTimeout(()=>{
              let routePoints = [];
              for(let i=0;i<currSceneItem.viewPointList.length;i++){
                routePoints.push([currSceneItem.viewPointList[i].lng,currSceneItem.viewPointList[i].lat])
              }
              this.previewAnimationFrameStop = false;

              this.flyByPath(routePoints,currSceneItem.pointAnimationParam.route.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  })

            },currSceneItem.pointAnimationParam.route.timeout*1000)

            break;
          }
          case "侧向跟踪":{
            this.previewTemp = setTimeout(()=>{
              let routePoints = [];
              for(let i=0;i<currSceneItem.viewPointList.length;i++){
                routePoints.push([currSceneItem.viewPointList[i].lng,currSceneItem.viewPointList[i].lat])
              }
              this.previewAnimationFrameStop = false;

              this.flyByPathWithChangeBearing(routePoints,currSceneItem.pointAnimationParam.flyByPathWithChangeBearing.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  })
            },currSceneItem.pointAnimationParam.flyByPathWithChangeBearing.timeout*1000)


            break;
          }
          case "空中游览":{
            this.previewTemp = setTimeout(()=>{
              let routePoints = [];
              for(let i=0;i<currSceneItem.viewPointList.length;i++){
                routePoints.push([currSceneItem.viewPointList[i].lng,currSceneItem.viewPointList[i].lat])
              }
              this.previewAnimationFrameStop = false;

              this.zoomAddAndFlyByPath(routePoints,currSceneItem.pointAnimationParam.zoomAddAndFlyByPath.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  })
            },currSceneItem.pointAnimationParam.zoomAddAndFlyByPath.timeout*1000)


            break;
          }
          case "模拟驾驶":{
            this.previewTemp = setTimeout(()=>{
              let routePoints = [];
              for(let i=0;i<currSceneItem.viewPointList.length;i++){
                routePoints.push([currSceneItem.viewPointList[i].lng,currSceneItem.viewPointList[i].lat])
              }
              this.previewAnimationFrameStop = false;

              this.flyByPathWithWatchNextPoint(routePoints,currSceneItem.pointAnimationParam.flyByPathWithWatchNextPoint.duration,
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";

                    this.flyChange(i)
                  })
            },currSceneItem.pointAnimationParam.flyByPathWithWatchNextPoint.timeout*1000)


            break;
          }


          case "无效果":{
            this.previewAnimationFrameStop = false;
            this.previewTemp = setTimeout(()=>{
              clearTimeout(this.previewTemp)
              this.pointNoAnimation(
                  ()=>{
                    this.previewing = false;

                    this.sceneItemPlaying = false;
                    this.$store.state.sceneCurrPlayItem = "";
                    this.flyChange(i)
                  }
              )
            },0)
            break;
          }

        }
      }
      else{
        console.log("播放结束")
        this.quitFullScreenFun()
      }

    },
    //全屏播放 飞行效果
    flyChange(i){
      console.log("flyChange" + i)
      if(i !== this.$store.state.sceneList.length - 1){
        //转场中隐藏地球上标记
        setTimeout(()=>{
          this.playMaterialInfo = {
            materialList:[],
            materialMarkerData:this.$store.state.defaultMaterialMarkerData
          }
          this.getMaterialMarkerData(this.playMaterialInfo)
        },0)

        let currSceneItem = this.$store.state.sceneList[i];   //当前场景
        let nextSceneItem = this.$store.state.sceneList[i+1];   //下一个场景
        //根据下一个场景点位动效不同，不一定飞到下一个场景视角
        switch(this.$store.state.sceneList[i+1].pointAnimation){
          case "高空悬停":{
            //上一点位飞到当前点位的center+pitch+bearing+加大zoom
            nextSceneItem = {
              sceneCenter:nextSceneItem.sceneCenter,
              sceneZoom:nextSceneItem.sceneZoom < 16.9 ? nextSceneItem.sceneZoom + 0.1 : 17,
              sceneBearing:nextSceneItem.sceneBearing,
              scenePitch:nextSceneItem.scenePitch,
            }
            break;
          }
          case "螺旋靠近":{
            //上一点位飞到当前点位的center+pitch+bearing+减小zoom
            nextSceneItem = {
              sceneCenter:nextSceneItem.sceneCenter,
              sceneZoom:nextSceneItem.sceneZoom > 3 ? nextSceneItem.sceneZoom - 2 : 1,
              sceneBearing:nextSceneItem.sceneBearing,
              scenePitch:nextSceneItem.scenePitch,
            }
            break;
          }
          case "俯冲环绕":{
            //上一点位飞到当前点位的center+pitch=0+bearing+减小zoom
            nextSceneItem = {
              sceneCenter:nextSceneItem.sceneCenter,
              sceneZoom:nextSceneItem.sceneZoom > 3 ? nextSceneItem.sceneZoom - 2 : 1,
              sceneBearing:nextSceneItem.sceneBearing,
              scenePitch:0,
            }
            break;
          }
          case "俯冲观测":{
            //上一点位飞到当前点位的center+pitch=0+bearing+减小zoom
            nextSceneItem = {
              sceneCenter:nextSceneItem.sceneCenter,
              sceneZoom:nextSceneItem.sceneZoom > nextSceneItem.pointAnimationParam.zoomAddAndHovering.zoomChange+1 ? nextSceneItem.sceneZoom - nextSceneItem.pointAnimationParam.zoomAddAndHovering.zoomChange : 1,
              sceneBearing:nextSceneItem.sceneBearing,
              scenePitch:0,
            }
            break;
          }

          case "空中游览":{
            //上一点位飞到当前点位的center+pitch=0+bearing=0+减小zoom
            nextSceneItem = {
              sceneCenter:nextSceneItem.sceneCenter,
              sceneZoom:nextSceneItem.zoomBasis > 2 ? nextSceneItem.zoomBasis - 1 : 1,
              sceneBearing:0,
              scenePitch:0,
            }
            break;
          }
          case "侧向跟踪":{
            //上一点位飞到当前点位的center+pitch=0+bearing=0+减小zoom
            nextSceneItem = {
              sceneCenter:nextSceneItem.sceneCenter,
              sceneZoom:nextSceneItem.zoomBasis,
              sceneBearing:0,
              scenePitch:60,
            }
            break;
          }
          case "模拟驾驶":{
            //上一点位飞到当前点位的center+pitch=0+bearing=0+减小zoom
            nextSceneItem = {
              sceneCenter:nextSceneItem.sceneCenter,
              sceneZoom:nextSceneItem.zoomBasis < 16 ? nextSceneItem.zoomBasis + 1 : 17,
              sceneBearing:0,
              scenePitch:0,
            }
            break;
          }
        }

        this.previewing = true;
        this.previewingType = "fly+" + currSceneItem.flyAnimation + "+" + currSceneItem.flyAnimationParam.jumpTo.type

        switch(currSceneItem.flyAnimation){
          case "跳跃":{
            // this.flyToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
            //     nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.flyTo.duration / this.screenPlaySpeed,currSceneItem.flyAnimationParam.flyTo.minZoom,
            //     ()=>{this.previewing = false;this.pointChange(i+1)}
            // )


            // 临时njh 慢速时飞行格外慢，实现本地缓存瓦片exe的缓存
            // this.FlyToFunToMinZoom = false
            if(this.screenPlaySpeed !== 1){
              this.flyToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                  nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.flyTo.duration / this.screenPlaySpeed * 20,currSceneItem.flyAnimationParam.flyTo.minZoom,
                  ()=>{this.previewing = false;this.pointChange(i+1)}
              )
            }
            else{
              this.flyToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                  nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.flyTo.duration / this.screenPlaySpeed,currSceneItem.flyAnimationParam.flyTo.minZoom,
                  ()=>{this.previewing = false;this.pointChange(i+1)}
              )
            }
            break;
          }
          case "平移":{
            this.easeToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.easeTo.duration / this.screenPlaySpeed,
                ()=>{this.previewing = false;this.pointChange(i+1)}
            )
            break;
          }
          case "切换":{

            switch(currSceneItem.flyAnimationParam.jumpTo.type){
              case "淡出":{
                // this.pageAnimationAllScreen("blackToTransparent",currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
                //     ()=>{this.previewing = false;this.pointChange(i+1)}
                // )
                // this.jumpToSceneItem(nextSceneItem)

                this.pageAnimationOperationChnage("mapOpacityChange",currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,nextSceneItem,
                    ()=>{this.previewing = false;this.pointChange(i+1)}
                )

                break;
              }
              case "浮入":{
                this.pageAnimationAllScreen("height100To0",currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
                    ()=>{this.previewing = false;this.pointChange(i+1)}
                )
                this.jumpToSceneItem(nextSceneItem)

                break;
              }
              case "扩展":{
                this.pageAnimationAllScreenCenter("allScreenToCenter",currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
                    ()=>{this.previewing = false;this.pointChange(i+1)}
                )
                this.jumpToSceneItem(nextSceneItem)

                break;
              }
              case "百叶窗":{
                this.pageAnimationWindowClose(currSceneItem.flyAnimationParam.jumpTo.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
                    ()=>{this.previewing = false;this.pointChange(i+1)}
                )
                this.jumpToSceneItem(nextSceneItem)

                break;
              }
              case "无":{
                this.jumpToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                    nextSceneItem.scenePitch,
                    ()=>{this.previewing = false;this.pointChange(i+1)}
                )
                break;
              }

            }


            break;
          }


          //新动效
          case "旋转跳跃":{
            this.rotateAndFlyTo(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.rotateAndFlyTo.duration / this.screenPlaySpeed,
                ()=>{this.previewing = false;this.pointChange(i+1)}
            )
            break;
          }
          case "穿梭":{
            this.easeToWithSpeed(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.easeToWithSpeed.duration / this.screenPlaySpeed,
                ()=>{this.previewing = false;this.pointChange(i+1)}
            )
            break;
          }
          case "回太空":{
            this.flyToBetweenGlobal(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                nextSceneItem.scenePitch,currSceneItem.flyAnimationParam.flyToBetweenGlobal.duration / this.screenPlaySpeed,
                ()=>{this.previewing = false;this.pointChange(i+1)}
            )
            break;
          }

          case "无":{
            this.jumpToFun(nextSceneItem.sceneCenter[0],nextSceneItem.sceneCenter[1],nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
                nextSceneItem.scenePitch,
                ()=>{this.previewing = false;this.pointChange(i+1)}
            )
            break;
          }
        }

      }
      else{
        console.log("播放结束")
        this.quitFullScreenFun()
      }
    },
    //中间打断全屏播放，处理动效停止
    scenePlayStop(){

      //当前正有跳转在进行
      if(this.previewing){

        let panelType = this.previewingType.split("+")[0];
        let previewType = this.previewingType.split("+")[1];

        if(panelType === "fly"){
          switch(previewType){
            case "跳跃": case "平移": case "穿梭":{
              this.map.stop();
              break;
            }
            case "切换":{
              switch(this.previewingType.split("+")[2]){
                case "淡出":{
                  clearTimeout(this.previewTemp)
                  this.animationAllScreenMapMantleName = "";
                  this.animationAllScreenMapMantleDuration = "";
                  this.map.stop();
                  break;
                }
                case "浮入":{
                  clearTimeout(this.previewTemp)
                  this.animationAllScreenMantleShow = false;
                  this.animationAllScreenBackground = "";
                  this.animationAllScreenMantleName = "";
                  this.animationAllScreenMantleDuration = "";

                  break;
                }
                case "扩展":{
                  clearTimeout(this.previewTemp)
                  this.animationAllScreenMantleCenterShow = false;
                  this.animationAllScreenCenterBackground = "";
                  this.animationAllScreenMantleCenterName = "";
                  this.animationAllScreenMantleCenterDuration = "";

                  break;
                }
                case "百叶窗":{
                  clearTimeout(this.previewTemp)
                  this.animationWindowMantleShow = false;
                  this.animationWindowBackground = "";
                  this.animationWindowMantleDuration = "";

                  break;
                }
                case "无":{
                  clearTimeout(this.previewTemp)
                  break;
                }

              }

              break;
            }

            case "旋转跳跃":{
              this.map.stop();
              clearInterval(this.previewIntervalTemp)
              clearTimeout(this.previewTemp)
              break;
            }
            case "回太空":{
              this.map.stop();
              clearTimeout(this.previewTemp)
              break;
            }
            case "无":{
              clearTimeout(this.previewTemp)
              break;
            }

          }
        }
        else if(panelType === "point"){

          switch(previewType){
            case "螺旋凝视":{
              this.previewAnimationFrameStop = true;
              clearInterval(this.previewIntervalTemp)
              clearTimeout(this.previewTemp)
              break;
            }
            case "太空俯冲": case "侧向跟踪":{
              clearTimeout(this.previewTemp)
              this.previewAnimationFrameStop = true;
              break;
            }
            case "地球自转": case "高空悬停": case "螺旋环绕": case "螺旋靠近": case "俯冲环绕": case "俯冲观测":{
              this.previewAnimationFrameStop = true;
              clearInterval(this.previewIntervalTemp)
              clearTimeout(this.previewTemp)
              this.map.stop();
              break;
            }
            case "平移跟踪": case "空中游览":{
              clearTimeout(this.previewTemp);
              this.map.stop();
              break;
            }
            case "模拟驾驶":{
              clearTimeout(this.previewTemp);
              this.previewAnimationFrameStop = true;
              this.map.stop();
              break;
            }
          }

        }

        //跳转结束
        this.previewing = false;

      }
      else{
        //可能在初始蒙层处延时，也可能正好一段播放结束
        clearInterval(this.previewIntervalTemp)
        clearTimeout(this.previewTemp)
        this.fullScreenPlayBeginMantle = false;
      }

    },

    //按下esc退出全屏播放
    escQuitFullScreen(e){
      if (e.keyCode === 27) {
        e.stopPropagation();

        //esc退出播放，打断了跳转动画，需要处理方法
        this.scenePlayStop()

        this.quitFullScreenFun()

      }

    },
    //退出全屏的方法
    quitFullScreenFun(){
      document.removeEventListener('keyup', this.escQuitFullScreen);

      this.$store.state.globeSceneFullScreen = false;
      setTimeout(()=>{
        this.map.resize()
      },0)

      //显示比例尺
      document.querySelector('.mapboxgl-ctrl-scale').style.visibility = 'visible'

      //播放速度恢复为1
      this.screenPlaySpeed = 1;


      console.log("退出播放")
      this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化
      this.playing = false;
      this.sceneItemPlaying = false;
      this.$store.state.sceneCurrPlayItem = "";

      //启用mapbox的鼠标交互
      this.map.boxZoom.enable();
      this.map.scrollZoom.enable();
      this.map.dragPan.enable();
      this.map.dragRotate.enable();
      this.map.doubleClickZoom.enable();
      this.map.touchZoomRotate.enable();

      //隐藏常显素材地图数据
      this.$store.state.sceneMaterialShow_allShow = false;
      this.clearMaterialMarkerLayer_allShow()

      //显示地图icon
      setTimeout(()=>{
        if(this.$store.state.currChooseSceneItemIndex !== ""){
          //获取素材
          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);

          setTimeout(()=>{
            this.$store.state.sceneMaterialShow = true;
          },0)

          this.$store.state.sceneViewMarkerShow = true;
          this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
        }
        else{
          this.getMaterialMarkerData({
            materialList:[],
            materialMarkerData:this.$store.state.defaultMaterialMarkerData
          });

        }

      },0)




    },


    //各种切换方法

    //跳转：经度，纬度，层级，bearing正北为0，pitch旋转角0-85之间，持续时间毫秒
    flyToFun(lng,lat,zoom,bearing,pitch,duration,minZoom,finishFun){
      // let _this = this
      this.map.flyTo({
        center:[lng,lat],
        zoom:zoom,
        bearing:bearing,
        pitch:pitch,
        curve:1,
        duration: duration * 1000,
        minZoom:minZoom,
        easing(t) {
          if(t === 1){
            if(finishFun !== undefined){
              setTimeout(()=>{
                finishFun()
              },0)
            }
          }
          return t
          // //临时njh，实现前一半动画减速，后一半动画加速
          // if(_this.map.getZoom() === minZoom){
          //   //已经达到flyTo最小zoom，达到前是上升过程，达到后是下降过程
          //   _this.FlyToFunToMinZoom = true
          // }
          //
          // let returnResult = ""
          // if(!_this.FlyToFunToMinZoom){
          //   // console.log("上升")
          //   // flyTo上升过程
          //   returnResult = t * t * t;
          // }
          // else{
          //   // flyTo下降过程
          //   // console.log("下降")
          //   returnResult = t < 0.5 ?
          //       Math.pow(t, 6) * 64 :
          //       0.8 + 0.2 * (1 - Math.pow(2 - 2*t, 6));
          // }
          //
          // return returnResult

        }
      })
    },
    //平移：经度，纬度，层级，bearing正北为0，pitch旋转角0-85之间，持续时间毫秒
    easeToFun(lng,lat,zoom,bearing,pitch,duration,finishFun){
      this.map.easeTo({
        center:[lng,lat],
        zoom:zoom,
        bearing:bearing,
        pitch:pitch,
        curve:1,
        duration: duration * 1000,
        easing(t) {
          if(t === 1){
            if(finishFun !== undefined){
              setTimeout(()=>{
                finishFun()
              },0)

            }
          }
          return t
        }
      })
    },
    //无效果
    jumpToFun(lng,lat,zoom,bearing,pitch,finishFun){
      this.map.jumpTo({
        center:[lng,lat],
        zoom:zoom,
        bearing:bearing,
        pitch:pitch,
      });
      if(finishFun !== undefined){
        clearTimeout(this.previewTemp)
        this.previewTemp = setTimeout(()=>{
          finishFun()
        },0)
      }
    },
    //切换
    //使用全屏蒙层的动画：淡出 blackToTransparent，浮出 height100To0
    pageAnimationAllScreen(animationName,duration,animationBackground,finishFun){
      this.animationAllScreenBackground = animationBackground;
      this.animationAllScreenMantleName = animationName;
      this.animationAllScreenMantleDuration = duration + 's';
      this.animationAllScreenMantleShow = true;

      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        this.animationAllScreenMantleShow = false;
        this.animationAllScreenBackground = "";
        this.animationAllScreenMantleName = "";
        this.animationAllScreenMantleDuration = "";
        if(finishFun !== undefined){
          clearTimeout(this.previewTemp)
          this.previewTemp = setTimeout(()=>{
            finishFun()
          },0)
        }
      },duration * 1000)

    },
    //居中全屏蒙层，缩小至中心 allScreenToCenter
    pageAnimationAllScreenCenter(animationName,duration,animationBackground,finishFun){
      this.animationAllScreenCenterBackground = animationBackground;
      this.animationAllScreenMantleCenterName = animationName;
      this.animationAllScreenMantleCenterDuration = duration + 's';
      this.animationAllScreenMantleCenterShow = true;

      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        this.animationAllScreenMantleCenterShow = false;
        this.animationAllScreenCenterBackground = "";
        this.animationAllScreenMantleCenterName = "";
        this.animationAllScreenMantleCenterDuration = "";
        if(finishFun !== undefined){
          clearTimeout(this.previewTemp)
          this.previewTemp = setTimeout(()=>{
            finishFun()
          },0)
        }
      },duration * 1000)

    },
    //百叶窗
    pageAnimationWindowClose(duration,animationBackground,finishFun){
      this.animationWindowBackground = animationBackground;
      this.animationWindowMantleDuration = duration + 's';
      this.animationWindowMantleShow = true;
      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        this.animationWindowMantleShow = false;
        this.animationWindowBackground = "";
        this.animationWindowMantleDuration = "";
        if(finishFun !== undefined){
          clearTimeout(this.previewTemp)
          this.previewTemp = setTimeout(()=>{
            finishFun()
          },0)
        }
      },duration * 1000)
    },
    //淡出-透明度版本
    pageAnimationOperationChnage(animationName,duration,nextSceneItem,finishFun){
      console.log(nextSceneItem)

      this.animationAllScreenMapMantleName = animationName;
      this.animationAllScreenMapMantleDuration = duration + 's';

      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        this.animationAllScreenMapMantleName = "";
        this.animationAllScreenMapMantleDuration = "";
        if(finishFun !== undefined){
          clearTimeout(this.previewTemp)
          this.previewTemp = setTimeout(()=>{
            finishFun()
          },0)
        }
      },duration * 1000)


      this.map.flyTo({
        center:nextSceneItem.sceneCenter,
        zoom:nextSceneItem.sceneZoom,
        bearing:nextSceneItem.sceneBearing,
        pitch:nextSceneItem.scenePitch,
        curve:1,
        duration: duration * 1000,
      })
    },

    //旋转跳跃：经度，纬度，层级，bearing正北为0，pitch旋转角0-85之间，持续时间毫秒
    //先减小zoom并不断改变bearing(旋转)，然后再执行当前跳跃
    rotateAndFlyTo(lng,lat,zoom,bearing,pitch,duration,finishFun){
      //确定环绕结束的时间
      let rotateFinish = false;

      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        rotateFinish = true
      },duration * 1000 * 0.6)   //60%的时间用于旋转

      //开始旋转
      clearInterval(this.previewIntervalTemp)
      this.previewIntervalTemp = setInterval(()=>{
        if(rotateFinish){
          //环绕结束，开始flyTo
          clearInterval(this.previewIntervalTemp)

          this.map.flyTo({
            center:[lng,lat],
            zoom:zoom,
            bearing:bearing,
            pitch:pitch,
            curve:1,
            duration: duration * 1000 * 0.4,   //40%的时间用于flyTo
            easing(t) {
              if(t === 1){
                if(finishFun !== undefined){
                  setTimeout(()=>{
                    finishFun()
                  },0)
                }
              }
              return t
            }
          })
        }
        else{
          //环绕效果
          let bearing = this.map.getBearing() + 1.5;
          this.map.rotateTo(bearing, {duration: 0})
          this.map.jumpTo({
            bearing:bearing,
            zoom:this.map.getZoom()-0.01,
          })
        }
      },0)

    },
    //穿梭：经度，纬度，层级，bearing正北为0，pitch旋转角0-85之间，持续时间毫秒
    //相比正常的easeTo增加速度变化，慢快慢
    easeToWithSpeed(lng,lat,zoom,bearing,pitch,duration,finishFun){
      this.map.easeTo({
        center:[lng,lat],
        zoom:zoom,
        bearing:bearing,
        pitch:pitch,
        curve:1,
        duration: duration * 1000,
        easing(t) {
          if(t === 1){
            if(finishFun !== undefined){
              setTimeout(()=>{
                finishFun()
              },0)

            }
          }
          return Math.sin(t * Math.PI / 2)
        }
      })
    },
    //回太空：经度，纬度，层级，bearing正北为0，pitch旋转角0-85之间，持续时间毫秒
    //先flyTo地球初始位置，再flyTo下一点位
    flyToBetweenGlobal(lng,lat,zoom,bearing,pitch,duration,finishFun){

      //回初始状态
      this.map.flyTo({
        center:this.initCenter,
        zoom:this.initZoom,
        bearing:0,
        pitch:0,
        curve:1,
        duration: (duration * 1000 - 100) / 2,
        easing(t) {
          return t
        }
      })

      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        //飞到下一点位
        this.map.flyTo({
          center:[lng,lat],
          zoom:zoom,
          bearing:bearing,
          pitch:pitch,
          curve:1,
          duration: (duration * 1000 - 100) / 2,
          easing(t) {
            if(t === 1){
              if(finishFun !== undefined){
                setTimeout(()=>{
                  finishFun()
                },0)
              }
            }
            return t
          }
        })
      },duration * 1000 / 2 + 100)   //时间过半时开始飞到下一点位



    },



    //各种点位动效

    //点位 螺旋凝视，以定义速度和定义时间持续旋转
    //speed:每次改变的角度值，direction:0逆时针1顺时针
    rotateToByDuration(speed,direction,duration,finishFun){
      let finish = false;

      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        finish = true
      },duration*1000)

      clearInterval(this.previewIntervalTemp)
      this.previewIntervalTemp = setInterval(()=>{
        if(finish){
          //结束
          clearInterval(this.previewIntervalTemp)
          if(finishFun !== undefined){
            clearTimeout(this.previewTemp)
            this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }
        else{
          let bearing = this.map.getBearing();
          if(direction === 0){
            bearing = bearing + 5 * speed
          }
          else{
            bearing = bearing - 5 * speed
          }
          this.map.rotateTo(bearing, {duration: 0})
        }

      },0)



      // let times = duration * 1000;
      // console.log(times)
      // let n = 0;
      // clearInterval(this.previewIntervalTemp)
      // this.previewIntervalTemp = setInterval(()=>{
      //   let bearing
      //   if(direction === 0){
      //     bearing = n * speed
      //   }
      //   else{
      //     bearing = -n * speed
      //   }
      //   this.map.rotateTo(bearing, {duration: 0})
      //   n = n + 7;
      //   console.log(n)
      //   if(n >= times){
      //     clearInterval(this.previewIntervalTemp)
      //     if(finishFun !== undefined){
      //       clearTimeout(this.previewTemp)
      //       this.previewTemp = setTimeout(()=>{
      //         finishFun()
      //       },0)
      //     }
      //   }
      // },0)
    },
    //点位：调整3D视角
    //pitch正北为0-85，持续时间毫秒
    setPitchFun(pitch,duration,finishFun){
      this.easeToFun(this.map.getCenter().lng,this.map.getCenter().lat,this.map.getZoom(),this.map.getBearing(),pitch,duration)
      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        if(finishFun !== undefined){
          clearTimeout(this.previewTemp)
          this.previewTemp = setTimeout(()=>{
            finishFun()
          },0)
        }
      },duration * 1000)
    },
    //点位：平移跟踪（其他效果也调用此方法）（实现延路线飞行,duration持续时间）
    flyByPath(routePoints,duration,finishFun){
      const routeDistance = turf.lineDistance(turf.lineString(routePoints));   //总路线长度
      const pointsDistance = [];    //各点之间的长度
      const pointsEaseToDuration = [];    //各点之间平移的时长
      for(let i=1;i<routePoints.length;i++){
        let currPointDistance = turf.lineDistance(turf.lineString([routePoints[i-1],routePoints[i]]))
        pointsDistance.push(currPointDistance)
        pointsEaseToDuration.push(currPointDistance / routeDistance * duration * 1000)
      }

      let easeToWithTwoPointI = 0;
      this.easeToWithTwoPoint(routePoints[easeToWithTwoPointI+1],pointsEaseToDuration[easeToWithTwoPointI],easeToWithTwoPointFinishFun_flyByPath)

      let _this = this
      function easeToWithTwoPointFinishFun_flyByPath(){
        easeToWithTwoPointI ++;
        if(easeToWithTwoPointI===routePoints.length-1){
          //全部点位执行结束
          console.log("结束")
          if(finishFun !== undefined){
            clearTimeout(_this.previewTemp)
            _this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }
        else{
          _this.easeToWithTwoPoint(routePoints[easeToWithTwoPointI+1],pointsEaseToDuration[easeToWithTwoPointI],easeToWithTwoPointFinishFun_flyByPath)
        }
      }

      //旧版沿路线移动实现思路，会导致在有dem的区域上下抖动
      // const pointsDistance = [0];    //各点到起点的长度
      // for(let i=1;i<routePoints.length;i++){
      //   let currRoute = routePoints.slice(0,i+1);
      //   pointsDistance.push(turf.lineDistance(turf.lineString(currRoute)))
      // }
      // console.log(pointsDistance)
      // let start;
      //
      // let _this = this
      // function frame(time) {
      //   if (!start) start = time;
      //
      //   const phase = (time - start) / (duration * 1000);
      //
      //   const alongRoute = turf.along(
      //       turf.lineString(routePoints),
      //       routeDistance * phase
      //   ).geometry.coordinates;
      //
      //   _this.map.jumpTo({
      //     center:alongRoute
      //   })
      //
      //   if(!_this.previewAnimationFrameStop && phase <= 1){
      //     //继续预览，且进度没到1时，重复过程
      //     window.requestAnimationFrame(frame);
      //   }
      //   else if(!_this.previewAnimationFrameStop){
      //     // console.log("飞行结束")
      //     if(finishFun !== undefined){
      //       clearTimeout(_this.previewTemp)
      //       _this.previewTemp = setTimeout(()=>{
      //         finishFun()
      //       },0)
      //     }
      //   }
      //
      // }
      //
      // window.requestAnimationFrame(frame);

    },
    //用于路线效果中 两个点之间的移动，从当前点移动到nextPoint，耗时duration
    easeToWithTwoPoint(nextPoint,duration,finishFun){
      this.map.easeTo({
        center:nextPoint,
        curve:1,
        duration: duration,
        easing(t) {
          if(t === 1){
            if(finishFun !== undefined){
              setTimeout(()=>{
                finishFun()
              },0)
            }
          }
          return t
        }
      })
    },


    //点位：太空俯冲（pitch先变小后变大）
    flyToSlide(finishZoom,duration,finishFun){
      const animationDuration = duration * 1000;    //总持续时间

      let start;
      let _this = this

      function frame(time) {
        if (!start) start = time;
        const phase = (time - start) / animationDuration;   //进度 0-1

        //每次循环根据进度 进行视角处理
        if(phase <= 0.5){
          _this.map.jumpTo({
            pitch:80 - 140*phase,
            zoom:2+12*phase
          })
        }
        else{
          _this.map.jumpTo({
            pitch:10 + 140*(phase-0.5),
            zoom:2+12*phase
          })
        }

        if(!_this.previewAnimationFrameStop && phase <= 1){
          //进度没到1时，重复过程
          window.requestAnimationFrame(frame);
        }
        else if(!_this.previewAnimationFrameStop){
          // console.log("飞行结束")
          if(finishFun !== undefined){
            clearTimeout(_this.previewTemp)
            _this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }

      }

      window.requestAnimationFrame(frame);

    },
    //点位：无效果
    pointNoAnimation(finishFun){
      if(finishFun !== undefined){
        clearTimeout(this.previewTemp)
        this.previewTemp = setTimeout(()=>{
          finishFun()
        },0)
      }
    },



    //点位动效测试：根据视角数组生成动效
    createAnimationFromArray(duration,finishFun){

      //前端延时循环实现
      let lngList = [
            125.407263,
            125.40726324673503,
            125.40726398687926,
            125.40726522025007,
            125.40726694654315,
            125.40726916533254,
            125.4072718760708,
            125.40727507808909,
            125.40727877059737,
            125.40728295268457,
            125.40728762331881,
            125.40729278134769,
            125.40729842549854,
            125.40730455437875,
            125.40731116647612,
            125.4073182601592,
            125.40732583367773,
            125.40733388516308,
            125.40734241262864,
            125.4073514139704,
            125.40736088696741,
            125.40737082928234,
            125.4073812384621,
            125.40739211193834,
            125.40740344702822,
            125.40741524093497,
            125.40742749074863,
            125.40744019344673,
            125.40745334589506,
            125.40746694484848,
            125.40748098695163,
            125.40749546873982,
            125.40751038663991,
            125.40752573697112,
            125.407541515946,
            125.40755771967129,
            125.407574344149,
            125.40759138527726,
            125.40760883885144,
            125.40762670056515,
            125.40764496601125,
            125.40766363068302,
            125.40768268997525,
            125.40770213918532,
            125.40772197351444,
            125.4077421880688,
            125.40776277786074,
            125.40778373781004,
            125.40780506274515,
            125.40782674740447,
            125.40784878643763,
            125.40787117440681,
            125.40789390578814,
            125.40791697497298,
            125.40794037626935,
            125.40796410390334,
            125.4079881520205,
            125.40801251468733,
            125.4080371858927,
            125.40806215954935,
            125.40808742949541,
            125.4081129894959,
            125.4081388332443,
            125.408164954364,
            125.40819134641004,
            125.40821800287057,
            125.40824491716849,
            125.40827208266313,
            125.40829949265179,
            125.40832714037147,
            125.40835501900051,
            125.40838312166028,
            125.40841144141686,
            125.40843997128279,
            125.40846870421872,
            125.40849763313527,
            125.40852675089462,
            125.40855605031244,
            125.4085855241595,
            125.4086151651636,
            125.40864496601125,
            125.40867491934954,
            125.40870501778792,
            125.40873525390006,
            125.40876562022567,
            125.40879610927229,
            125.4088267135172,
            125.40885742540928,
            125.40888823737082,
            125.40891914179943,
            125.40895013106991,
            125.40898119753612,
            125.40901233353287,
            125.40904353137782,
            125.40907478337336,
            125.40910608180855,
            125.40913741896094,
            125.40916878709858,
            125.40920017848184,
            125.40923158536538,
            125.409263,
            125.40929441463462,
            125.40932582151815,
            125.40935721290141,
            125.40938858103905,
            125.40941991819145,
            125.40945121662664,
            125.40948246862217,
            125.40951366646712,
            125.40954480246387,
            125.40957586893008,
            125.40960685820056,
            125.40963776262917,
            125.40966857459071,
            125.40969928648279,
            125.4097298907277,
            125.40976037977433,
            125.40979074609993,
            125.40982098221207,
            125.40985108065045,
            125.40988103398874,
            125.4099108348364,
            125.40994047584049,
            125.40996994968755,
            125.40999924910537,
            125.41002836686472,
            125.41005729578127,
            125.4100860287172,
            125.41011455858313,
            125.41014287833971,
            125.41017098099948,
            125.41019885962852,
            125.4102265073482,
            125.41025391733686,
            125.4102810828315,
            125.41030799712942,
            125.41033465358996,
            125.410361045636,
            125.4103871667557,
            125.41041301050409,
            125.41043857050458,
            125.41046384045065,
            125.4104888141073,
            125.41051348531266,
            125.4105378479795,
            125.41056189609665,
            125.41058562373064,
            125.41060902502701,
            125.41063209421185,
            125.41065482559318,
            125.41067721356237,
            125.41069925259552,
            125.41072093725484,
            125.41074226218996,
            125.41076322213925,
            125.4107838119312,
            125.41080402648555,
            125.41082386081467,
            125.41084331002475,
            125.41086236931697,
            125.41088103398874,
            125.41089929943485,
            125.41091716114855,
            125.41093461472273,
            125.410951655851,
            125.4109682803287,
            125.410984484054,
            125.41100026302887,
            125.41101561336008,
            125.41103053126017,
            125.41104501304837,
            125.41105905515151,
            125.41107265410493,
            125.41108580655326,
            125.41109850925136,
            125.41111075906502,
            125.41112255297178,
            125.41113388806166,
            125.4111447615379,
            125.41115517071765,
            125.41116511303258,
            125.41117458602959,
            125.41118358737135,
            125.41119211483691,
            125.41120016632226,
            125.41120773984079,
            125.41121483352387,
            125.41122144562124,
            125.41122757450145,
            125.4112332186523,
            125.41123837668118,
            125.41124304731542,
            125.41124722940262,
            125.4112509219109,
            125.4112541239292,
            125.41125683466745,
            125.41125905345685,
            125.41126077974992,
            125.41126201312073,
            125.41126275326496,
            125.41126299999999,
            125.41126275326496,
            125.41126201312073,
            125.41126077974992,
            125.41125905345685,
            125.41125683466745,
            125.4112541239292,
            125.4112509219109,
            125.41124722940262,
            125.41124304731542,
            125.41123837668118,
            125.4112332186523,
            125.41122757450145,
            125.41122144562124,
            125.41121483352387,
            125.41120773984079,
            125.41120016632226,
            125.41119211483691,
            125.41118358737135,
            125.41117458602959,
            125.41116511303258,
            125.41115517071765,
            125.4111447615379,
            125.41113388806166,
            125.41112255297178,
            125.41111075906502,
            125.41109850925136,
            125.41108580655326,
            125.41107265410493,
            125.41105905515151,
            125.41104501304837,
            125.41103053126017,
            125.41101561336008,
            125.41100026302887,
            125.410984484054,
            125.4109682803287,
            125.410951655851,
            125.41093461472273,
            125.41091716114855,
            125.41089929943485,
            125.41088103398874,
            125.41086236931697,
            125.41084331002475,
            125.41082386081467,
            125.41080402648555,
            125.4107838119312,
            125.41076322213925,
            125.41074226218996,
            125.41072093725484,
            125.41069925259552,
            125.41067721356237,
            125.41065482559318,
            125.41063209421185,
            125.41060902502701,
            125.41058562373064,
            125.41056189609665,
            125.4105378479795,
            125.41051348531266,
            125.4104888141073,
            125.41046384045065,
            125.41043857050458,
            125.41041301050409,
            125.4103871667557,
            125.410361045636,
            125.41033465358996,
            125.41030799712942,
            125.4102810828315,
            125.41025391733686,
            125.4102265073482,
            125.41019885962852,
            125.41017098099948,
            125.41014287833971,
            125.41011455858313,
            125.4100860287172,
            125.41005729578127,
            125.41002836686472,
            125.40999924910537,
            125.40996994968755,
            125.40994047584049,
            125.4099108348364,
            125.40988103398874,
            125.40985108065045,
            125.40982098221207,
            125.40979074609993,
            125.40976037977433,
            125.4097298907277,
            125.40969928648279,
            125.40966857459071,
            125.40963776262917,
            125.40960685820056,
            125.40957586893008,
            125.40954480246387,
            125.40951366646712,
            125.40948246862217,
            125.40945121662664,
            125.40941991819145,
            125.40938858103905,
            125.40935721290141,
            125.40932582151815,
            125.40929441463462,
            125.409263,
            125.40923158536538,
            125.40920017848184,
            125.40916878709858,
            125.40913741896094,
            125.40910608180855,
            125.40907478337336,
            125.40904353137782,
            125.40901233353287,
            125.40898119753612,
            125.40895013106991,
            125.40891914179943,
            125.40888823737082,
            125.40885742540928,
            125.4088267135172,
            125.40879610927229,
            125.40876562022567,
            125.40873525390006,
            125.40870501778792,
            125.40867491934954,
            125.40864496601125,
            125.4086151651636,
            125.4085855241595,
            125.40855605031244,
            125.40852675089462,
            125.40849763313527,
            125.40846870421872,
            125.40843997128279,
            125.40841144141686,
            125.40838312166028,
            125.40835501900051,
            125.40832714037147,
            125.40829949265179,
            125.40827208266313,
            125.40824491716849,
            125.40821800287057,
            125.40819134641004,
            125.408164954364,
            125.4081388332443,
            125.4081129894959,
            125.40808742949541,
            125.40806215954935,
            125.4080371858927,
            125.40801251468733,
            125.4079881520205,
            125.40796410390334,
            125.40794037626935,
            125.40791697497298,
            125.40789390578814,
            125.40787117440681,
            125.40784878643763,
            125.40782674740447,
            125.40780506274515,
            125.40778373781004,
            125.40776277786074,
            125.4077421880688,
            125.40772197351444,
            125.40770213918532,
            125.40768268997525,
            125.40766363068302,
            125.40764496601125,
            125.40762670056515,
            125.40760883885144,
            125.40759138527726,
            125.407574344149,
            125.40755771967129,
            125.407541515946,
            125.40752573697112,
            125.40751038663991,
            125.40749546873982,
            125.40748098695163,
            125.40746694484848,
            125.40745334589506,
            125.40744019344673,
            125.40742749074863,
            125.40741524093497,
            125.40740344702822,
            125.40739211193834,
            125.4073812384621,
            125.40737082928234,
            125.40736088696741,
            125.4073514139704,
            125.40734241262864,
            125.40733388516308,
            125.40732583367773,
            125.4073182601592,
            125.40731116647612,
            125.40730455437875,
            125.40729842549854,
            125.40729278134769,
            125.40728762331881,
            125.40728295268457,
            125.40727877059737,
            125.40727507808909,
            125.4072718760708,
            125.40726916533254,
            125.40726694654315,
            125.40726522025007,
            125.40726398687926,
            125.40726324673503,
            125.407263
          ]

      let latList = [
        43.97404,
        43.97407141463463,
        43.97410282151816,
        43.97413421290142,
        43.97416558103906,
        43.97419691819146,
        43.97422821662664,
        43.974259468622186,
        43.974290666467134,
        43.97432180246388,
        43.97435286893008,
        43.97438385820056,
        43.97441476262917,
        43.97444557459072,
        43.9744762864828,
        43.97450689072772,
        43.97453737977433,
        43.974567746099936,
        43.97459798221208,
        43.97462808065047,
        43.97465803398875,
        43.974687834836395,
        43.97471747584049,
        43.974746949687564,
        43.974776249105375,
        43.974805366864736,
        43.97483429578127,
        43.97486302871721,
        43.97489155858313,
        43.97491987833971,
        43.97494798099948,
        43.97497585962852,
        43.975003507348205,
        43.975030917336866,
        43.9750580828315,
        43.975084997129436,
        43.97511165358996,
        43.975138045636,
        43.975164166755704,
        43.975190010504086,
        43.97521557050459,
        43.97524084045065,
        43.97526581410731,
        43.97529048531268,
        43.9753148479795,
        43.975338896096666,
        43.975362623730646,
        43.97538602502702,
        43.97540909421186,
        43.97543182559318,
        43.97545421356237,
        43.97547625259553,
        43.97549793725484,
        43.97551926218996,
        43.975540222139266,
        43.9755608119312,
        43.97558102648556,
        43.97560086081468,
        43.97562031002475,
        43.97563936931698,
        43.97565803398875,
        43.97567629943485,
        43.97569416114855,
        43.97571161472274,
        43.97572865585101,
        43.97574528032871,
        43.97576148405401,
        43.97577726302888,
        43.97579261336009,
        43.97580753126018,
        43.97582201304838,
        43.975836055151525,
        43.975849654104934,
        43.97586280655327,
        43.97587550925137,
        43.975887759065024,
        43.97589955297178,
        43.97591088806166,
        43.97592176153791,
        43.975932170717655,
        43.975942113032595,
        43.9759515860296,
        43.975960587371354,
        43.975969114836914,
        43.97597716632226,
        43.9759847398408,
        43.97599183352388,
        43.975998445621244,
        43.97600457450146,
        43.97601021865231,
        43.97601537668119,
        43.97602004731544,
        43.97602422940263,
        43.97602792191091,
        43.97603112392921,
        43.97603383466747,
        43.97603605345686,
        43.97603777974992,
        43.97603901312073,
        43.97603975326496,
        43.976040000000005,
        43.97603975326496,
        43.97603901312073,
        43.97603777974992,
        43.97603605345686,
        43.97603383466747,
        43.97603112392921,
        43.97602792191091,
        43.97602422940263,
        43.97602004731544,
        43.97601537668119,
        43.97601021865231,
        43.97600457450146,
        43.975998445621244,
        43.97599183352388,
        43.9759847398408,
        43.97597716632226,
        43.975969114836914,
        43.975960587371354,
        43.9759515860296,
        43.975942113032595,
        43.975932170717655,
        43.97592176153791,
        43.97591088806166,
        43.97589955297178,
        43.975887759065024,
        43.97587550925137,
        43.97586280655327,
        43.975849654104934,
        43.975836055151525,
        43.97582201304838,
        43.97580753126018,
        43.97579261336009,
        43.97577726302888,
        43.97576148405401,
        43.97574528032871,
        43.97572865585101,
        43.97571161472274,
        43.97569416114855,
        43.97567629943485,
        43.97565803398875,
        43.97563936931698,
        43.97562031002475,
        43.97560086081468,
        43.97558102648556,
        43.9755608119312,
        43.975540222139266,
        43.97551926218996,
        43.97549793725484,
        43.97547625259553,
        43.97545421356237,
        43.97543182559318,
        43.97540909421186,
        43.97538602502702,
        43.975362623730646,
        43.975338896096666,
        43.9753148479795,
        43.97529048531268,
        43.97526581410731,
        43.97524084045065,
        43.97521557050459,
        43.975190010504086,
        43.975164166755704,
        43.975138045636,
        43.97511165358996,
        43.975084997129436,
        43.9750580828315,
        43.975030917336866,
        43.975003507348205,
        43.97497585962852,
        43.97494798099948,
        43.97491987833971,
        43.97489155858313,
        43.97486302871721,
        43.97483429578127,
        43.974805366864736,
        43.974776249105375,
        43.974746949687564,
        43.97471747584049,
        43.974687834836395,
        43.97465803398875,
        43.97462808065047,
        43.97459798221208,
        43.974567746099936,
        43.97453737977433,
        43.97450689072772,
        43.9744762864828,
        43.97444557459072,
        43.97441476262917,
        43.97438385820056,
        43.97435286893008,
        43.97432180246388,
        43.974290666467134,
        43.974259468622186,
        43.97422821662664,
        43.97419691819146,
        43.97416558103906,
        43.97413421290142,
        43.97410282151816,
        43.97407141463463,
        43.97404,
        43.974008585365375,
        43.973977178481846,
        43.973945787098586,
        43.973914418960945,
        43.973883081808545,
        43.97385178337336,
        43.97382053137782,
        43.97378933353287,
        43.97375819753613,
        43.97372713106992,
        43.973696141799444,
        43.97366523737083,
        43.97363442540929,
        43.97360371351721,
        43.97357310927229,
        43.97354262022567,
        43.97351225390007,
        43.97348201778792,
        43.973451919349536,
        43.97342196601125,
        43.97339216516361,
        43.97336252415951,
        43.97333305031244,
        43.97330375089463,
        43.97327463313527,
        43.97324570421873,
        43.973216971282795,
        43.97318844141687,
        43.97316012166029,
        43.97313201900052,
        43.97310414037148,
        43.9730764926518,
        43.97304908266314,
        43.9730219171685,
        43.97299500287057,
        43.97296834641004,
        43.972941954364,
        43.9729158332443,
        43.97288998949592,
        43.97286442949542,
        43.97283915954935,
        43.972814185892695,
        43.97278951468733,
        43.97276515202051,
        43.97274110390334,
        43.97271737626936,
        43.972693974972984,
        43.97267090578814,
        43.97264817440682,
        43.97262578643763,
        43.97260374740448,
        43.97258206274516,
        43.97256073781004,
        43.97253977786074,
        43.9725191880688,
        43.97249897351445,
        43.972479139185324,
        43.97245968997525,
        43.972440630683025,
        43.972421966011254,
        43.97240370056515,
        43.97238583885145,
        43.972368385277264,
        43.972351344149,
        43.972334719671295,
        43.97231851594599,
        43.97230273697112,
        43.97228738663991,
        43.972272468739824,
        43.972257986951625,
        43.97224394484848,
        43.97223034589507,
        43.97221719344673,
        43.97220449074864,
        43.97219224093498,
        43.97218044702822,
        43.97216911193834,
        43.97215823846209,
        43.97214782928235,
        43.97213788696741,
        43.9721284139704,
        43.97211941262865,
        43.97211088516309,
        43.972102833677745,
        43.97209526015921,
        43.97208816647613,
        43.97208155437876,
        43.972075425498545,
        43.97206978134769,
        43.972064623318815,
        43.97205995268457,
        43.97205577059737,
        43.97205207808909,
        43.972048876070794,
        43.972046165332536,
        43.972043946543145,
        43.97204222025008,
        43.97204098687927,
        43.97204024673504,
        43.97204,
        43.97204024673504,
        43.97204098687927,
        43.97204222025008,
        43.972043946543145,
        43.972046165332536,
        43.972048876070794,
        43.97205207808909,
        43.97205577059737,
        43.97205995268457,
        43.972064623318815,
        43.97206978134769,
        43.972075425498545,
        43.97208155437876,
        43.97208816647613,
        43.97209526015921,
        43.972102833677745,
        43.97211088516309,
        43.97211941262865,
        43.9721284139704,
        43.97213788696741,
        43.97214782928235,
        43.97215823846209,
        43.97216911193834,
        43.97218044702822,
        43.97219224093498,
        43.97220449074864,
        43.97221719344673,
        43.97223034589507,
        43.97224394484848,
        43.972257986951625,
        43.972272468739824,
        43.97228738663991,
        43.97230273697112,
        43.97231851594599,
        43.972334719671295,
        43.972351344149,
        43.972368385277264,
        43.97238583885145,
        43.97240370056515,
        43.972421966011254,
        43.972440630683025,
        43.97245968997525,
        43.972479139185324,
        43.97249897351445,
        43.9725191880688,
        43.97253977786074,
        43.97256073781004,
        43.97258206274516,
        43.97260374740448,
        43.97262578643763,
        43.97264817440682,
        43.97267090578814,
        43.972693974972984,
        43.97271737626936,
        43.97274110390334,
        43.97276515202051,
        43.97278951468733,
        43.972814185892695,
        43.97283915954935,
        43.97286442949542,
        43.97288998949592,
        43.9729158332443,
        43.972941954364,
        43.97296834641004,
        43.97299500287057,
        43.9730219171685,
        43.97304908266314,
        43.9730764926518,
        43.97310414037148,
        43.97313201900052,
        43.97316012166029,
        43.97318844141687,
        43.973216971282795,
        43.97324570421873,
        43.97327463313527,
        43.97330375089463,
        43.97333305031244,
        43.97336252415951,
        43.97339216516361,
        43.97342196601125,
        43.973451919349536,
        43.97348201778792,
        43.97351225390007,
        43.97354262022567,
        43.97357310927229,
        43.97360371351721,
        43.97363442540929,
        43.97366523737083,
        43.973696141799444,
        43.97372713106992,
        43.97375819753613,
        43.97378933353287,
        43.97382053137782,
        43.97385178337336,
        43.973883081808545,
        43.973914418960945,
        43.973945787098586,
        43.973977178481846,
        43.974008585365375,
        43.97404
      ]

      let bearingList = [
        90,
        90.9,
        91.8,
        92.7,
        93.6,
        94.5,
        95.4,
        96.3,
        97.2,
        98.1,
        99,
        99.9,
        100.8,
        101.7,
        102.6,
        103.5,
        104.4,
        105.3,
        106.2,
        107.1,
        108,
        108.9,
        109.8,
        110.7,
        111.6,
        112.5,
        113.4,
        114.3,
        115.2,
        116.1,
        117,
        117.9,
        118.8,
        119.7,
        120.6,
        121.5,
        122.4,
        123.3,
        124.2,
        125.1,
        126,
        126.9,
        127.8,
        128.7,
        129.6,
        130.5,
        131.4,
        132.3,
        133.2,
        134.1,
        135,
        135.9,
        136.8,
        137.7,
        138.6,
        139.5,
        140.4,
        141.3,
        142.2,
        143.1,
        144,
        144.9,
        145.8,
        146.7,
        147.6,
        148.5,
        149.4,
        150.3,
        151.2,
        152.1,
        153,
        153.9,
        154.8,
        155.7,
        156.6,
        157.5,
        158.4,
        159.3,
        160.2,
        161.10000000000002,
        162,
        162.9,
        163.8,
        164.7,
        165.6,
        166.5,
        167.4,
        168.3,
        169.2,
        170.1,
        171,
        171.9,
        172.8,
        173.7,
        174.6,
        175.5,
        176.39999999999998,
        177.3,
        178.2,
        179.1,
        180,
        180.9,
        181.8,
        182.7,
        183.60000000000002,
        184.5,
        185.4,
        186.3,
        187.2,
        188.10000000000002,
        189,
        189.9,
        190.8,
        191.7,
        192.6,
        193.5,
        194.39999999999998,
        195.3,
        196.2,
        197.1,
        198,
        198.89999999999998,
        199.8,
        200.7,
        201.6,
        202.5,
        203.4,
        204.3,
        205.2,
        206.10000000000002,
        207,
        207.9,
        208.8,
        209.7,
        210.60000000000002,
        211.5,
        212.4,
        213.3,
        214.2,
        215.1,
        216,
        216.89999999999998,
        217.8,
        218.7,
        219.6,
        220.5,
        221.4,
        222.3,
        223.2,
        224.1,
        225,
        225.9,
        226.8,
        227.7,
        228.6,
        229.5,
        230.4,
        231.3,
        232.20000000000002,
        233.1,
        234,
        234.9,
        235.8,
        236.7,
        237.6,
        238.5,
        239.4,
        240.29999999999998,
        241.2,
        242.1,
        243,
        243.9,
        244.8,
        245.7,
        246.6,
        247.5,
        248.4,
        249.3,
        250.2,
        251.1,
        252,
        252.9,
        253.8,
        254.70000000000002,
        255.6,
        256.5,
        257.4,
        258.3,
        259.2,
        260.1,
        261,
        261.9,
        262.79999999999995,
        263.7,
        264.6,
        265.5,
        266.4,
        267.3,
        268.2,
        269.1,
        270,
        270.9,
        271.8,
        272.7,
        273.6,
        274.5,
        275.4,
        276.29999999999995,
        277.20000000000005,
        278.1,
        279,
        279.9,
        280.8,
        281.7,
        282.6,
        283.5,
        284.4,
        285.29999999999995,
        286.20000000000005,
        287.1,
        288,
        288.9,
        289.8,
        290.7,
        291.6,
        292.5,
        293.4,
        294.3,
        295.2,
        296.1,
        297,
        297.9,
        298.79999999999995,
        299.70000000000005,
        300.6,
        301.5,
        302.4,
        303.3,
        304.2,
        305.1,
        306,
        306.9,
        307.79999999999995,
        308.70000000000005,
        309.6,
        310.5,
        311.4,
        312.3,
        313.2,
        314.1,
        315,
        315.9,
        316.8,
        317.7,
        318.6,
        319.5,
        320.4,
        321.29999999999995,
        322.20000000000005,
        323.1,
        324,
        324.9,
        325.8,
        326.7,
        327.6,
        328.5,
        329.4,
        330.29999999999995,
        331.20000000000005,
        332.1,
        333,
        333.9,
        334.8,
        335.7,
        336.6,
        337.5,
        338.4,
        339.3,
        340.2,
        341.1,
        342,
        342.9,
        343.79999999999995,
        344.70000000000005,
        345.6,
        346.5,
        347.4,
        348.3,
        349.2,
        350.1,
        351,
        351.90000000000003,
        352.8,
        353.7,
        354.6,
        355.5,
        356.4,
        357.3,
        358.2,
        359.1,
        360,
        360.9,
        361.8,
        362.7,
        363.6,
        364.5,
        365.4,
        366.3,
        367.2,
        368.09999999999997,
        369,
        369.9,
        370.8,
        371.7,
        372.6,
        373.5,
        374.40000000000003,
        375.3,
        376.2,
        377.1,
        378,
        378.9,
        379.8,
        380.7,
        381.6,
        382.5,
        383.4,
        384.3,
        385.2,
        386.1,
        387,
        387.9,
        388.8,
        389.7,
        390.59999999999997,
        391.5,
        392.4,
        393.3,
        394.2,
        395.1,
        396,
        396.90000000000003,
        397.8,
        398.7,
        399.6,
        400.5,
        401.4,
        402.3,
        403.2,
        404.1,
        405,
        405.9,
        406.8,
        407.7,
        408.6,
        409.5,
        410.4,
        411.3,
        412.2,
        413.09999999999997,
        414,
        414.9,
        415.8,
        416.7,
        417.6,
        418.5,
        419.40000000000003,
        420.3,
        421.2,
        422.1,
        423,
        423.9,
        424.8,
        425.7,
        426.6,
        427.5,
        428.4,
        429.3,
        430.2,
        431.1,
        432,
        432.9,
        433.8,
        434.7,
        435.59999999999997,
        436.5,
        437.4,
        438.3,
        439.2,
        440.1,
        441,
        441.90000000000003,
        442.8,
        443.7,
        444.6,
        445.5,
        446.4,
        447.3,
        448.2,
        449.1
      ]


      let pointListDuration = 8   //数组里1秒50项，看相当于几秒的值  如150项，相当于3秒

      let duration_past = 0;
      let intervalI = 0


      let _this = this
      let temp = setInterval(()=>{

        if(duration_past === duration){
          console.log("结束")
          //执行到相应的秒数，动画结束
          clearInterval(temp)
          if(finishFun !== undefined){
            clearTimeout(_this.previewTemp)
            _this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }
        else{

          intervalI ++;

          _this.map.jumpTo({
            center:[lngList[Math.floor(pointListDuration / duration * intervalI)],latList[Math.floor(pointListDuration / duration * intervalI)]],
            // bearing:pointList[Math.floor(pointListDuration / duration * intervalI)],
            bearing:bearingList[Math.floor(pointListDuration / duration * intervalI)],
            zoom:13
          })
          if(intervalI % 50 === 49){
            duration_past ++
          }

        }

      },20)

    },

    //用于多个动效中使地球旋转到某bearing（代替rotateTo，rotateTo无法控制速度）
    //（螺旋环绕、螺旋靠近、俯冲环绕）
    easeToBearing(bearing,zoom,duration,finishFun){
      let _this = this;
      this.map.easeTo({
        bearing:bearing,
        zoom:zoom,
        curve:1,
        duration: duration * 1000,
        easing(t) {
          if(t === 1){
            if(finishFun !== undefined){
              _this.$nextTick(()=>{
                finishFun()
              })
            }
          }
          return t
        }
      })
    },



    //点位：地球自转
    //direction：自转方向，0从左向右；1从右向左
    earthRotation(direction,duration,finishFun){
      let finish = false;

      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        finish = true
      },duration*1000)

      clearInterval(this.previewIntervalTemp)
      this.previewIntervalTemp = setInterval(()=>{
        if(finish){
          //结束
          clearInterval(this.previewIntervalTemp)
          if(finishFun !== undefined){
            clearTimeout(this.previewTemp)
            this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }
        else{
          const secondsPerRevolution = 20;
          let distancePerSecond = 360 / secondsPerRevolution;
          const center = this.map.getCenter();
          center.lng = direction === 0 ? center.lng - distancePerSecond : center.lng + distancePerSecond
          this.map.easeTo({ center, duration: 1000, easing: (n) => n });
        }
      },1000)
    },

    //点位：高空悬停
    //上一点位飞到当前点位的center+pitch+bearing+加大zoom
    //动效时先上升到当前点位zoom，再稍微不断改变center和zoom（zoom缓慢边小再变大）
    zoomSubAndHovering(duration,finishFun){

      let halfFinish = false;   //前一半时间结束（悬停动效根据前半后半不同）
      let finish = false;   //整个动效结束

      clearInterval(this.previewIntervalTemp)
      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        halfFinish = true;
        clearTimeout(this.previewTemp)
        this.previewTemp = setTimeout(()=>{
          finish = true
        },(duration * 1000 / 2 - 1000))
      },(duration * 1000 / 2 + 1000))

      let _this = this;
      this.map.easeTo({
        zoom:this.map.getZoom()-0.1,
        duration: 1000,
        easing(t) {
          if(t === 1){
            //开始悬停效果
            clearInterval(_this.previewIntervalTemp)
            _this.previewIntervalTemp = setInterval(()=>{
              if(finish){
                //结束
                clearInterval(_this.previewIntervalTemp)
                _this.map.stop();
                if(finishFun !== undefined){
                  clearTimeout(_this.previewTemp)
                  _this.previewTemp = setTimeout(()=>{
                    finishFun()
                  },0)
                }
              }
              else{
                //悬停效果

                //随机移动中心点
                let lngChange = Math.random() * 0.0015
                let latChange = Math.random() * 0.0015
                let lngAddOrSub = Math.random() > 0.5 ? 'add' : 'sub';
                let latAddOrSub = Math.random() > 0.5 ? 'add' : 'sub';
                const center = _this.map.getCenter();
                center.lng = lngAddOrSub==="add" ? center.lng + lngChange : center.lng - lngChange;
                center.lat = latAddOrSub==="add" ? center.lat + latChange : center.lat - latChange;

                _this.map.easeTo({
                  center,
                  zoom:!halfFinish ? _this.map.getZoom() - 0.01 : _this.map.getZoom() + 0.01,  //zoom先变小后变大
                  duration: 1200,
                  curve:1,
                  // easing(t){
                  //   //变化过程速度动画 慢-快-慢
                  //   return Math.sin(t * Math.PI / 2)
                  // }
                })

              }
            },1000)

          }

          //变化过程速度动画 慢-快-慢
          // return Math.sin(t * Math.PI / 2)
          return t
        }
      })

    },

    //点位：螺旋环绕
    //direction：螺旋方向，0逆时针，bearing加；1顺时针，bearing减
    //上一点位飞到当前点位的center+pitch+bearing+zoom
    //动效，螺旋凝视效果，旋转速度360°需要30s
    zoomAddAndPitchAddAndRotate(direction,duration,finishFun){
      //总共环绕度数
      let totalBearing = duration / 30 * 360;

      //已旋转的角度
      let hasRotateBearing = 0;
      //每次加/减90，来控制顺时针和逆时针   360°需要30s，90度需要7.5s
      let bearing = direction === 0 ? this.map.getBearing() + 90 : this.map.getBearing() - 90;
      this.easeToBearing(bearing,this.map.getZoom(),7.5,easeToBearingFinishFun_zoomAddAndPitchAddAndRotate)

      let _this = this
      function easeToBearingFinishFun_zoomAddAndPitchAddAndRotate(){
        hasRotateBearing = hasRotateBearing + 90;   //最后一次可能旋转不足90所以判断结束使用>=
        if(hasRotateBearing >= totalBearing){
          //动效结束
          if(finishFun !== undefined){
            clearTimeout(_this.previewTemp)
            _this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }
        else{
          if(totalBearing > hasRotateBearing + 90){
            //剩余超过90度
            let bearing = direction === 0 ? _this.map.getBearing() + 90 : _this.map.getBearing() - 90;
            _this.easeToBearing(bearing,_this.map.getZoom(),7.5,easeToBearingFinishFun_zoomAddAndPitchAddAndRotate)
          }
          else{
            //剩余不足90度
            let bearing = direction === 0 ? _this.map.getBearing() + (totalBearing-hasRotateBearing) : _this.map.getBearing() - (totalBearing-hasRotateBearing);
            let duration = (totalBearing-hasRotateBearing) * 30 / 360;
            _this.easeToBearing(bearing,_this.map.getZoom(),duration,easeToBearingFinishFun_zoomAddAndPitchAddAndRotate)
          }
        }
      }
    },

    //点位：螺旋靠近
    //direction：螺旋方向，0逆时针，bearing加；1顺时针，bearing减
    //上一点位飞到当前点位的center+pitch+bearing+减小zoom
    //动效，先螺旋凝视同时增大zoom到该点位zoom（360°）（360°有误差），然后进行现有螺旋凝视效果，旋转速度都是360°需要24s
    zoomAddAndPitchAddAndRotateZoomAdd(direction,duration,finishFun){
      //总共环绕度数
      let totalBearing = duration / 24 * 360;
      //zoom在360度内改变2，每90度改变0.5

      //已旋转的角度
      let hasRotateBearing = 0;
      //每次加/减90，来控制顺时针和逆时针   360°需要24s，90度需要6s
      let bearing = direction === 0 ? this.map.getBearing() + 90 : this.map.getBearing() - 90;
      this.easeToBearing(bearing,this.map.getZoom()+0.5,6,easeToBearingFinishFun_zoomAddAndPitchAddAndRotateZoomAdd)

      let _this = this
      function easeToBearingFinishFun_zoomAddAndPitchAddAndRotateZoomAdd(){
        hasRotateBearing = hasRotateBearing + 90;   //最后一次可能旋转不足90所以判断结束使用>=
        if(hasRotateBearing >= totalBearing){
          //动效结束
          if(finishFun !== undefined){
            clearTimeout(_this.previewTemp)
            _this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }
        else{
          if(totalBearing > hasRotateBearing + 90){
            //剩余超过90度
            let bearing = direction === 0 ? _this.map.getBearing() + 90 : _this.map.getBearing() - 90;
            if(hasRotateBearing >= 360){
              //已经旋转360度，不需要改变zoom
              _this.easeToBearing(bearing,_this.map.getZoom(),6,easeToBearingFinishFun_zoomAddAndPitchAddAndRotateZoomAdd)
            }
            else{
              //旋转不到360度，仍然在靠近，需要改变zoom
              _this.easeToBearing(bearing,_this.map.getZoom()+0.5,6,easeToBearingFinishFun_zoomAddAndPitchAddAndRotateZoomAdd)
            }
          }
          else{
            //剩余不足90度
            let bearing = direction === 0 ? _this.map.getBearing() + (totalBearing-hasRotateBearing) : _this.map.getBearing() - (totalBearing-hasRotateBearing);
            let duration = (totalBearing-hasRotateBearing) * 24 / 360;
            if(hasRotateBearing >= 360){
              //已经旋转360度，不需要改变zoom
              _this.easeToBearing(bearing,_this.map.getZoom(),duration,easeToBearingFinishFun_zoomAddAndPitchAddAndRotateZoomAdd)
            }
            else{
              //旋转不到360度，仍然在靠近，需要改变zoom
              //zoom在360度改变2，在totalBearing-hasRotateBearing度数中改变的值为
              let changeZoom = (totalBearing-hasRotateBearing) * 2 / 360
              _this.easeToBearing(bearing,_this.map.getZoom()+changeZoom,duration,easeToBearingFinishFun_zoomAddAndPitchAddAndRotateZoomAdd)
            }
          }
        }
      }

    },

    //点位：俯冲环绕
    //direction：环绕方向，0逆时针，bearing加；1顺时针，bearing减（zoomChange是旧版的俯冲高度参数，不使用）
    //上一点位飞到当前点位的center+pitch=0+bearing+减小zoom
    //动效，先平移到当前点位的center+pitch+bearing+zoom（5秒），再进行现有螺旋凝视效果（旋转速度360°需要30s）
    zoomAddAndRotate(direction,zoomChange,duration,finishFun){
      //总共环绕度数
      let totalBearing = (duration - 5) / 30 * 360;   //进场动效5秒
      //已旋转的角度
      let hasRotateBearing = 0;

      let _this = this;
      this.map.easeTo({
        zoom:this.$store.state.sceneCurrPlayItem.sceneZoom,
        pitch:this.$store.state.sceneCurrPlayItem.scenePitch,
        duration: 5000,
        easing(t) {
          if(t === 1){
            //开始环绕
            _this.$nextTick(()=>{
              //每次加/减90，来控制顺时针和逆时针   360°需要30s，90度需要7.5s
              let bearing = direction === 0 ? _this.map.getBearing() + 90 : _this.map.getBearing() - 90;
              _this.easeToBearing(bearing,_this.map.getZoom(),7.5,easeToBearingFinishFun_zoomAddAndRotate)
            })
          }

          return t;
        }
      })

      function easeToBearingFinishFun_zoomAddAndRotate(){
        hasRotateBearing = hasRotateBearing + 90;   //最后一次可能旋转不足90所以判断结束使用>=
        if(hasRotateBearing >= totalBearing){
          //动效结束
          if(finishFun !== undefined){
            clearTimeout(_this.previewTemp)
            _this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }
        else{
          if(totalBearing > hasRotateBearing + 90){
            //剩余超过90度
            let bearing = direction === 0 ? _this.map.getBearing() + 90 : _this.map.getBearing() - 90;
            _this.easeToBearing(bearing,_this.map.getZoom(),7.5,easeToBearingFinishFun_zoomAddAndRotate)
          }
          else{
            //剩余不足90度
            let bearing = direction === 0 ? _this.map.getBearing() + (totalBearing-hasRotateBearing) : _this.map.getBearing() - (totalBearing-hasRotateBearing);
            let duration = (totalBearing-hasRotateBearing) * 30 / 360;
            _this.easeToBearing(bearing,_this.map.getZoom(),duration,easeToBearingFinishFun_zoomAddAndRotate)
          }
        }
      }

    },

    //点位：俯冲观测
    //上一点位飞到当前点位的center+ pitch=0+bearing+减小zoom
    //动效，先平移到当前点位的center+pitch+bearing+zoom，再稍微不断改变center和zoom（zoom缓慢变大再变小）
    zoomAddAndHovering(zoomChange,duration,finishFun){
      let halfFinish = false;   //前一半时间结束（悬停动效根据前半后半不同）
      let finish = false;   //整个动效结束

      clearInterval(this.previewIntervalTemp)
      clearTimeout(this.previewTemp)
      this.previewTemp = setTimeout(()=>{
        halfFinish = true;
        clearTimeout(this.previewTemp)
        this.previewTemp = setTimeout(()=>{
          finish = true
        },(duration * 1000 - 800) / 2)
      },(duration * 1000 - 800) / 2)


      let _this = this;
      this.map.easeTo({
        zoom:this.map.getZoom()+zoomChange,
        pitch:this.$store.state.sceneCurrPlayItem.scenePitch,
        duration: 800,
        easing(t) {
          if(t === 1){
            //开始悬停
            clearInterval(_this.previewIntervalTemp)
            _this.previewIntervalTemp = setInterval(()=>{
              if(finish){
                //结束
                clearInterval(_this.previewIntervalTemp)
                if(finishFun !== undefined){
                  clearTimeout(_this.previewTemp)
                  _this.previewTemp = setTimeout(()=>{
                    finishFun()
                  },0)
                }
              }
              else{
                //悬停效果
                //随机移动中心点
                let lngChange = Math.random() * 0.0015
                let latChange = Math.random() * 0.0015
                let lngAddOrSub = Math.random() > 0.5 ? 'add' : 'sub';
                let latAddOrSub = Math.random() > 0.5 ? 'add' : 'sub';
                const center = _this.map.getCenter();
                center.lng = lngAddOrSub==="add" ? center.lng + lngChange : center.lng - lngChange;
                center.lat = latAddOrSub==="add" ? center.lat + latChange : center.lat - latChange;

                _this.map.easeTo({
                  center,
                  zoom:!halfFinish ? _this.map.getZoom() + 0.01 : _this.map.getZoom() - 0.01,  //zoom先变小后变大
                  duration: 1200,
                  easing(t){
                    //变化过程速度动画 慢-快-慢
                    return Math.sin(t * Math.PI / 2)
                  }
                })

              }
            },1000)

          }

          return t;
        }
      })

    },


    //点位：空中游览
    //routePoints路线点位，duration持续时间
    //上一点位飞到当前点位的center+pitch=0+bearing=0+减小zoom
    //动效，先平移到当前点位的center+pitch=0+bearing=0+zoom，再进行当前的平移跟踪
    //离开时先平移到能看到所有点位的视角，再转下一点位
    zoomAddAndFlyByPath(routePoints,duration,finishFun){
      let _this = this;
      this.map.easeTo({
        zoom:this.map.getZoom()+1,
        duration: 2000,
        easing(t) {
          if(t === 1){
            _this.$nextTick(()=>{
              //开始沿路线移动，直接调用原本的沿路线移动方法
              _this.flyByPath(routePoints,duration-5,()=>{
                //离开时先平移到能看到所有点位的视角，再转下一点位
                let routePointsTurfPoints = [];
                for(let i=0;i<routePoints.length;i++){
                  routePointsTurfPoints.push(turf.point(routePoints[i]))
                }
                let features = turf.featureCollection(routePointsTurfPoints);
                let enveloped = turf.envelope(features);

                const bbox = turf.bbox(enveloped)
                _this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
                  animate: true,
                  padding: {top: 30, bottom: 30, left: 30, right: 30},
                  duration:3000,
                  easing(t){
                    if(t === 1){
                      //fitbounds结束后，再执行动效的finishFun
                      if(finishFun !== undefined){
                        clearTimeout(_this.previewTemp)
                        _this.previewTemp = setTimeout(()=>{
                          finishFun()
                        },0)
                      }
                    }
                    return t;
                  }
                })

              })
            })
          }

          return t;
        }
      })

    },


    //点位：侧向跟踪
    //平移跟踪基础上，增加固定的pitch值，每步移动需要根据当前点和下一点的角度，设置地球bearing，使出现侧向观察效果
    flyByPathWithChangeBearing(routePoints,duration,finishFun){
      const routeDistance = turf.lineDistance(turf.lineString(routePoints));   //总路线长度
      const pointsDistance = [0];    //各点到起点的长度
      for(let i=1;i<routePoints.length;i++){
        let currRoute = routePoints.slice(0,i+1);
        pointsDistance.push(turf.lineDistance(turf.lineString(currRoute)))
      }

      //素材线的总长度 和 移动路线总长度的比值
      //移动路线每次按距起点距离取点，根据比值计算 素材线每次取点距离素材线起点的距离  每次取值素材线到的位置

      let start;

      let _this = this
      function frame(time) {
        if (!start) start = time;

        const phase = (time - start) / (duration * 1000);

        const alongRoute = turf.along(
            turf.lineString(routePoints),
            routeDistance * phase
        ).geometry.coordinates;
        const alongRouteNext = turf.along(
            turf.lineString(routePoints),
            routeDistance * (phase + 0.02)
        ).geometry.coordinates;

        //计算下个点和当前点之间的角度
        let alongRouteBearing = turf.bearing(turf.point(alongRoute), turf.point(alongRouteNext));

        _this.map.jumpTo({
          center:alongRoute,
          bearing:alongRouteBearing+90
        })


        if(!_this.previewAnimationFrameStop && phase <= 1){
          //继续预览，且进度没到1时，重复过程
          window.requestAnimationFrame(frame);
        }
        else if(!_this.previewAnimationFrameStop){
          // console.log("飞行结束")
          if(finishFun !== undefined){
            clearTimeout(_this.previewTemp)
            _this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }

      }

      window.requestAnimationFrame(frame);
    },


    //点位：模拟驾驶
    //平移跟踪基础上，增加固定的pitch值，并且使视角一直看着前进方向
    flyByPathWithWatchNextPoint(routePoints,duration,finishFun){
      //计算位于第一个点，朝向第二个点的bearing
      let alongRouteFirstBearing = turf.bearing(turf.point(routePoints[0]), turf.point(routePoints[1]));

      let _this = this;
      this.map.easeTo({
        zoom:this.map.getZoom()-1,
        // zoom:this.map.getZoom(),
        pitch:60,
        bearing:alongRouteFirstBearing,
        duration: 2000,
        easing(t) {
          if(t === 1){
            _this.$nextTick(()=>{
              //开始沿路线移动，同时视角一直看着前进方向
              _this.flyByPathAndWatchFrontFun(routePoints,duration-5,()=>{
                //离开时先平移到能看到所有点位的视角，再转下一点位
                let routePointsTurfPoints = [];
                for(let i=0;i<routePoints.length;i++){
                  routePointsTurfPoints.push(turf.point(routePoints[i]))
                }
                let features = turf.featureCollection(routePointsTurfPoints);
                let enveloped = turf.envelope(features);

                const bbox = turf.bbox(enveloped)
                _this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
                  animate: true,
                  padding: {top: 30, bottom: 30, left: 30, right: 30},
                  duration:3000,
                  easing(t){
                    if(t === 1){
                      //fitbounds结束后，再执行动效的finishFun
                      if(finishFun !== undefined){
                        clearTimeout(_this.previewTemp)
                        _this.previewTemp = setTimeout(()=>{
                          finishFun()
                        },0)
                      }
                    }
                    return t;
                  }
                })

              })
            })

          }

          return t;
        }
      })

    },
    //延路线移动，同时视角一直看着前进方向
    flyByPathAndWatchFrontFun(routePoints,duration,finishFun){
      const routeDistance = turf.lineDistance(turf.lineString(routePoints));   //总路线长度
      const pointsDistance = [];    //各点之间的长度
      const pointsEaseToDuration = [];    //各点之间平移的时长
      for(let i=1;i<routePoints.length;i++){
        let currPointDistance = turf.lineDistance(turf.lineString([routePoints[i-1],routePoints[i]]))
        pointsDistance.push(currPointDistance)
        pointsEaseToDuration.push(currPointDistance / routeDistance * duration * 1000 - 300)   //-300是因为每次移动前视角扭头需要300ms，但是第一次移动前没有扭头，所以其实最后会有300ms误差
      }

      let easeToWithTwoPointI = 0;
      //第一个点直接移动，不需要转视角，因为模拟驾驶入场时视角已经朝向第二个点
      this.easeToWithTwoPoint(routePoints[easeToWithTwoPointI+1],pointsEaseToDuration[easeToWithTwoPointI],easeToWithTwoPointFinishFun_flyByPathAndWatchFrontFun)

      let _this = this
      function easeToWithTwoPointFinishFun_flyByPathAndWatchFrontFun(){
        easeToWithTwoPointI ++;
        if(easeToWithTwoPointI===routePoints.length-1){
          //全部点位执行结束
          console.log("结束")
          if(finishFun !== undefined){
            clearTimeout(_this.previewTemp)
            _this.previewTemp = setTimeout(()=>{
              finishFun()
            },0)
          }
        }
        else{
          //视角转向朝下一个点
          let alongRouteBearing = turf.bearing(turf.point(routePoints[easeToWithTwoPointI]), turf.point(routePoints[easeToWithTwoPointI+1]));

          _this.map.easeTo({
            bearing:alongRouteBearing,
            curve:1,
            duration: 300,
            easing(t) {
              if(t === 1){
                _this.$nextTick(()=>{
                  //进行移动
                  _this.easeToWithTwoPoint(routePoints[easeToWithTwoPointI+1],pointsEaseToDuration[easeToWithTwoPointI],easeToWithTwoPointFinishFun_flyByPathAndWatchFrontFun)
                })
              }
              return t
            }
          })

        }
      }


      //旧版实现思路，在dem区域视角会上下抖动
      // const routeDistance = turf.lineDistance(turf.lineString(routePoints));   //总路线长度
      // const pointsDistance = [0];    //各点到起点的长度
      // for(let i=1;i<routePoints.length;i++){
      //   let currRoute = routePoints.slice(0,i+1);
      //   pointsDistance.push(turf.lineDistance(turf.lineString(currRoute)))
      // }
      //
      // //素材线的总长度 和 移动路线总长度的比值
      // //移动路线每次按距起点距离取点，根据比值计算 素材线每次取点距离素材线起点的距离  每次取值素材线到的位置
      //
      // let start;
      //
      // let _this = this
      // function frame(time) {
      //   if (!start) start = time;
      //
      //   const phase = (time - start) / (duration * 1000);
      //
      //   const alongRoute = turf.along(
      //       turf.lineString(routePoints),
      //       routeDistance * phase
      //   ).geometry.coordinates;
      //   const alongRouteNext = turf.along(
      //       turf.lineString(routePoints),
      //       routeDistance * (phase + 0.02)
      //   ).geometry.coordinates;
      //
      //   //计算下个点和当前点之间的角度
      //   let alongRouteBearing = turf.bearing(turf.point(alongRoute), turf.point(alongRouteNext));
      //
      //   _this.map.jumpTo({
      //     center:alongRoute,
      //     bearing:alongRouteBearing
      //   })
      //
      //   if(!_this.previewAnimationFrameStop && phase <= 1){
      //     //继续预览，且进度没到1时，重复过程
      //     window.requestAnimationFrame(frame);
      //   }
      //   else if(!_this.previewAnimationFrameStop){
      //     // console.log("飞行结束")
      //     if(finishFun !== undefined){
      //       clearTimeout(_this.previewTemp)
      //       _this.previewTemp = setTimeout(()=>{
      //         finishFun()
      //       },0)
      //     }
      //   }
      //
      // }
      //
      // window.requestAnimationFrame(frame);

      //通过相机设置实现，不能支持pitch效果
      // const cameraAltitude = ((2 * Math.PI * 6378137.0) / Math.pow(2, this.map.getZoom()) / 2 / Math.tan(this.map.transform._fov / 2)/1000) * 1000;
      //
      // const routeDistance = turf.lineDistance(turf.lineString(routePoints));   //总路线长度
      //
      // let start;
      //
      // let _this = this
      // function frame(time) {
      //   if (!start) start = time;
      //
      //   const phase = (time - start) / (duration * 1000);
      //
      //   const alongRoute = turf.along(
      //       turf.lineString(routePoints),
      //       routeDistance * (phase + 0.03)
      //   ).geometry.coordinates;
      //   const alongCamera = turf.along(
      //       turf.lineString(routePoints),
      //       routeDistance * phase
      //   ).geometry.coordinates;
      //
      //   const camera = _this.map.getFreeCameraOptions();
      //   camera.position = mapboxgl.MercatorCoordinate.fromLngLat(
      //       {
      //         lng: alongCamera[0],
      //         lat: alongCamera[1]
      //       },
      //       cameraAltitude
      //   );
      //   camera.lookAtPoint({
      //     lng: alongRoute[0],
      //     lat: alongRoute[1]
      //   });
      //   _this.map.setFreeCameraOptions(camera);
      //
      //
      //   if(!_this.previewAnimationFrameStop && phase <= 1){
      //     //继续预览，且进度没到1时，重复过程
      //     window.requestAnimationFrame(frame);
      //   }
      //   else if(!_this.previewAnimationFrameStop){
      //     // console.log("飞行结束")
      //     if(finishFun !== undefined){
      //       clearTimeout(_this.previewTemp)
      //       _this.previewTemp = setTimeout(()=>{
      //         finishFun()
      //       },0)
      //     }
      //   }
      //
      // }
      //
      // window.requestAnimationFrame(frame);
    },



    //备份 地球+相机视角变化
    // flyByPath(routePoints,speed,height,finishFun){
    //   console.log(height)
    //
    //   const routes = routePoints;
    //
    //   const targetRoute = routes;
    //   const cameraRoute = routes;
    //
    //   const animationDuration = speed * routes.length;   //总路线动效时间
    //   // const animationDuration = 50000;
    //   const cameraAltitude = height;
    //
    //   const routeDistance = turf.lineDistance(turf.lineString(targetRoute));   //总路线长度
    //   const pointsDistance = [0];    //各点到起点的长度
    //   for(let i=1;i<targetRoute.length;i++){
    //     let currRoute = targetRoute.slice(0,i+1);
    //     pointsDistance.push(turf.lineDistance(turf.lineString(currRoute)))
    //   }
    //   let routeFinishPointIndex = 0;
    //
    //
    //   const cameraRouteDistance = turf.lineDistance(
    //       turf.lineString(cameraRoute)
    //   );
    //
    //
    //   //素材线的总长度 和 移动路线总长度的比值
    //   //移动路线每次按距起点距离取点，根据比值计算 素材线每次取点距离素材线起点的距离  每次取值素材线到的位置
    //
    //
    //   let start;
    //
    //   let _this = this
    //   function frame(time) {
    //     if (!start) start = time;
    //
    //     const phase = (time - start) / animationDuration;
    //
    //     const alongRoute = turf.along(
    //         turf.lineString(targetRoute),
    //         routeDistance * phase
    //     ).geometry.coordinates;
    //     if(routeDistance * phase >= pointsDistance[routeFinishPointIndex]){
    //       // console.log("经过第"+routeFinishPointIndex+"个视野点")
    //       routeFinishPointIndex++
    //     }
    //
    //     const alongCamera = turf.along(
    //         turf.lineString(cameraRoute),
    //         cameraRouteDistance * phase
    //     ).geometry.coordinates;
    //
    //     const camera = _this.map.getFreeCameraOptions();
    //     camera.position = mapboxgl.MercatorCoordinate.fromLngLat(
    //         {
    //           lng: alongCamera[0],
    //           lat: alongCamera[1]
    //         },
    //         cameraAltitude
    //     );
    //
    //     camera.lookAtPoint({
    //       lng: alongRoute[0],
    //       lat: alongRoute[1]
    //     });
    //
    //     _this.map.setFreeCameraOptions(camera);
    //
    //     if(!_this.previewAnimationFrameStop && phase <= 1){
    //       //继续预览，且进度没到1时，重复过程
    //       window.requestAnimationFrame(frame);
    //     }
    //     else if(!_this.previewAnimationFrameStop){
    //       // console.log("飞行结束")
    //       if(finishFun !== undefined){
    //         clearTimeout(_this.previewTemp)
    //         _this.previewTemp = setTimeout(()=>{
    //           finishFun()
    //         },0)
    //       }
    //     }
    //
    //   }
    //
    //   window.requestAnimationFrame(frame);
    //
    // },



    //使用！！判断是否在预览中，并处理
    isPreviewing(nextFun){
      console.log(this.previewing)
      if(this.previewing){
        let panelType = this.previewingType.split("+")[0];
        let previewType = this.previewingType.split("+")[1];

        console.log(panelType);
        console.log(previewType);

        if(panelType === "fly"){
          switch(previewType){

            case "跳跃": case "平移": case "穿梭":{
              this.map.stop();
              this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
              break;
            }
            case "切换":{
              switch(this.previewingType.split("+")[2]){
                case "淡出":{
                  clearTimeout(this.previewTemp)
                  this.animationAllScreenMapMantleName = "";
                  this.animationAllScreenMapMantleDuration = "";

                  this.map.stop();
                  this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
                  break;
                }

                case "浮入":{
                  clearTimeout(this.previewTemp)
                  this.animationAllScreenMantleShow = false;
                  this.animationAllScreenBackground = "";
                  this.animationAllScreenMantleName = "";
                  this.animationAllScreenMantleDuration = "";
                  this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                  break;
                }
                case "扩展":{
                  clearTimeout(this.previewTemp)
                  this.animationAllScreenMantleCenterShow = false;
                  this.animationAllScreenCenterBackground = "";
                  this.animationAllScreenMantleCenterName = "";
                  this.animationAllScreenMantleCenterDuration = "";
                  this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                  break;
                }
                case "百叶窗":{
                  clearTimeout(this.previewTemp)
                  this.animationWindowMantleShow = false;
                  this.animationWindowBackground = "";
                  this.animationWindowMantleDuration = "";
                  this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

                  break;
                }
                case "无":{
                  clearTimeout(this.previewTemp)
                  this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
                  break;
                }
              }

              break;
            }
            case "旋转跳跃":{
              this.map.stop();
              clearInterval(this.previewIntervalTemp)
              clearTimeout(this.previewTemp)
              this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
              break;
            }
            case "回太空":{
              this.map.stop();
              clearTimeout(this.previewTemp)
              this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
              break;
            }
            case "无":{
              clearTimeout(this.previewTemp)
              this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
              break;
            }

          }
        }
        else if(panelType === "point"){

          switch(previewType){
            //单点
            case "螺旋凝视":{
              console.log("停止螺旋凝视")
              this.previewAnimationFrameStop = false;
              clearInterval(this.previewIntervalTemp)
              clearTimeout(this.previewTemp)
              this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])

              break;
            }
            // case "俯视":{
            //   this.map.stop();
            //   clearTimeout(this.previewTemp)
            //   this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
            //   break;
            // }
            case "太空俯冲":{
              this.previewAnimationFrameStop = true;
              clearTimeout(this.previewTemp)
              setTimeout(()=>{
                this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
              },100)

              break;
            }
            case "地球自转": case "高空悬停": case "螺旋环绕": case "螺旋靠近": case "俯冲环绕": case "俯冲观测":{
              this.previewAnimationFrameStop = true;
              clearInterval(this.previewIntervalTemp)
              clearTimeout(this.previewTemp)
              this.map.stop();
              setTimeout(()=>{
                this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
              },100)
              break;
            }

            //多点
            case "侧向跟踪":{
              this.previewAnimationFrameStop = true;
              clearTimeout(this.previewTemp)
              setTimeout(()=>{
                this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
              },100)

              break;
            }
            case "平移跟踪": case "空中游览":{
              clearTimeout(this.previewTemp);
              this.map.stop();
              setTimeout(()=>{
                this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
              },100)
              break;
            }
            case "模拟驾驶":{
              this.previewAnimationFrameStop = true;
              clearTimeout(this.previewTemp)
              this.map.stop();
              setTimeout(()=>{
                this.jumpToSceneItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex])
              },100)

              break;
            }

          }

        }

        //当前录制点素材显隐（更新该录制点的素材地图标记文件）
        setTimeout(()=>{
          this.$store.state.sceneCurrPlayItem = "";
          //素材点销毁重新加载，以开始素材动画
          this.$store.state.sceneMaterialShow = false;   //先隐藏素材，再改变播放状态，播放状态改变会导致素材点的显示变量变化

          //隐藏常显素材地图数据
          this.$store.state.sceneMaterialShow_allShow = false;
          this.clearMaterialMarkerLayer_allShow()

          this.sceneItemPlaying = false;

          if(this.map.getSource('sceneMaterialLine') == undefined){
            this.createMaterialMarkerLayer()
          }
          this.getMaterialMarkerData(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo);
          setTimeout(()=>{
            this.$store.state.sceneMaterialShow = true;
          },0)
          //播放中的地球上标记清空
          this.playMaterialInfo = {
            materialList:[],
            materialMarkerData:this.$store.state.defaultMaterialMarkerData
          }

          //显示视野点
          this.$store.state.sceneViewMarkerShow = true;

        },0)


        //预览结束
        this.previewing = false;

      }
      else{
        if(nextFun !== undefined){
          nextFun();
        }
      }
    },

    //使用！！是否处于录制点排序状态
    isSceneItemDragging(nextFun){
      if(this.$store.state.sceneItemDragging){
        this.$store.state.sceneItemDragging = false;
        if(nextFun !== undefined){
          nextFun();
        }
      }
      else{
        if(nextFun !== undefined){
          nextFun();
        }
      }
    },

    //使用！！是否处于录制点批量操作状态
    isSceneItemMultipleChoosing(nextFun){
      if(this.$store.state.sceneItemMultipleChoosing){
        this.$store.state.sceneItemMultipleChoosing = false;
        if(nextFun !== undefined){
          nextFun();
        }
      }
      else{
        if(nextFun !== undefined){
          nextFun();
        }
      }
    },


    //生成样例数据，制作数据 点击播放后将scenePicture的base64数据转为http
    async createExample(){
      let exampleList = JSON.parse(JSON.stringify(this.$store.state.sceneList))
      for(let i=0;i<exampleList.length;i++){
        // 把生成的base64位图片上传到服务器,生成在线图片地址
        exampleList[i].scenePicture = await this.$utils.base64ToHttp(exampleList[i].scenePicture)
        for(let j=0;j<exampleList[i].viewPointList.length;j++){
          exampleList[i].viewPointList[j].viewPicture = await this.$utils.base64ToHttp(exampleList[i].viewPointList[j].viewPicture)
        }
      }
      console.log(exampleList)
      console.log(JSON.stringify(exampleList))
    },




    //视野点///////////////////////////////////////////////////////////////////////////////////////

    //使用！！点击添加视野点
    addViewPoint(){
      console.log("添加视野点")

      this.isPreviewing(()=>{
        if(!this.cutScreening){
          this.cutScreening = true;

          //添加录制点的第一个默认点位，提示语不同
          if(this.addDefaultFirstViewPointIng){
            this.loadingDialogText = "录制点位添加中……";
            this.showLoadingDialog = true;
            this.addDefaultFirstViewPointIng = false;
          }
          else{
            this.loadingDialogText = "视野点位添加中……";
            this.showLoadingDialog = true;
          }


          //视野点栏折叠，自动打开
          if(!this.viewPointerListOpen){
            this.changeViewPointerListOpenState()
          }

          //当前视野点列表
          let currViewList = this.$store.state.tempViewPointList

          //在全屏球截屏
          this.sceneFullMap.jumpTo({
            center:this.map.getCenter(),
            zoom:this.map.getZoom(),
            bearing:this.map.getBearing(),
            pitch:this.map.getPitch(),
          });
          setTimeout(()=>{
            //获取当前点位 截图地图区域
            html2canvas(this.$refs.sceneFullMap, {
              // width: 30, //截图宽度
              // height: this.$refs.globeMap.offsetHeight - 25, //截图高度
              backgroundColor: null, //画出来的图片有白色的边框,不要可设置背景为透明色（null）
              useCORS: true, //支持图片跨域
              scale: 1, //设置放大的倍数
            }).then((canvas) => {
              console.log(canvas)

              //添加视野点位，暂无缩略图
              this.$axios({
                method:"get",
                url:"/authorApi/POI/searchFromLocation",
                params:{
                  lat:this.map.getCenter().lat,
                  lon:this.map.getCenter().lng
                }
              }).then((resultData_poi)=>{
                resultData_poi = resultData_poi.data;
                if(resultData_poi.message === "ok"){
                  //视野点名称
                  let viewPointName
                  if(resultData_poi.result.city !== ""){
                    if(resultData_poi.result.name !== ""){
                      viewPointName = resultData_poi.result.city + " · " + resultData_poi.result.name;
                    }
                    else{
                      let num = this.$store.state.tempViewPointList.length+1;
                      viewPointName = resultData_poi.result.city + " · 视野点" + num;
                    }
                  }
                  else if(resultData_poi.result.province !== ""){
                    if(resultData_poi.result.name !== ""){
                      viewPointName = resultData_poi.result.province + " · " + resultData_poi.result.name;
                    }
                    else{
                      let num = this.$store.state.tempViewPointList.length+1;
                      viewPointName = resultData_poi.result.province + " · 视野点" + num;
                    }
                  }
                  else if(resultData_poi.result.city !== ""){
                    if(resultData_poi.result.name !== ""){
                      viewPointName = resultData_poi.result.city + " · " + resultData_poi.result.name;
                    }
                    else{
                      let num = this.$store.state.tempViewPointList.length+1;
                      viewPointName = resultData_poi.result.city + " · 视野点" + num;
                    }
                  }
                  else{
                    if(resultData_poi.result.name !== ""){
                      viewPointName = "其他 · " + resultData_poi.result.name;
                    }
                    else{
                      let num = this.$store.state.tempViewPointList.length+1;
                      viewPointName = "其他 · 视野点" + num;
                    }
                  }

                  //获取新id
                  this.$utils.getNewId((newId)=>{
                    this.$store.state.tempViewPointList.push(
                        {
                          viewId:newId,
                          lng:this.map.getCenter().lng,
                          lat:this.map.getCenter().lat,
                          zoom:this.map.getZoom(),
                          pitch:this.map.getPitch(),
                          bearing:this.map.getBearing(),
                          name:viewPointName,
                          isZoomBasis:currViewList.length === 0 ? true : false,
                          viewPicture:"",
                          viewThumb:""
                        },
                    )

                    //第一个点自动设为视野基准点
                    if(this.$store.state.tempViewPointList.length === 1){
                      console.log("设为基准点")
                      this.$store.state.tempSceneZoomBasis = this.$store.state.tempViewPointList[0].zoom;
                    }

                    //列表滚动到底
                    this.viewListScrollToBottom();

                    // 把生成的base64位图片上传到服务器,生成在线图片地址
                    let url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64
                    //上传后台
                    let file = this.$utils.base64ToFile(url,"视野点位.jpg");
                    let paramData = new FormData();
                    paramData.append('multipartFile',file);
                    this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
                        .then((resultData)=>{
                          resultData = resultData.data;
                          console.log(resultData)
                          if(resultData.status === 200){
                            //补充点位图
                            this.$store.state.tempViewPointList[this.$store.state.tempViewPointList.length - 1].viewPicture = url;
                            this.$store.state.tempViewPointList[this.$store.state.tempViewPointList.length - 1].viewThumb = resultData.data.thumb;

                            //添加完成后处理
                            console.log(this.$store.state.sceneType)
                            switch(this.$store.state.sceneType){
                              case "单点动画": case "地球动画":{
                                this.$store.state.sceneOperationState_addViewPointGuideState = 'viewPointFinish';
                                this.sceneGuideMantle_viewFinishBtnAvailable_show();
                                this.sceneGuideMantle_mapAvailable = false;

                                break;
                              }
                              case "多点跳转":{
                                if(currViewList.length === 1){
                                  this.$store.state.sceneOperationState_addViewPointGuideState = 'newViewPoint';
                                  //箭头位置
                                  this.sceneGuideMantle_arrowPositionLeft = "calc(50% + 310px)";
                                  this.sceneGuideMantle_arrowPositionTop = "calc(100% - 85px)";
                                  this.sceneGuideMantle_arrowShow = true;
                                }
                                else{
                                  this.$store.state.sceneOperationState_addViewPointGuideState = 'viewPoint2';
                                  this.sceneGuideMantle_arrowShow = false;
                                }

                                break;
                              }
                              case "自定义动画":{
                                if(currViewList.length === 1){
                                  //添加引导说明更改
                                  this.$store.state.sceneOperationState_addViewPointGuideState = 'viewPoint1';
                                  this.sceneRecommendedAnimationList = [
                                    {
                                      picture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310131651000043808.jpg",
                                      name:"螺旋凝视"
                                    },
                                    {
                                      picture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310131651000043808.jpg",
                                      name:"太空俯冲"
                                    },
                                  ]
                                  this.$store.state.sceneOperationState_addViewPointRecommendedAnimationShow = true;
                                }
                                else{
                                  if(currViewList.length >= 2){
                                    this.$store.state.sceneOperationState_addViewPointGuideState = 'viewPoint2';
                                  }
                                  this.sceneRecommendedAnimationList = [
                                    {
                                      picture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310131651000043808.jpg",
                                      name:"平移跟踪"
                                    }
                                  ]
                                  this.$store.state.sceneOperationState_addViewPointRecommendedAnimationShow = true;
                                }

                                break;
                              }



                            }


                            this.cutScreening = false;

                            this.showLoadingDialog = false;

                          }
                          else{
                            console.log(resultData.status + resultData.message);
                          }
                        })
                        .catch(()=>{

                        })
                  })

                }
                else{
                  console.log(resultData_poi.status + resultData_poi.message);
                }
              }).catch((err)=>{
                console.log(err);
              });

            });

          },500)

        }

      })


    },

    //使用！！视野点列表完成
    viewPointerListFinish(){
      if(!this.cutScreening){
        if(this.$store.state.tempViewPointList.length > 0){

          //退出页面时弹出弹窗
          this.$store.state.globeQuitShowDialog = true;

          if(this.$store.state.currChooseSceneItemId === ""){
            //新添加录制点位
            this.$utils.getNewId((newId)=>{
              // this.$store.state.scenePointNameIndex ++;
              let scenePointId = newId;   //新id
              let nameNum = this.$store.state.sceneList.length+1;
              this.$store.state.sceneList.push(
                  {
                    //基本信息
                    sceneId:scenePointId,
                    sceneCenter:[this.$store.state.tempViewPointList[0].lng,this.$store.state.tempViewPointList[0].lat],
                    sceneZoom:this.$store.state.tempViewPointList[0].zoom,
                    scenePitch:this.$store.state.tempViewPointList[0].pitch,
                    sceneBearing:this.$store.state.tempViewPointList[0].bearing,
                    sceneName: "录制点位"+nameNum,
                    sceneThumb: this.$store.state.tempViewPointList[0].viewThumb,
                    scenePicture: this.$store.state.tempViewPointList[0].viewPicture,

                    //录制点动画
                    pointAnimation:this.$store.state.tempViewPointList.length === 1 ? "无效果" : "平移跟踪",
                    pointAnimationParam:{
                      //单点
                      //螺旋凝视
                      rotate:{
                        direction:0,   //0逆时针，bearing加；1顺时针，bearing减
                        duration:5,
                        timeout:2,
                      },
                      //太空俯冲
                      slide:{
                        duration:5,
                        timeout:2,
                      },
                      //地球自转
                      earthRotation:{
                        direction:1,   //0逆时针，bearing加；1顺时针，bearing减
                        duration:5,
                        timeout:2,
                      },
                      //高空悬停
                      zoomSubAndHovering:{
                        duration:5,
                        timeout:2,
                      },
                      //螺旋环绕
                      zoomAddAndPitchAddAndRotate:{
                        direction:1,   //0逆时针，bearing加；1顺时针，bearing减
                        duration:15,
                        timeout:2,
                      },
                      //螺旋靠近
                      zoomAddAndPitchAddAndRotateZoomAdd:{
                        direction:1,   //0逆时针，bearing加；1顺时针，bearing减
                        zoomChange:2,   //靠近时zoom的变化大小（不使用）
                        duration:30,
                        timeout:2,
                      },
                      //俯冲环绕
                      zoomAddAndRotate:{
                        direction:1,   //0逆时针，bearing加；1顺时针，bearing减
                        zoomChange:4,   //俯冲高度（不使用）
                        duration:15,
                        timeout:2,
                      },
                      //俯冲观测
                      zoomAddAndHovering:{
                        zoomChange:4,   //俯冲高度
                        duration:5,
                        timeout:2,
                      },

                      //多点
                      //平移跟踪
                      route:{
                        duration:10,
                        timeout:2,
                      },
                      //侧向跟踪
                      flyByPathWithChangeBearing:{
                        duration:10,
                        timeout:2,
                      },
                      //空中游览
                      zoomAddAndFlyByPath:{
                        duration:15,
                        timeout:2,
                      },
                      //模拟驾驶
                      flyByPathWithWatchNextPoint:{
                        duration:30,
                        timeout:2,
                      },




                    },

                    //转场
                    flyAnimationShow:false,
                    flyAnimation:"平移",
                    flyAnimationParam:{
                      //跳跃
                      flyTo:{
                        duration:5,
                        minZoom:6,
                      },
                      //平移
                      easeTo:{
                        duration:5,
                      },
                      //切换
                      jumpTo:{
                        type:"淡出",
                        duration:5,
                      },

                      //新动效
                      //旋转跳跃
                      rotateAndFlyTo:{
                        duration:5,
                        minZoom:6,
                      },
                      //穿梭
                      easeToWithSpeed:{
                        duration:5,
                      },
                      //回太空
                      flyToBetweenGlobal:{
                        duration:5,
                      },


                      flyAnimationSmooth:true,   //转场效果平滑过渡
                    },

                    flyUpdate:false,   //拖拽带来的转场需要更新

                    //视野点
                    // viewPointNum:this.$store.state.tempViewPointList.length,
                    viewPointList:this.$store.state.tempViewPointList,
                    zoomBasis:this.$store.state.tempSceneZoomBasis,

                    //素材
                    materialInfo:{
                      materialMarkerUpdate:true,
                      materialList:this.$store.state.tempMaterialInfo.materialList,
                      //素材地图上图标数据
                      materialMarkerData:this.$store.state.defaultMaterialMarkerData,
                    }

                  },

              )

              this.isMaterialShow(()=>{
                //不选择任何录制点
                this.$store.state.currChooseSceneItemId = scenePointId;
                this.$store.state.currChooseSceneItemIndex = this.$store.state.sceneList.length - 1;
                this.$store.state.tempMaterialInfo = {
                  materialList:[],
                  materialMarkerData:this.$store.state.defaultMaterialMarkerData
                };
              })

              //清空临时视野点内容，地球上按钮等显隐
              this.$store.state.tempViewPointList = [];
              this.$store.state.tempSceneZoomBasis = "";
              this.$store.state.scenePointEditing = false;
              this.$store.state.sceneOperationState_addViewPointGuideState = "";

              switch(this.$store.state.sceneType){
                case "单点动画": case "地球动画":{
                  this.sceneGuideMantle_viewFinishBtnAvailable = false;
                  this.$store.state.sceneType = "自定义动画";
                  this.sceneGuideMantle_arrowShow = false;

                  break;
                }
                case "多点跳转":{
                  this.sceneGuideMantle_mapAvailable = false;
                  this.$store.state.sceneType = "自定义动画";
                  this.sceneGuideMantle_arrowShow = false;

                  break;
                }
                case "自定义动画":{

                  break;
                }



              }


              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "录制点位添加成功"
              this.$store.state.snackbarType = 'success'

            })
          }
          else{
            //编辑已有的录制点位

            //修改录制点信息
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneCenter = [this.$store.state.tempViewPointList[0].lng,this.$store.state.tempViewPointList[0].lat];
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneZoom = this.$store.state.tempViewPointList[0].zoom;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].scenePitch = this.$store.state.tempViewPointList[0].pitch;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneBearing = this.$store.state.tempViewPointList[0].bearing;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneThumb = this.$store.state.tempViewPointList[0].viewThumb
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].scenePicture = this.$store.state.tempViewPointList[0].viewPicture
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].zoomBasis = this.$store.state.tempSceneZoomBasis;
            //点位动效
            let oldViewPointNum = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length;
            let newViewPointNum = this.$store.state.tempViewPointList.length;
            if(oldViewPointNum > 1 && newViewPointNum === 1){
              //从多点变成单点
              this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].pointAnimation = "无效果";
            }
            if(oldViewPointNum === 1 && newViewPointNum > 1){
              //从单点变成多点
              this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].pointAnimation = "平移跟踪";
            }
            //其他情况依然是单点活多点，动效不变
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList = JSON.parse(JSON.stringify(this.$store.state.tempViewPointList));
            // this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointNum = this.$store.state.tempViewPointList.length

            //清空临时视野点内容，地球上按钮等显隐
            this.$store.state.tempViewPointList = [];
            this.$store.state.tempSceneZoomBasis = "";
            this.$store.state.scenePointEditing = false;
            this.$store.state.sceneOperationState_addViewPointGuideState = "";
          }


        }
        else{
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = "暂无视野点位添加"
          this.$store.state.snackbarType = 'error'
        }
      }
    },

    //通过点击推荐动效添加录制点完成
    addViewPointAndSetPointAnimation(pointAnimationName){
      let currScenePointNum = this.$store.state.sceneList.length;
      this.viewPointerListFinish();
      let temp = setInterval(()=>{
        if(this.$store.state.sceneList.length === currScenePointNum + 1){
          clearInterval(temp);
          this.$store.state.sceneList[this.$store.state.sceneList.length - 1].pointAnimation = pointAnimationName;
        }

      },200)
    },


    //使用！！视野点列表 取消
    //被各处调用取消编辑状态
    viewPointerListCancel(){
      this.cutScreening = false;
      this.$store.state.tempViewPointList = [];
      this.$store.state.tempSceneZoomBasis = [];
      this.$store.state.scenePointEditing = false;

      this.$store.state.sceneOperationState_addViewPointGuideState = "";

      if(this.$store.state.currChooseSceneItemIndex === ""){
        this.$store.state.sceneViewPointAreaShow = false;
        //素材不保留，解析空素材数据，即清空地图上素材标记
        if(this.$store.state.tempMaterialInfo.materialList.length !== 0){
          let materialInfo = {
            materialList:[],
            materialMarkerData:this.$store.state.defaultMaterialMarkerData
          }
          this.getMaterialMarkerData(materialInfo);
        }

      }

      //如果当前有引导蒙层，结束引导
      this.sceneGuideMantle_mapAvailable = false;
      this.sceneGuideMantle_viewFinishBtnAvailable = false;
      this.sceneGuideMantle_arrowShow = false;
      this.$store.state.sceneOperationState_addViewPointGuideState = "";

    },

    //使用！！点击视野点弹窗 新增点位按钮
    clickAddViewPointBtn(){
      this.isPreviewing(()=>{
        this.$store.state.tempViewPointList = JSON.parse(JSON.stringify(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList))
        this.$store.state.tempSceneZoomBasis = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].zoomBasis
        this.$store.state.scenePointEditing = true;
      })
    },

    //使用！！视野点弹窗在编辑状态，切换录制点的提示弹窗 确定
    viewEditNotSaveDialogOK(){
      this.$store.state.scenePointEditing = false;
      this.chooseNextSceneItem_notSaveDialogShow = false;

      //切换录制点
      this.map.flyTo({
        center: this.nextChooseSceneItem.sceneCenter,
        zoom: this.nextChooseSceneItem.sceneZoom,
        pitch: this.nextChooseSceneItem.scenePitch,
        bearing:this.nextChooseSceneItem.sceneBearing,
      })

      this.isMaterialShow(()=>{
        if(this.nextChooseSceneItemType === "sceneItem"){
          this.$store.state.currChooseSceneItemId = this.nextChooseSceneItem.sceneId;
          this.$store.state.currChooseSceneItemIndex = this.nextChooseSceneItemIndex;
        }
        else if(this.nextChooseSceneItemType === "flyAnimation"){
          this.$store.state.currChooseSceneItemId = this.nextChooseSceneItem.sceneId;
          this.$store.state.currChooseSceneItemIndex = this.nextChooseSceneItemIndex;
        }
      })


      this.$store.state.sceneOperationState_addViewPointGuideState = ""

      if(this.nextChooseSceneItemType === "sceneItem"){
        this.$store.state.currChooseViewItemId = "";
        this.$store.state.currChooseViewItemIndex = "";

        this.nextChooseSceneItem.flyAnimationShow = false;

        this.$store.state.sceneViewPointAreaShow = true;

        //显示地图上素材marker
        this.createMaterialMarkerLayer()
        this.$store.state.sceneViewMarkerShow = true;
      }
      else if(this.nextChooseSceneItemType === "flyAnimation"){
        this.nextChooseSceneItem.flyAnimationShow = true;
        if(this.nextChooseSceneItem.flyUpdate){
          this.nextChooseSceneItem.flyUpdate = false
        }

        this.$store.state.sceneViewPointAreaShow = false;

        //删除地图上素材marker
        this.clearMaterialMarkerLayer()
        this.$store.state.sceneViewMarkerShow = false;
      }




    },

    //使用！！视野点列表开关
    changeViewPointerListOpenState(){
      if(!this.viewPointerListOpen){
        this.materialListOpen = false;
      }
      this.viewPointerListOpen = !this.viewPointerListOpen
    },
    //使用！！素材栏开关
    changeMaterialOpenState(){
      if(!this.materialListOpen){
        this.viewPointerListOpen = false;
      }
      this.materialListOpen = !this.materialListOpen
    },



    //点击视野点列表中某项
    chooseViewItem(item){
      this.isPreviewing(()=>{
        this.$store.state.currChooseViewItemId = item.viewId;
        this.map.flyTo({
          center:[item.lng,item.lat],
          zoom:item.zoom,
          bearing:item.bearing,
          pitch:item.pitch
        })
      })
    },


    //点击球上的视野点
    clickSceneViewMarker(markerInfo){
      //视野点栏折叠，自动打开
      if(!this.viewPointerListOpen){
        this.changeViewPointerListOpenState()
      }

      //列表滚动到该位置
      setTimeout(()=>{
        let viewPointerList = this.$refs.viewPointerList;
        if(viewPointerList.scrollHeight > viewPointerList.clientHeight) {
          //获取要自动选中的视野点的index
          let currViewPointList = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList
              : this.$store.state.tempViewPointList;
          for(let i=0;i<currViewPointList.length;i++){
            if(currViewPointList[i].viewId === markerInfo.viewId){
              viewPointerList.scrollTop = i * 46;
              break;
            }
          }
        }
      },50)



      //和点击列表中的视野点效果相同
      this.chooseViewItem(markerInfo)
    },


    //设为基准zoom
    setZoomBasis(item){
      console.log(item)

      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      let currViewPointList;
      if(this.$store.state.scenePointEditing){
        currViewPointList = this.$store.state.tempViewPointList;
        this.$store.state.tempSceneZoomBasis = item.zoom;
      }
      else{
        currViewPointList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList;
        this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].zoomBasis = item.zoom;
      }

      for(let i=0;i<currViewPointList.length;i++){
        currViewPointList[i].isZoomBasis = false;
      }
      item.isZoomBasis = true;

      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = "参考视野已调整"
      this.$store.state.snackbarType = 'success'

    },

    //删除视野点
    deleteViewPoint(item,index){

      this.isPreviewing(()=>{

        console.log(index);

        if((!this.$store.state.scenePointEditing && this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length === 1)
            || (this.$store.state.scenePointEditing && this.$store.state.tempViewPointList.length === 1)){
          //仅剩余一个点，不能删除
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = "视野点不能为空"
          this.$store.state.snackbarType = 'error'
        }
        else{
          //退出页面时弹出弹窗
          this.$store.state.globeQuitShowDialog = true;

          let currViewPointList;
          if(this.$store.state.scenePointEditing){
            currViewPointList = this.$store.state.tempViewPointList;
          }
          else{
            currViewPointList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList;
          }

          //判断删除的点是否是zoom基准点
          let deleteZoomBasisPoint = false;
          if(item.isZoomBasis){
            deleteZoomBasisPoint = true;
          }
          currViewPointList.splice(index,1)
          //zoom基准点设为视野点列表中第一个点
          if(deleteZoomBasisPoint){
            currViewPointList[0].isZoomBasis = true;
            if(!this.$store.state.scenePointEditing){
              this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].zoomBasis = currViewPointList[0].zoom
            }
            else{
              this.$store.state.tempSceneZoomBasis = currViewPointList[0].zoom
            }
          }

          //删除的是当前选中的视野点
          if(this.$store.state.currChooseViewItemId === item.viewId){
            this.$store.state.currChooseViewItemId = ""
          }

          //操作已有的录制点 且不处于编辑状态，随时变更录制点信息
          if(this.$store.state.currChooseSceneItemId !== "" && !this.$store.state.scenePointEditing){
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneCenter =
                [this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[0].lng,this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[0].lat]
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneZoom =
                this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[0].zoom
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].scenePitch =
                this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[0].pitch
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneBearing =
                this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[0].bearing
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneThumb =
                this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[0].viewThumb;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].scenePicture =
                this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[0].viewPicture;


            // this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointNum =
            //     this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length;


            if(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length === 1){
              this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].pointAnimation = "无效果"
              // if(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[0].zoom <= 5){
              //   this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].pointAnimation = "地球自转"
              // }
              // else{
              //   this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].pointAnimation = "高空悬停"
              // }
            }

          }


          //修改素材的显示时间范围
          let currMaterialList = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList
              : this.$store.state.tempMaterialInfo.materialList
          console.log(index)
          for(let i=0;i<currMaterialList.length;i++){
            console.log(currMaterialList[i].showSet.timeRange)
            //逻辑：假设原本是3-5，删除3到5（包括3和5）变成3-4；删除1或2 变成2-4；删除6及以上 还是3-5
            if(currMaterialList[i].showSet.timeRange[0]<=index && currMaterialList[i].showSet.timeRange[1]>=index){
              if(currMaterialList[i].showSet.timeRange[0] === currMaterialList[i].showSet.timeRange[1]){
                //起始相同
                if(currMaterialList[i].showSet.timeRange[0] !==0){
                  //起始均不为0
                  currMaterialList[i].showSet.timeRange[0]--;
                  currMaterialList[i].showSet.timeRange[1]--;
                }
                else{
                  //起始为0

                }
              }
              else{
                currMaterialList[i].showSet.timeRange[1]--;
              }
            }
            else if(currMaterialList[i].showSet.timeRange[0]>index){

              currMaterialList[i].showSet.timeRange[0]--;
              currMaterialList[i].showSet.timeRange[1]--;
            }
            console.log(currMaterialList[i].showSet.timeRange)
          }

          //有素材显示弹窗展示，修改当前素材显示信息
          if(this.$store.state.setMaterialAreaShow){
            //时间轴不自动更新，强制更新
            this.$refs.setMaterialRangeSlider['_data'].lazyValue = this.$store.state.currChooseMaterialItem.showSet.timeRange;

            setTimeout(()=>{
              this.rangeSliderChangeFun()
            },50)
          }

          //如果在显示引导效果推荐，修改效果推荐列表
          if(this.$store.state.sceneOperationState_addViewPointRecommendedAnimationShow){
            if(currViewPointList.length === 1){
              //添加引导说明更改
              this.sceneRecommendedAnimationList = [
                {
                  picture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310131651000043808.jpg",
                  name:"螺旋凝视"
                },
                {
                  picture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310131651000043808.jpg",
                  name:"太空俯冲"
                },
              ]
            }
          }
          //在编辑中有引导，删除时引导提示变化
          if(this.$store.state.scenePointEditing && this.$store.state.sceneOperationState_addViewPointGuideState !== ""){
            switch(this.$store.state.sceneType){


              case "自定义动画":{
                if(currViewPointList.length === 1){
                  this.$store.state.sceneOperationState_addViewPointGuideState = 'viewPoint1';
                }
                break;
              }
            }

          }

        }

      })



    },



    //关闭视野点弹窗
    closeViewPointArea(){
      this.isMaterialShow(()=>{
        this.$store.state.currChooseSceneItemId = "";
        this.$store.state.currChooseSceneItemIndex = "";
      })

      this.$store.state.sceneViewPointAreaShow = false;
      //清除当前选择状态
      this.$store.state.currChooseViewItemId = "";
      this.$store.state.currChooseViewItemIndex = "";
      //地球上引导信息及按钮
      this.$store.state.scenePointEditing = false;
      this.$store.state.sceneOperationState_addViewPointGuideState = "";
      //隐藏地图上视野点标记？？？

    },

    //视野点拖拽排序
    //开始拖拽，记录被拖拽项的index
    viewPointItemDragstart(index) {
      this.viewPointItemDragIndex = index
    },
    //拖拽进入目标对象的效果，取消浏览器默认效果
    viewPointItemDragover(e, index) {
      e.preventDefault();
      this.viewPointItemEndIndex = index
      if(e.offsetY < 23){
        //鼠标在容器项的上半部分
        this.viewPointItemEndDirection = "top"
      }
      else{
        //鼠标在容器项的下半部分
        this.viewPointItemEndDirection = "bottom"
      }
    },
    //拖拽离开容器元素，去除拖拽中的效果
    viewPointItemDragleave(e, index){
      let currViewPointList;
      if(this.$store.state.scenePointEditing){
        currViewPointList = this.$store.state.tempViewPointList;
      }
      else{
        currViewPointList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList;
      }
      if(index === currViewPointList.length -1 && this.viewPointItemEndDirection === "bottom"){
        //离开最后一项的下方
        this.viewPointItemEndIndex = ""
        this.viewPointItemEndDirection = ""
      }
      else if(index === 0 && this.viewPointItemEndDirection === "top"){
        //离开第一项的上方
        this.viewPointItemEndIndex = ""
        this.viewPointItemEndDirection = ""
      }
    },
    //拖拽完成
    viewPointItemDragend(e,index){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      e.preventDefault();

      if(this.viewPointItemDragIndex !== index){
        //放置位置不是自身现在位置
        let currViewPointList;
        if(this.$store.state.scenePointEditing){
          currViewPointList = this.$store.state.tempViewPointList;
        }
        else{
          currViewPointList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList;
        }

        let currDragItem = currViewPointList[this.viewPointItemDragIndex]

        //被拖拽到第一位 或者被拖拽的是第一位  操作已有的录制点 且不处于编辑状态，随时更换配图
        if(index === 0){
          if(this.$store.state.currChooseSceneItemId !== "" && !this.$store.state.scenePointEditing){
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneCenter = [currDragItem.lng,currDragItem.lat];
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneZoom = currDragItem.zoom;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].scenePitch = currDragItem.pitch;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneBearing = currDragItem.bearing;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneThumb = currDragItem.viewThumb
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].scenePicture = currDragItem.viewPicture
          }
        }
        else if(this.viewPointItemDragIndex === 0){
          if(this.$store.state.currChooseSceneItemId !== "" && !this.$store.state.scenePointEditing){
            let firstItem = currViewPointList[0];
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneCenter = [firstItem.lng,firstItem.lat];
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneZoom = firstItem.zoom;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].scenePitch = firstItem.pitch;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneBearing = firstItem.bearing;
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].sceneThumb = firstItem.viewThumb
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].scenePicture = firstItem.viewPicture
          }
        }

        //列表里删除被拖拽元素
        currViewPointList.splice(this.viewPointItemDragIndex, 1);
        //在目标位置插入被拖拽元素
        if(index < this.viewPointItemDragIndex){
          //目标位置在被拖拽元素上方
          if(this.viewPointItemEndDirection === "top"){
            currViewPointList.splice(index,0,currDragItem)
          }
          else if(this.viewPointItemEndDirection === "bottom"){
            currViewPointList.splice(index+1,0,currDragItem)
          }
        }
        else if(index > this.viewPointItemDragIndex){
          //目标位置在被拖拽元素下方
          if(this.viewPointItemEndDirection === "top"){
            currViewPointList.splice(index-1,0,currDragItem)
          }
          else if(this.viewPointItemEndDirection === "bottom"){
            currViewPointList.splice(index,0,currDragItem)
          }
        }
        //拖拽完成，清空数据
        this.viewPointItemDragIndex = ""
        this.viewPointItemEndIndex = ""
        this.viewPointItemEndDirection = ""


      }
      else{
        //拖拽完成，清空数据
        this.viewPointItemDragIndex = ""
        this.viewPointItemEndIndex = ""
        this.viewPointItemEndDirection = ""

      }



    },

    //重命名视野点
    intoEditViewItemName(e,item){
      if(this.$store.state.currChooseViewItemId === item.viewId){

        //退出页面时弹出弹窗
        this.$store.state.globeQuitShowDialog = true;

        this.editViewItemNameShow = true;
        //该双击场景名称的下一个元素，是输入框
        let currTextFieldDom = e.target.nextSibling.querySelector("input")
        setTimeout(()=>{
          currTextFieldDom.focus()
          currTextFieldDom.select();
        },0)


      }
    },


    //视野点列表滚动条滚到最底部
    viewListScrollToBottom(){
      //滚动条自动滚动到底部
      let viewPointerList = this.$refs.viewPointerList;
      if(viewPointerList.scrollHeight > viewPointerList.clientHeight) {
        setTimeout(function(){
          //设置滚动条到最底部
          viewPointerList.scrollTop = viewPointerList.scrollHeight;
        },500);
      }
    },

    //素材列表滚动条滚到最底部
    materialListScrollToBottom(){
      //滚动条自动滚动到底部
      let viewPointerList = this.$refs.materialList;
      if(viewPointerList.scrollHeight > viewPointerList.clientHeight) {
        setTimeout(function(){
          //设置滚动条到最底部
          viewPointerList.scrollTop = viewPointerList.scrollHeight;
        },500);
      }
    },


    //素材///////////////////////////////////////////////////////////////////////////////////////////////////////////
    //素材图标
    getMaterialIcon(val){
      const map={
        "point":'&#xe677;',
        "lineString":'&#xe675;',
        "roadString":'&#xe679;',
        "circle":'&#xe67b;',
        "rectangle":'&#xe67a;',
        "polygon":'&#xe678;',
        "administrativeArea":'&#xe67c;',
        "folder":'&#xe64d;',
        "image":'&#xe6b1;'
      }
      return map[val]
    },


    //计算素材的配图里是否有图片
    isMaterialHasImage(propertiesImageList){
      let result = false;
      for(let i=0;i<propertiesImageList.length;i++){
        if(propertiesImageList[i].type === "image"){
          result = true;
          break;
        }
      }
      return result;
    },


    //添加素材成功
    addMaterialOK(){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      this.addSceneMaterialShow = false;

      if(this.map.getLayer('sceneMaterialPolygonLine') === undefined){
        console.log("创建素材图层")
        this.createMaterialMarkerLayer();
      }

      let currMaterialInfo = this.$store.state.currChooseSceneItemIndex !== ''
          ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo
          : this.$store.state.tempMaterialInfo;
      this.getMaterialMarkerData(currMaterialInfo);


      this.$store.state.snackbarShow=true;
      this.$store.state.snackbarText = "素材导入成功"
      this.$store.state.snackbarType = 'success';
    },
    //添加素材图片成功
    addMaterialImageOK(currMaterialImageInfo){
      console.log("添加图片素材成功")
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      console.log(this.map.getLayer('sceneMaterialPolygonLine'))
      if(this.map.getLayer('sceneMaterialPolygonLine') === undefined){
        console.log("创建素材图层")
        this.createMaterialMarkerLayer();
      }


      let currMaterialInfo = this.$store.state.currChooseSceneItemIndex !== ''
          ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo
          : this.$store.state.tempMaterialInfo;
      this.getMaterialMarkerData(currMaterialInfo);

      this.$store.state.snackbarShow=true;
      this.$store.state.snackbarText = "素材已添加至地图显示"
      this.$store.state.snackbarType = 'success';

      //选中新添加的素材
      this.clickMaterialItem(currMaterialImageInfo)

    },


    //重命名素材
    intoEditMaterialItemName(e,item){
      if(this.$store.state.currChooseMaterialItemId === item.id){

        //退出页面时弹出弹窗
        this.$store.state.globeQuitShowDialog = true;

        this.editMaterialItemNameShow = true;
        //该双击场景名称的下一个元素，是输入框
        let currTextFieldDom = e.target.nextSibling.querySelector("input")
        setTimeout(()=>{
          currTextFieldDom.focus()
          currTextFieldDom.select();
        },0)


      }
    },


    //显示素材地图图标的相关图层（点使用html，数据变化就会改变）
    createMaterialMarkerLayer(){
      console.log("显示marker")
      this.clearMaterialMarkerLayer()
      //点
      this.$store.state.sceneMaterialShow = true;
      //多边形边框+填充
      this.map.addSource('sceneMaterialPolygon',{
        type:"geojson",
        data:this.$store.state.currChooseSceneItemIndex !== ''
            ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygon
            : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygon
      })
      this.map.addLayer({
        id: 'sceneMaterialPolygonLine',
        type: 'line',
        source: 'sceneMaterialPolygon',
        // layout: {
        //   "visibility":'visible',
        // },
        filter:['==','totalVisible','visible'],
        paint: {
          'line-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "lineColor"],
            '#2A82E4'
          ],
          'line-width': [
            'match',
            ['get', 'defaultStyle'],
            'true', 4,
            'false', ["get", "width"],
            4
          ],
        }
      })
      this.map.addLayer({
        id: 'sceneMaterialPolygon',
        type: 'fill',
        source: 'sceneMaterialPolygon',
        // layout: {
        //   "visibility":'visible',
        // },
        filter:['==','totalVisible','visible'],
        paint: {
          'fill-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'fill-opacity': 0.5,
        }
      })
      //多边形点
      this.map.addSource('sceneMaterialPolygonPoint',{
        type:"geojson",
        data:this.$store.state.currChooseSceneItemIndex !== ''
            ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonPoint
            : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonPoint
      })
      this.map.addLayer({
        id: 'sceneMaterialPolygonPoint_circle',
        type: 'circle',
        source: 'sceneMaterialPolygonPoint',
        // layout: {
        //   "visibility":'visible',
        // },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint: {
          'circle-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'circle-radius': 5,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#ffffff'
        }
      })
      this.map.addLayer({
        id:'sceneMaterialPolygonPoint_text',
        type:'symbol',
        source: 'sceneMaterialPolygonPoint',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "bottom",
          "text-offset": [0,-0.8],
          // "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })
      //多边形名
      this.map.addSource('sceneMaterialPolygonName',{
        type:"geojson",
        data:this.$store.state.currChooseSceneItemIndex !== ''
            ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonName
            : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonName
      })
      this.map.addLayer({
        id:'sceneMaterialPolygonName',
        type:'symbol',
        source: 'sceneMaterialPolygonName',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "center",
          // "visibility":'visible'
        },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })

      //线+路线规划
      console.log("11111111111111111111111")
      this.map.addSource('sceneMaterialLine', {
        type: 'geojson',
        data: this.$store.state.currChooseSceneItemIndex !== ''
            ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.line
            : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.line
      });
      this.map.addLayer({
        id: 'sceneMaterialLine',
        type: 'line',
        source: 'sceneMaterialLine',
        filter:['==','totalVisible','visible'],
        paint: {
          'line-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'line-width': [
            'match',
            ['get', 'defaultStyle'],
            'true', 5,
            'false', ["get", "width"],
            5
          ],
          'line-opacity': 1
        }
      });
      //线点
      this.map.addSource('sceneMaterialLinePoint',{
        type:"geojson",
        data:this.$store.state.currChooseSceneItemIndex !== ''
            ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.linePoint
            : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.linePoint
      })
      this.map.addLayer({
        id: 'sceneMaterialLinePoint_circle',
        type: 'circle',
        source: 'sceneMaterialLinePoint',
        // layout:{
        //   "visibility":'visible',
        // },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint: {
          'circle-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'circle-radius': 5,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#ffffff'
        }
      });
      this.map.addLayer({
        id:'sceneMaterialLinePoint_text',
        type:'symbol',
        source: 'sceneMaterialLinePoint',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "bottom",
          "text-offset": [0,-0.8],
          // "visibility":'visible',
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
        },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })
      //线名
      this.map.addSource('sceneMaterialLineName',{
        type:"geojson",
        data:this.$store.state.currChooseSceneItemIndex !== ''
            ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.lineName
            : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.lineName
      })
      this.map.addLayer({
        id:'sceneMaterialLineName',
        type:'symbol',
        source: 'sceneMaterialLineName',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "top",
          "text-offset": [-1.3,1],
          // "visibility":'none',
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
        },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })


      //监听地图上marker的点击
      this.map.off('click','sceneMaterialPolygon',this.clickMaterialItem_mapLayer)
      this.map.on('click','sceneMaterialPolygon',this.clickMaterialItem_mapLayer)
      this.map.off('click','sceneMaterialLine',this.clickMaterialItem_mapLayer)
      this.map.on('click','sceneMaterialLine',this.clickMaterialItem_mapLayer)



      //选中素材的临时显示数据，实现在所有layer上层
      //多边形边框+填充
      this.map.addSource('sceneMaterialPolygon_currChooseMaterial',{
        type:"geojson",
        data:this.$store.state.currChooseMaterialMarkerData.polygonList.polygon
      })
      this.map.addLayer({
        id: 'sceneMaterialPolygon_currChooseMaterial',
        type: 'fill',
        source: 'sceneMaterialPolygon_currChooseMaterial',
        paint: {
          'fill-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'fill-opacity': 0.5,
        }
      })
      this.map.addLayer({
        id: 'sceneMaterialPolygonLine_currChooseMaterial',
        type: 'line',
        source: 'sceneMaterialPolygon_currChooseMaterial',
        paint: {
          'line-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "lineColor"],
            '#2A82E4'
          ],
          'line-width': [
            'match',
            ['get', 'defaultStyle'],
            'true', 4,
            'false', ["get", "width"],
            4
          ],
        }
      })
      //多边形点
      this.map.addSource('sceneMaterialPolygonPoint_currChooseMaterial',{
        type:"geojson",
        data:this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint
      })
      this.map.addLayer({
        id: 'sceneMaterialPolygonPoint_circle_currChooseMaterial',
        type: 'circle',
        source: 'sceneMaterialPolygonPoint_currChooseMaterial',
        // layout: {
        //   "visibility":'visible',
        // },
        filter:['==','visible','visible'],
        paint: {
          'circle-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'circle-radius': 5,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#ffffff'
        }
      })
      this.map.addLayer({
        id:'sceneMaterialPolygonPoint_text_currChooseMaterial',
        type:'symbol',
        source: 'sceneMaterialPolygonPoint_currChooseMaterial',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "bottom",
          "text-offset": [0,-0.8],
          // "visibility":'visible',
        },
        filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })
      //多边形名
      this.map.addSource('sceneMaterialPolygonName_currChooseMaterial',{
        type:"geojson",
        data:this.$store.state.currChooseMaterialMarkerData.polygonList.polygonName
      })
      this.map.addLayer({
        id:'sceneMaterialPolygonName_currChooseMaterial',
        type:'symbol',
        source: 'sceneMaterialPolygonName_currChooseMaterial',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "center",
          // "visibility":'visible',
        },
        filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })
      //线+路线规划
      this.map.addSource('sceneMaterialLine_currChooseMaterial', {
        type: 'geojson',
        data: this.$store.state.currChooseMaterialMarkerData.lineList.line
      });
      this.map.addLayer({
        id: 'sceneMaterialLine_currChooseMaterial',
        type: 'line',
        source: 'sceneMaterialLine_currChooseMaterial',
        // filter:['==','totalVisible','visible'],
        paint: {
          'line-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'line-width': [
            'match',
            ['get', 'defaultStyle'],
            'true', 5,
            'false', ["get", "width"],
            5
          ],
          'line-opacity': 1
        }
      });
      //线点
      this.map.addSource('sceneMaterialLinePoint_currChooseMaterial',{
        type:"geojson",
        data:this.$store.state.currChooseMaterialMarkerData.lineList.linePoint
      })
      this.map.addLayer({
        id: 'sceneMaterialLinePoint_circle_currChooseMaterial',
        type: 'circle',
        source: 'sceneMaterialLinePoint_currChooseMaterial',
        // layout:{
        //   "visibility":'visible',
        // },
        filter:['==','visible','visible'],
        paint: {
          'circle-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'circle-radius': 5,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#ffffff'
        }
      });
      this.map.addLayer({
        id:'sceneMaterialLinePoint_text_currChooseMaterial',
        type:'symbol',
        source: 'sceneMaterialLinePoint_currChooseMaterial',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "bottom",
          "text-offset": [0,-0.8],
          // "visibility":'visible',
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
        },
        filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })
      //线名
      this.map.addSource('sceneMaterialLineName_currChooseMaterial',{
        type:"geojson",
        data:this.$store.state.currChooseMaterialMarkerData.lineList.lineName
      })
      this.map.addLayer({
        id:'sceneMaterialLineName_currChooseMaterial',
        type:'symbol',
        source: 'sceneMaterialLineName_currChooseMaterial',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "top",
          "text-offset": [-1.3,1],
          // "visibility":'none',
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
        },
        filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })

    },
    createMaterialMarkerLayer_allShow(){
      console.log(this.$store.state.allShowMaterialMarkerData)
      //播放常显数据
      this.clearMaterialMarkerLayer_allShow()
      //点
      this.$store.state.sceneMaterialShow_allShow = true;
      //多边形边框+填充
      this.map.addSource('sceneMaterialPolygon_allShow',{
        type:"geojson",
        data:this.$store.state.allShowMaterialMarkerData.polygonList.polygon
      })
      this.map.addLayer({
        id: 'sceneMaterialPolygonLine_allShow',
        type: 'line',
        source: 'sceneMaterialPolygon_allShow',
        // layout: {
        //   "visibility":'visible',
        // },
        filter:['==','totalVisible','visible'],
        paint: {
          'line-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "lineColor"],
            '#2A82E4'
          ],
          'line-width': [
            'match',
            ['get', 'defaultStyle'],
            'true', 4,
            'false', ["get", "width"],
            4
          ],
        }
      })
      this.map.addLayer({
        id: 'sceneMaterialPolygon_allShow',
        type: 'fill',
        source: 'sceneMaterialPolygon_allShow',
        // layout: {
        //   "visibility":'visible',
        // },
        filter:['==','totalVisible','visible'],
        paint: {
          'fill-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'fill-opacity': 0.5,
        }
      })
      //多边形点
      this.map.addSource('sceneMaterialPolygonPoint_allShow',{
        type:"geojson",
        data:this.$store.state.allShowMaterialMarkerData.polygonList.polygonPoint
      })
      this.map.addLayer({
        id: 'sceneMaterialPolygonPoint_allShow_circle',
        type: 'circle',
        source: 'sceneMaterialPolygonPoint_allShow',
        // layout: {
        //   "visibility":'visible',
        // },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint: {
          'circle-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'circle-radius': 5,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#ffffff'
        }
      })
      this.map.addLayer({
        id:'sceneMaterialPolygonPoint_allShow_text',
        type:'symbol',
        source: 'sceneMaterialPolygonPoint_allShow',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "bottom",
          "text-offset": [0,-0.8],
          // "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })
      //多边形名
      this.map.addSource('sceneMaterialPolygonName_allShow',{
        type:"geojson",
        data:this.$store.state.allShowMaterialMarkerData.polygonList.polygonName
      })
      this.map.addLayer({
        id:'sceneMaterialPolygonName_allShow',
        type:'symbol',
        source: 'sceneMaterialPolygonName_allShow',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "center",
          // "visibility":'visible'
        },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })

      //线+路线规划
      this.map.addSource('sceneMaterialLine_allShow', {
        type: 'geojson',
        data: this.$store.state.allShowMaterialMarkerData.lineList.line
      });
      this.map.addLayer({
        id: 'sceneMaterialLine_allShow',
        type: 'line',
        source: 'sceneMaterialLine_allShow',
        filter:['==','totalVisible','visible'],
        paint: {
          'line-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'line-width': [
            'match',
            ['get', 'defaultStyle'],
            'true', 5,
            'false', ["get", "width"],
            5
          ],
          'line-opacity': 1
        }
      });
      //线点
      this.map.addSource('sceneMaterialLinePoint_allShow',{
        type:"geojson",
        data:this.$store.state.allShowMaterialMarkerData.lineList.linePoint
      })
      this.map.addLayer({
        id: 'sceneMaterialLinePoint_allShow_circle',
        type: 'circle',
        source: 'sceneMaterialLinePoint_allShow',
        // layout:{
        //   "visibility":'visible',
        // },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint: {
          'circle-color': [
            'match',
            ['get', 'defaultStyle'],
            'true', '#2A82E4',
            'false', ["get", "color"],
            '#2A82E4'
          ],
          'circle-radius': 5,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#ffffff'
        }
      });
      this.map.addLayer({
        id:'sceneMaterialLinePoint_allShow_text',
        type:'symbol',
        source: 'sceneMaterialLinePoint_allShow',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "bottom",
          "text-offset": [0,-0.8],
          // "visibility":'visible',
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
        },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })
      //线名
      this.map.addSource('sceneMaterialLineName_allShow',{
        type:"geojson",
        data:this.$store.state.allShowMaterialMarkerData.lineList.lineName
      })
      this.map.addLayer({
        id:'sceneMaterialLineName_allShow',
        type:'symbol',
        source: 'sceneMaterialLineName_allShow',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "top",
          "text-offset": [-1.3,1],
          // "visibility":'none',
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
        },
        // filter:['==','visible','visible'],
        filter:["all", ["==", 'visible', 'visible'], ["==", 'totalVisible', 'visible']],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })

    },

    //清除素材地图图标的相关图层
    clearMaterialMarkerLayer(){
      this.$store.state.sceneMaterialShow = false;
      if(this.map.getLayer("sceneMaterialPolygonLine")){
        this.map.removeLayer('sceneMaterialPolygonLine')
        this.map.removeLayer('sceneMaterialPolygon')
        this.map.removeSource('sceneMaterialPolygon')
      }
      if(this.map.getLayer("sceneMaterialPolygonPoint_circle")){
        this.map.removeLayer('sceneMaterialPolygonPoint_circle')
        this.map.removeLayer('sceneMaterialPolygonPoint_text')
        this.map.removeSource('sceneMaterialPolygonPoint')
      }
      if(this.map.getLayer("sceneMaterialPolygonName")){
        this.map.removeLayer('sceneMaterialPolygonName')
        this.map.removeSource('sceneMaterialPolygonName')
      }
      if(this.map.getLayer("sceneMaterialLine")){
        this.map.removeLayer('sceneMaterialLine')
        this.map.removeSource('sceneMaterialLine')
      }
      if(this.map.getLayer("sceneMaterialLinePoint_circle")){
        this.map.removeLayer('sceneMaterialLinePoint_circle')
        this.map.removeLayer('sceneMaterialLinePoint_text')
        this.map.removeSource('sceneMaterialLinePoint')
      }
      if(this.map.getLayer("sceneMaterialLineName")){
        this.map.removeLayer('sceneMaterialLineName')
        this.map.removeSource('sceneMaterialLineName')
      }

      //临时图层
      if(this.map.getLayer("sceneMaterialPolygonLine_currChooseMaterial")){
        this.map.removeLayer('sceneMaterialPolygonLine_currChooseMaterial')
        this.map.removeLayer('sceneMaterialPolygon_currChooseMaterial')
        this.map.removeSource('sceneMaterialPolygon_currChooseMaterial')
      }
      if(this.map.getLayer("sceneMaterialPolygonPoint_circle_currChooseMaterial")){
        this.map.removeLayer('sceneMaterialPolygonPoint_circle_currChooseMaterial')
        this.map.removeLayer('sceneMaterialPolygonPoint_text_currChooseMaterial')
        this.map.removeSource('sceneMaterialPolygonPoint_currChooseMaterial')
      }
      if(this.map.getLayer("sceneMaterialPolygonName_currChooseMaterial")){
        this.map.removeLayer('sceneMaterialPolygonName_currChooseMaterial')
        this.map.removeSource('sceneMaterialPolygonName_currChooseMaterial')
      }
      if(this.map.getLayer("sceneMaterialLine_currChooseMaterial")){
        this.map.removeLayer('sceneMaterialLine_currChooseMaterial')
        this.map.removeSource('sceneMaterialLine_currChooseMaterial')
      }
      if(this.map.getLayer("sceneMaterialLinePoint_circle_currChooseMaterial")){
        this.map.removeLayer('sceneMaterialLinePoint_circle_currChooseMaterial')
        this.map.removeLayer('sceneMaterialLinePoint_text_currChooseMaterial')
        this.map.removeSource('sceneMaterialLinePoint_currChooseMaterial')
      }
      if(this.map.getLayer("sceneMaterialLineName_currChooseMaterial")){
        this.map.removeLayer('sceneMaterialLineName_currChooseMaterial')
        this.map.removeSource('sceneMaterialLineName_currChooseMaterial')
      }

    },
    clearMaterialMarkerLayer_allShow(){
      //常显图层
      if(this.map.getLayer("sceneMaterialPolygonLine_allShow")){
        this.map.removeLayer('sceneMaterialPolygonLine_allShow')
        this.map.removeLayer('sceneMaterialPolygon_allShow')
        this.map.removeSource('sceneMaterialPolygon_allShow')
      }
      if(this.map.getLayer("sceneMaterialPolygonPoint_allShow_circle")){
        this.map.removeLayer('sceneMaterialPolygonPoint_allShow_circle')
        this.map.removeLayer('sceneMaterialPolygonPoint_allShow_text')
        this.map.removeSource('sceneMaterialPolygonPoint_allShow')
      }
      if(this.map.getLayer("sceneMaterialPolygonName_allShow")){
        this.map.removeLayer('sceneMaterialPolygonName_allShow')
        this.map.removeSource('sceneMaterialPolygonName_allShow')
      }
      if(this.map.getLayer("sceneMaterialLine_allShow")){
        this.map.removeLayer('sceneMaterialLine_allShow')
        this.map.removeSource('sceneMaterialLine_allShow')
      }
      if(this.map.getLayer("sceneMaterialLinePoint_allShow_circle")){
        this.map.removeLayer('sceneMaterialLinePoint_allShow_circle')
        this.map.removeLayer('sceneMaterialLinePoint_allShow_text')
        this.map.removeSource('sceneMaterialLinePoint_allShow')
      }
      if(this.map.getLayer("sceneMaterialLineName_allShow")){
        this.map.removeLayer('sceneMaterialLineName_allShow')
        this.map.removeSource('sceneMaterialLineName_allShow')
      }
    },


    //解析素材地图图标的相关数据
    getMaterialMarkerData(currMaterialInfo){
      console.log("更新素材marker数据")
      // console.log(currMaterialInfo)

      currMaterialInfo.materialMarkerUpdate = false;

      currMaterialInfo.materialMarkerData.pointList = [];
      currMaterialInfo.materialMarkerData.lineList = {
        line:{
          'type': 'FeatureCollection',
          'features': []
        },
        //线名
        lineName:{
          'type': 'FeatureCollection',
          'features': []
        },
        //线拐点
        linePoint:{
          'type': 'FeatureCollection',
          'features': []
        },
      };
      currMaterialInfo.materialMarkerData.polygonList = {
        //多边形
        polygon:{
          'type': 'FeatureCollection',
          'features': []
        },
        //多边形名
        polygonName:{
          'type': 'FeatureCollection',
          'features': []
        },
        //多边形拐点
        polygonPoint:{
          'type': 'FeatureCollection',
          'features': []
        },
      };
      currMaterialInfo.materialMarkerData.imageList = [];
      this.map.getSource('sceneMaterialLine').setData(currMaterialInfo.materialMarkerData.lineList.line)
      this.map.getSource('sceneMaterialLinePoint').setData(currMaterialInfo.materialMarkerData.lineList.linePoint)
      this.map.getSource('sceneMaterialLineName').setData(currMaterialInfo.materialMarkerData.lineList.lineName)
      this.map.getSource('sceneMaterialPolygon').setData(currMaterialInfo.materialMarkerData.polygonList.polygon)
      this.map.getSource('sceneMaterialPolygonPoint').setData(currMaterialInfo.materialMarkerData.polygonList.polygonPoint)
      this.map.getSource('sceneMaterialPolygonName').setData(currMaterialInfo.materialMarkerData.polygonList.polygonName)

      for(let i=0;i<currMaterialInfo.materialList.length;i++){

        switch(currMaterialInfo.materialList[i].type){
          case "point":{
            // currMaterialInfo.materialList[i].showSet.defaultStyle = true;
            // currMaterialInfo.materialList[i].showSet.showName = true;
            currMaterialInfo.materialMarkerData.pointList.push(currMaterialInfo.materialList[i])


            break;
          }
          case "lineString": case "roadString":{
            currMaterialInfo.materialList[i].geoJson.geo.properties.defaultStyle
                = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
            currMaterialInfo.materialList[i].geoJson.geo.properties.totalVisible
                = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
            currMaterialInfo.materialMarkerData.lineList.line.features.push(currMaterialInfo.materialList[i].geoJson.geo);
            this.map.getSource('sceneMaterialLine').setData(currMaterialInfo.materialMarkerData.lineList.line)

            console.log(currMaterialInfo.materialList[i].geoJson.points)
            for(let j=0;j<currMaterialInfo.materialList[i].geoJson.points.length;j++){
              currMaterialInfo.materialList[i].geoJson.points[j].properties.visible
                  = currMaterialInfo.materialList[i].showSet.showPoint ? 'visible' : 'none';
              currMaterialInfo.materialList[i].geoJson.points[j].properties.totalVisible
                  = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
              currMaterialInfo.materialList[i].geoJson.points[j].properties.defaultStyle
                  = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
              currMaterialInfo.materialMarkerData.lineList.linePoint.features.push(currMaterialInfo.materialList[i].geoJson.points[j])
            }
            console.log(currMaterialInfo.materialMarkerData.lineList.linePoint)
            this.map.getSource('sceneMaterialLinePoint').setData(currMaterialInfo.materialMarkerData.lineList.linePoint)

            console.log(currMaterialInfo.materialList[i].geoJson)
            currMaterialInfo.materialMarkerData.lineList.lineName.features.push({
              type: 'Feature',
              id: currMaterialInfo.materialList[i].geoJson.geo.id,
              geometry: {
                type:"Point",
                coordinates:currMaterialInfo.materialList[i].geoJson.geo.geometry.coordinates[0]
              },
              properties: {
                "name": currMaterialInfo.materialList[i].geoJson.geo.properties.name,
                "totalVisible":currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none',
                "visible":currMaterialInfo.materialList[i].showSet.showName ? 'visible' : 'none',
              },
            })
            this.map.getSource('sceneMaterialLineName').setData(currMaterialInfo.materialMarkerData.lineList.lineName)

            break;
          }
          case "circle": case "rectangle": case "polygon":{
            currMaterialInfo.materialList[i].geoJson.geo.properties.defaultStyle
                = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
            currMaterialInfo.materialList[i].geoJson.geo.properties.totalVisible
                = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
            currMaterialInfo.materialMarkerData.polygonList.polygon.features.push(currMaterialInfo.materialList[i].geoJson.geo);
            this.map.getSource('sceneMaterialPolygon').setData(currMaterialInfo.materialMarkerData.polygonList.polygon)

            for(let j=0;j<currMaterialInfo.materialList[i].geoJson.points.length;j++){
              currMaterialInfo.materialList[i].geoJson.points[j].properties.visible
                  = currMaterialInfo.materialList[i].showSet.showPoint ? 'visible' : 'none';
              currMaterialInfo.materialList[i].geoJson.points[j].properties.totalVisible
                  = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
              currMaterialInfo.materialList[i].geoJson.points[j].properties.defaultStyle
                  = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
              currMaterialInfo.materialMarkerData.polygonList.polygonPoint.features.push(currMaterialInfo.materialList[i].geoJson.points[j])
            }
            this.map.getSource('sceneMaterialPolygonPoint').setData(currMaterialInfo.materialMarkerData.polygonList.polygonPoint)

            currMaterialInfo.materialMarkerData.polygonList.polygonName.features.push({
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: currMaterialInfo.materialList[i].geoJson.geo.properties.center
              },
              id: currMaterialInfo.materialList[i].geoJson.geo.id,
              properties: {
                "name":currMaterialInfo.materialList[i].geoJson.geo.properties.name,
                "totalVisible":currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none',
                "visible":currMaterialInfo.materialList[i].showSet.showName ? 'visible' : 'none'
              },
            })
            this.map.getSource('sceneMaterialPolygonName').setData(currMaterialInfo.materialMarkerData.polygonList.polygonName)

            break;
          }
          case "image":{
            currMaterialInfo.materialMarkerData.imageList.push(currMaterialInfo.materialList[i])
            break;
          }


        }

      }
    },

    //解析素材地图图标的相关数据——播放，带素材动效
    getMaterialMarkerData_play(currMaterialInfo){
      console.log("更新素材marker数据 play")
      // console.log(currMaterialInfo)

      //临时 njh  没打开点位直接点击点位预览按钮，getSource('sceneMaterialLine').setData报错
      console.log(this.map.getSource('sceneMaterialLine'))
      if(this.map.getSource('sceneMaterialLine') == undefined){
        this.createMaterialMarkerLayer()
      }

      currMaterialInfo.materialMarkerUpdate = true;

      //显示该录制点的素材数据（常显数据除外）(线素材写在下面根据线动效开始延时等进行显示)
      currMaterialInfo.materialMarkerData.pointList = [];
      currMaterialInfo.materialMarkerData.lineList = {    //素材-线
        //线
        line:{
          'type': 'FeatureCollection',
          'features': []
        },
        //线名
        lineName:{
          'type': 'FeatureCollection',
          'features': []
        },
        //线拐点
        linePoint:{
          'type': 'FeatureCollection',
          'features': []
        },

      };
      currMaterialInfo.materialMarkerData.polygonList = {
        //多边形
        polygon:{
          'type': 'FeatureCollection',
          'features': []
        },
        //多边形名
        polygonName:{
          'type': 'FeatureCollection',
          'features': []
        },
        //多边形拐点
        polygonPoint:{
          'type': 'FeatureCollection',
          'features': []
        },

      };
      currMaterialInfo.materialMarkerData.imageList = [];
      this.map.getSource('sceneMaterialLine').setData(currMaterialInfo.materialMarkerData.lineList.line)
      this.map.getSource('sceneMaterialLinePoint').setData(currMaterialInfo.materialMarkerData.lineList.linePoint)
      this.map.getSource('sceneMaterialLineName').setData(currMaterialInfo.materialMarkerData.lineList.lineName)
      this.map.getSource('sceneMaterialPolygon').setData(currMaterialInfo.materialMarkerData.polygonList.polygon)
      this.map.getSource('sceneMaterialPolygonPoint').setData(currMaterialInfo.materialMarkerData.polygonList.polygonPoint)
      this.map.getSource('sceneMaterialPolygonName').setData(currMaterialInfo.materialMarkerData.polygonList.polygonName)

      for(let i=0;i<currMaterialInfo.materialList.length;i++){

        switch(currMaterialInfo.materialList[i].type){
          case "point":{
            //点不需要考虑动效，在marker中实现
            if(!currMaterialInfo.materialList[i].showSet.allShowInScenePoint){
              //需要等待点位延时
              currMaterialInfo.materialMarkerData.pointList.push(currMaterialInfo.materialList[i])
            }

            break;
          }
          case "lineString": case "roadString":{
            console.log(currMaterialInfo.materialList[i].showSet.timeRange)
            if(!currMaterialInfo.materialList[i].showSet.allShowInScenePoint){
              //不是在项目中常显 开始处理
              let materialLineAnimationSecondsInfo = this.getMaterialDataPlaySeconds(currMaterialInfo.materialList[i])
              console.log(materialLineAnimationSecondsInfo)
              if(materialLineAnimationSecondsInfo.showSeconds !== 0){
                //有显示时间
                let materialLineAnimationTemp = {
                  animationShowTemp:"",    //监听开始出现
                  animationingTemp:"",    //监听动画过程中
                  animationFinishTemp:"",    //监听隐藏延时
                }

                //监听开始动画前的秒数
                clearTimeout(materialLineAnimationTemp.animationShowTemp)
                materialLineAnimationTemp.animationShowTemp = setTimeout(()=>{

                  switch(currMaterialInfo.materialList[i].showSet.materialShowAnimation){
                    case "无":{
                      console.log("无动效")
                      //无动效，直接出现
                      currMaterialInfo.materialList[i].geoJson.geo.properties.defaultStyle
                          = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
                      currMaterialInfo.materialList[i].geoJson.geo.properties.totalVisible
                          = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
                      currMaterialInfo.materialMarkerData.lineList.line.features.push(currMaterialInfo.materialList[i].geoJson.geo);
                      this.map.getSource('sceneMaterialLine').setData(currMaterialInfo.materialMarkerData.lineList.line)

                      for(let j=0;j<currMaterialInfo.materialList[i].geoJson.points.length;j++){
                        currMaterialInfo.materialList[i].geoJson.points[j].properties.visible
                            = currMaterialInfo.materialList[i].showSet.showPoint ? 'visible' : 'none';
                        currMaterialInfo.materialList[i].geoJson.points[j].properties.totalVisible
                            = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
                        currMaterialInfo.materialList[i].geoJson.points[j].properties.defaultStyle
                            = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
                        currMaterialInfo.materialMarkerData.lineList.linePoint.features.push(currMaterialInfo.materialList[i].geoJson.points[j])
                      }
                      this.map.getSource('sceneMaterialLinePoint').setData(currMaterialInfo.materialMarkerData.lineList.linePoint)

                      console.log(currMaterialInfo.materialList[i])
                      currMaterialInfo.materialMarkerData.lineList.lineName.features.push({
                        type: 'Feature',
                        id: currMaterialInfo.materialList[i].geoJson.geo.id,
                        geometry: {
                          type:"Point",
                          coordinates:currMaterialInfo.materialList[i].geoJson.geo.geometry.coordinates[0]
                        },
                        properties: {
                          "name": currMaterialInfo.materialList[i].geoJson.geo.properties.name,
                          "totalVisible":currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none',
                          "visible":currMaterialInfo.materialList[i].showSet.showName ? 'visible' : 'none',
                        },
                      })
                      this.map.getSource('sceneMaterialLineName').setData(currMaterialInfo.materialMarkerData.lineList.lineName)

                      break;
                    }
                    case "沿线出现":{
                      //全部线标记数据，获取地球标记数据，按动效进行显示处理
                      currMaterialInfo.materialList[i].geoJson.geo.properties.defaultStyle
                          = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
                      currMaterialInfo.materialList[i].geoJson.geo.properties.totalVisible
                          = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
                      currMaterialInfo.materialList[i].geoJson.geo.properties.materialHide = false;
                      currMaterialInfo.materialMarkerData.lineList.line.features.push(currMaterialInfo.materialList[i].geoJson.geo);

                      for(let j=0;j<currMaterialInfo.materialList[i].geoJson.points.length;j++){
                        currMaterialInfo.materialList[i].geoJson.points[j].properties.visible
                            = currMaterialInfo.materialList[i].showSet.showPoint ? 'visible' : 'none';
                        currMaterialInfo.materialList[i].geoJson.points[j].properties.totalVisible
                            = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
                        currMaterialInfo.materialList[i].geoJson.points[j].properties.defaultStyle
                            = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
                        currMaterialInfo.materialMarkerData.lineList.linePoint.features.push(currMaterialInfo.materialList[i].geoJson.points[j])
                      }

                      currMaterialInfo.materialMarkerData.lineList.lineName.features.push({
                        type: 'Feature',
                        id: currMaterialInfo.materialList[i].geoJson.geo.id,
                        geometry: {
                          type:"Point",
                          coordinates:currMaterialInfo.materialList[i].geoJson.geo.geometry.coordinates[0]
                        },
                        properties: {
                          "name": currMaterialInfo.materialList[i].geoJson.geo.properties.name,
                          "totalVisible":'none',    //线名隐藏，等动画完成后显示
                          "visible":currMaterialInfo.materialList[i].showSet.showName ? 'visible' : 'none',
                        },
                      })
                      this.map.getSource('sceneMaterialLineName').setData(currMaterialInfo.materialMarkerData.lineList.lineName)


                      //开始该素材的沿线出现动效
                      //用于展示沿线出现动效的时间（隐藏时间-出现时间）
                      let showByLineDuration = materialLineAnimationSecondsInfo.animationHideSeconds-materialLineAnimationSecondsInfo.animationBeginSeconds;
                      //当录制点为多点位，且沿线出现的结束时刻在“结束”点时，需要删除录制点动效的离场时间
                      if(this.$store.state.sceneCurrPlayItem.viewPointList.length !== 1 && currMaterialInfo.materialList[i].showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
                        switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
                          case "空中游览":{
                            //该动效结束时有3秒离场时间
                            showByLineDuration = showByLineDuration - 3000;
                            break;
                          }
                          case "模拟驾驶":{
                            //该动效结束时有3秒离场时间
                            showByLineDuration = showByLineDuration - 3000;
                            break;
                          }

                        }
                      }
                      this.materialLineAnimation_showByLine(currMaterialInfo.materialList[i].id,currMaterialInfo.materialMarkerData.lineList,showByLineDuration)

                      break;
                    }

                  }

                },materialLineAnimationSecondsInfo.animationBeginSeconds)


                //监听动画隐藏前的秒数
                clearTimeout(materialLineAnimationTemp.animationFinishTemp)
                materialLineAnimationTemp.animationFinishTemp = setTimeout(()=>{
                  //隐藏线
                  for(let k=0;k<currMaterialInfo.materialMarkerData.lineList.line.features.length;k++){
                    //设置该素材线的隐藏为true，停止沿线出现动效
                    if(currMaterialInfo.materialMarkerData.lineList.line.features[k].id === currMaterialInfo.materialList[i].id){
                      currMaterialInfo.materialMarkerData.lineList.line.features[k].properties.materialHide = true;
                      currMaterialInfo.materialMarkerData.lineList.line.features[k].properties.totalVisible = "none";
                      break;
                    }
                  }
                  this.map.getSource('sceneMaterialLine').setData(currMaterialInfo.materialMarkerData.lineList.line)

                  //隐藏点
                  for(let k=0;k<currMaterialInfo.materialMarkerData.lineList.linePoint.features.length;k++){
                    if(currMaterialInfo.materialMarkerData.lineList.linePoint.features[k] !== undefined){
                      if(currMaterialInfo.materialMarkerData.lineList.linePoint.features[k].id === currMaterialInfo.materialList[i].id){
                        currMaterialInfo.materialMarkerData.lineList.linePoint.features[k].properties.totalVisible = "none";
                      }
                    }
                  }
                  this.map.getSource('sceneMaterialLinePoint').setData(currMaterialInfo.materialMarkerData.lineList.linePoint)

                  //隐藏名
                  for(let k=0;k<currMaterialInfo.materialMarkerData.lineList.lineName.features.length;k++){
                    if(currMaterialInfo.materialMarkerData.lineList.lineName.features[k].id === currMaterialInfo.materialList[i].id){
                      currMaterialInfo.materialMarkerData.lineList.lineName.features[k].properties.totalVisible = "none";
                      break;
                    }
                  }
                  this.map.getSource('sceneMaterialLineName').setData(currMaterialInfo.materialMarkerData.lineList.lineName)

                },materialLineAnimationSecondsInfo.animationHideSeconds)


                //监听录制点播放结束
                clearInterval(materialLineAnimationTemp.animationingTemp)
                materialLineAnimationTemp.animationingTemp = setInterval(()=>{
                  if(!this.sceneItemPlaying){
                    console.log("录制点播放结束")
                    clearInterval(materialLineAnimationTemp.animationingTemp)
                    clearTimeout(materialLineAnimationTemp.animationShowTemp)
                    clearTimeout(materialLineAnimationTemp.animationFinishTemp)
                  }

                },0)


              }
              else{
                //不显示

              }

            }

            break;
          }
          case "circle": case "rectangle": case "polygon":{
            if(!currMaterialInfo.materialList[i].showSet.allShowInScenePoint){
              //不是在项目中常显 开始处理
              let materialLineAnimationSecondsInfo = this.getMaterialDataPlaySeconds(currMaterialInfo.materialList[i])
              if(materialLineAnimationSecondsInfo.showSeconds !== 0){
                //有显示时间
                let materialLineAnimationTemp = {
                  animationShowTemp:"",    //监听开始出现
                  animationingTemp:"",    //监听动画过程中
                  animationFinishTemp:"",    //监听隐藏延时
                }

                //监听开始动画前的秒数
                clearTimeout(materialLineAnimationTemp.animationShowTemp)
                materialLineAnimationTemp.animationShowTemp = setTimeout(()=>{
                  //没有动画效果
                  currMaterialInfo.materialList[i].geoJson.geo.properties.defaultStyle
                      = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
                  currMaterialInfo.materialList[i].geoJson.geo.properties.totalVisible
                      = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
                  currMaterialInfo.materialMarkerData.polygonList.polygon.features.push(currMaterialInfo.materialList[i].geoJson.geo);
                  this.map.getSource('sceneMaterialPolygon').setData(currMaterialInfo.materialMarkerData.polygonList.polygon)

                  for(let j=0;j<currMaterialInfo.materialList[i].geoJson.points.length;j++){
                    currMaterialInfo.materialList[i].geoJson.points[j].properties.visible
                        = currMaterialInfo.materialList[i].showSet.showPoint ? 'visible' : 'none';
                    currMaterialInfo.materialList[i].geoJson.points[j].properties.totalVisible
                        = currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none';
                    currMaterialInfo.materialList[i].geoJson.points[j].properties.defaultStyle
                        = currMaterialInfo.materialList[i].showSet.defaultStyle ? 'true' : 'false';
                    currMaterialInfo.materialMarkerData.polygonList.polygonPoint.features.push(currMaterialInfo.materialList[i].geoJson.points[j])
                  }
                  this.map.getSource('sceneMaterialPolygonPoint').setData(currMaterialInfo.materialMarkerData.polygonList.polygonPoint)

                  currMaterialInfo.materialMarkerData.polygonList.polygonName.features.push({
                    type: 'Feature',
                    geometry: {
                      type: 'Point',
                      coordinates: currMaterialInfo.materialList[i].geoJson.geo.properties.center
                    },
                    id: currMaterialInfo.materialList[i].geoJson.geo.id,
                    properties: {
                      "name":currMaterialInfo.materialList[i].geoJson.geo.properties.name,
                      "totalVisible":currMaterialInfo.materialList[i].showSet.totalVisible ? 'visible' : 'none',
                      "visible":currMaterialInfo.materialList[i].showSet.showName ? 'visible' : 'none'
                    },
                  })
                  this.map.getSource('sceneMaterialPolygonName').setData(currMaterialInfo.materialMarkerData.polygonList.polygonName)

                },materialLineAnimationSecondsInfo.animationBeginSeconds)

                //监听动画隐藏前的秒数
                clearTimeout(materialLineAnimationTemp.animationFinishTemp)
                materialLineAnimationTemp.animationFinishTemp = setTimeout(()=>{
                  console.log("素材隐藏")
                  //隐藏面和边框
                  for(let k=0;k<currMaterialInfo.materialMarkerData.polygonList.polygon.features.length;k++){
                    //设置该素材线的隐藏为true，停止沿线出现动效
                    if(currMaterialInfo.materialMarkerData.polygonList.polygon.features[k].id === currMaterialInfo.materialList[i].id){
                      currMaterialInfo.materialMarkerData.polygonList.polygon.features[k].properties.totalVisible = false;
                      break;
                    }
                  }
                  this.map.getSource('sceneMaterialPolygon').setData(currMaterialInfo.materialMarkerData.polygonList.polygon)

                  //隐藏点
                  for(let k=0;k<currMaterialInfo.materialMarkerData.polygonList.polygonPoint.features.length;k++){
                    if(currMaterialInfo.materialMarkerData.polygonList.polygonPoint.features[k].id === currMaterialInfo.materialList[i].id){
                      currMaterialInfo.materialMarkerData.polygonList.polygonPoint.features[k].properties.totalVisible = "none";
                    }
                  }
                  this.map.getSource('sceneMaterialPolygonPoint').setData(currMaterialInfo.materialMarkerData.polygonList.polygonPoint)

                  //隐藏名
                  for(let k=0;k<currMaterialInfo.materialMarkerData.polygonList.polygonPoint.features.length;k++){
                    if(currMaterialInfo.materialMarkerData.polygonList.polygonPoint.features[k].id === currMaterialInfo.materialList[i].id){
                      currMaterialInfo.materialMarkerData.polygonList.polygonPoint.features[k].properties.totalVisible = "none";
                      break;
                    }
                  }
                  this.map.getSource('sceneMaterialPolygonName').setData(currMaterialInfo.materialMarkerData.polygonList.polygonPoint)


                },materialLineAnimationSecondsInfo.animationHideSeconds)


                //监听录制点播放结束
                clearInterval(materialLineAnimationTemp.animationingTemp)
                materialLineAnimationTemp.animationingTemp = setInterval(()=>{
                  if(!this.sceneItemPlaying){
                    console.log("录制点播放结束")
                    clearInterval(materialLineAnimationTemp.animationingTemp)
                    clearTimeout(materialLineAnimationTemp.animationShowTemp)
                    clearTimeout(materialLineAnimationTemp.animationFinishTemp)
                  }

                },0)
              }

            }


            break;
          }
          case "image":{
            if(!currMaterialInfo.materialList[i].showSet.allShowInScenePoint){
              currMaterialInfo.materialMarkerData.imageList.push(currMaterialInfo.materialList[i])
            }

            break;
          }


        }

      }

    },
    //获取素材动效的显示秒信息
    getMaterialDataPlaySeconds(currMaterialInfo){
      let materialAnimationSecondsInfo = {
        animationBeginSeconds:0,   //开始时的秒数  ms
        showSeconds:0,   //持续显示的秒数  ms
        animationHideSeconds:0,   //隐藏时的秒数  ms
      }

      if(this.$store.state.sceneCurrPlayItem.viewPointList.length === 1){
        //单点录制点，showSet的timeRange必须是[0,1]才会显示，时间范围从录制点开始直到动画结束
        // if(currMaterialInfo.showSet.timeRange[0] === 0 && currMaterialInfo.showSet.timeRange[1] === 1){

        //单点录制点，考虑动效有进场和离场，showSet的timeRange可以是[0,0]或[0,1]
        if(currMaterialInfo.showSet.timeRange[0] === 0){
          //素材的开始动画前秒数为进场动画秒数
          //素材的显示秒数即录制点动效持续时间（加延时时间？）- 进场动画秒数
          //素材动效结束秒数，当素材动效结束点在最后一个视野点时，即录制点动效持续时间（加延时时间？）- 离场动画秒数；当素材动效结束点在“结束”时，即录制点动效持续时间（加延时时间？）
          switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
            case "螺旋凝视":{
              materialAnimationSecondsInfo.animationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.rotate.timeout * 1000;
              materialAnimationSecondsInfo.animationHideSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.rotate.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.rotate.timeout) * 1000
              break;
            }
            case "太空俯冲":{
              materialAnimationSecondsInfo.animationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.slide.timeout * 1000;
              materialAnimationSecondsInfo.animationHideSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.slide.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.slide.timeout) * 1000
              break;
            }
            case "地球自转":{
              materialAnimationSecondsInfo.animationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.earthRotation.timeout * 1000;
              materialAnimationSecondsInfo.animationHideSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.earthRotation.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.earthRotation.timeout) * 1000
              break;
            }
            case "高空悬停":{
              //进场动效1秒
              materialAnimationSecondsInfo.animationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomSubAndHovering.timeout * 1000 + 1000;
              materialAnimationSecondsInfo.animationHideSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomSubAndHovering.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomSubAndHovering.timeout) * 1000
              break;
            }
            case "螺旋环绕":{
              materialAnimationSecondsInfo.animationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.timeout * 1000;
              materialAnimationSecondsInfo.animationHideSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.timeout) * 1000
              break;
            }
            case "螺旋靠近":{
              materialAnimationSecondsInfo.animationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.timeout * 1000;
              materialAnimationSecondsInfo.animationHideSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.timeout) * 1000
              break;
            }
            case "俯冲环绕":{
              //进场动效5秒
              materialAnimationSecondsInfo.animationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndRotate.timeout * 1000 + 5000;
              materialAnimationSecondsInfo.animationHideSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndRotate.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndRotate.timeout) * 1000
              break;
            }
            case "俯冲观测":{
              //进场动效800毫秒，离场动效800毫秒
              materialAnimationSecondsInfo.animationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.timeout * 1000 + 800;
              if(currMaterialInfo.showSet.timeRange[1] === 1){
                //素材动效在“结束”点位停止
                materialAnimationSecondsInfo.animationHideSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.timeout) * 1000
              }
              else{
                //素材动效在视野点位停止，需要去除离场时间
                materialAnimationSecondsInfo.animationHideSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.timeout) * 1000 - 800
              }
              break;
            }

          }
          materialAnimationSecondsInfo.showSeconds = materialAnimationSecondsInfo.animationHideSeconds - materialAnimationSecondsInfo.animationBeginSeconds

        }
      }
      else{
        //多录制点
        if(currMaterialInfo.showSet.timeRange[0] !== currMaterialInfo.showSet.timeRange[1]){
          //有显示时间
          if(currMaterialInfo.showSet.timeRange[0] === this.$store.state.sceneCurrPlayItem.viewPointList.length-1
              && currMaterialInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
            //时间范围是最后一个视野点开始到结束，平移跟踪效果中最后一个视野点没有时间，所以等于没有显示时间

          }
          else{
            //有正常显示范围
            console.log(currMaterialInfo.showSet.timeRange)

            //路线动画总时长 无进场离场的动效即为设置的时间
            let routeDuration;
            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "平移跟踪":{
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.route.duration * 1000;
                break;
              }
              case "侧向跟踪":{
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithChangeBearing.duration * 1000;
                break;
              }
              case "空中游览":{
                //该动效开头有2秒调整zoom，所有点位结束后有3秒延时
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndFlyByPath.duration * 1000 - 5000;
                break;
              }
              case "模拟驾驶":{
                //该动效开头有2秒调整zoom，所有点位结束后有3秒延时
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithWatchNextPoint.duration * 1000 - 5000;
                break;
              }

            }

            //总路线长度
            let routePoints = [];
            for(let i=0;i<this.$store.state.sceneCurrPlayItem.viewPointList.length;i++){
              routePoints.push([this.$store.state.sceneCurrPlayItem.viewPointList[i].lng,this.$store.state.sceneCurrPlayItem.viewPointList[i].lat])
            }
            let routeDistance = turf.lineDistance(turf.lineString(routePoints));

            //开始动画视野点距初始点的长度
            if(currMaterialInfo.showSet.timeRange[0] !== 0){
              let routePointsBeginAnimation = [];
              for(let i=0;i<=currMaterialInfo.showSet.timeRange[0];i++){
                routePointsBeginAnimation.push([this.$store.state.sceneCurrPlayItem.viewPointList[i].lng,this.$store.state.sceneCurrPlayItem.viewPointList[i].lat])
              }
              let routeDistanceBeginAnimation = turf.lineDistance(turf.lineString(routePointsBeginAnimation));
              //根据比例计算 路线进行到开始动画视野点的时长，即开始动画前的秒数
              materialAnimationSecondsInfo.animationBeginSeconds = routeDistanceBeginAnimation / routeDistance * routeDuration;

              switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
                case "空中游览":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  materialAnimationSecondsInfo.animationBeginSeconds = materialAnimationSecondsInfo.animationBeginSeconds + 2000;
                  break;
                }
                case "模拟驾驶":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  materialAnimationSecondsInfo.animationBeginSeconds = materialAnimationSecondsInfo.animationBeginSeconds + 2000;
                  break;
                }

              }
            }
            else{
              //开始动画在0秒就开始
              switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
                case "空中游览":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  materialAnimationSecondsInfo.animationBeginSeconds = 2000;
                  break;
                }
                case "模拟驾驶":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  materialAnimationSecondsInfo.animationBeginSeconds = 2000;
                  break;
                }
              }
            }

            //开始时间前需要加上延时
            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "平移跟踪":{
                materialAnimationSecondsInfo.animationBeginSeconds = materialAnimationSecondsInfo.animationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.route.timeout * 1000
                break;
              }
              case "侧向跟踪":{
                materialAnimationSecondsInfo.animationBeginSeconds = materialAnimationSecondsInfo.animationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithChangeBearing.timeout * 1000
                break;
              }
              case "空中游览":{
                materialAnimationSecondsInfo.animationBeginSeconds = materialAnimationSecondsInfo.animationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndFlyByPath.timeout * 1000
                break;
              }
              case "模拟驾驶":{
                materialAnimationSecondsInfo.animationBeginSeconds = materialAnimationSecondsInfo.animationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithWatchNextPoint.timeout * 1000
                break;
              }

            }


            //结束动画视野点距初始点的长度
            let routePointsEndAnimation = [];
            let routePointsEndAnimationNum;
            if(currMaterialInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
              //在 结束 点
              routePointsEndAnimationNum = currMaterialInfo.showSet.timeRange[1]-1
            }
            // else if(currMaterialInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
            //   //在 最后一个视野点
            //   routePointsEndAnimationNum = currMaterialInfo.showSet.timeRange[1]-1
            // }
            else{
              routePointsEndAnimationNum = currMaterialInfo.showSet.timeRange[1]
            }
            for(let i=0;i<=routePointsEndAnimationNum;i++){
              routePointsEndAnimation.push([this.$store.state.sceneCurrPlayItem.viewPointList[i].lng,this.$store.state.sceneCurrPlayItem.viewPointList[i].lat])
            }
            let routeDistanceEndAnimation = turf.lineDistance(turf.lineString(routePointsEndAnimation));
            //根据比例计算 路线进行到结束动画视野点的时长，即结束动画结束时的秒数
            materialAnimationSecondsInfo.animationHideSeconds = routeDistanceEndAnimation / routeDistance * routeDuration;

            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "空中游览":{
                //该动效开头有2秒延时，最后一个视野点到结束有3秒离场
                if(currMaterialInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
                  //动效显示时间段截止到结束点，需要在最后一个视野点的时间基础上增加开场延时+离场时间
                  materialAnimationSecondsInfo.animationHideSeconds = materialAnimationSecondsInfo.animationHideSeconds + 5000;
                }
                else{
                  //动效显示时间段截止到某视野点，需要在最后一个视野点的时间基础上增加开场延时
                  materialAnimationSecondsInfo.animationHideSeconds = materialAnimationSecondsInfo.animationHideSeconds + 2000;
                }

                break;
              }
              case "模拟驾驶":{
                //该动效开头有2秒延时，最后一个视野点到结束有3秒离场
                if(currMaterialInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
                  //动效显示时间段截止到结束点，需要在最后一个视野点的时间基础上增加开场延时+离场时间
                  materialAnimationSecondsInfo.animationHideSeconds = materialAnimationSecondsInfo.animationHideSeconds + 5000;
                }
                else{
                  //动效显示时间段截止到某视野点，需要在最后一个视野点的时间基础上增加开场延时
                  materialAnimationSecondsInfo.animationHideSeconds = materialAnimationSecondsInfo.animationHideSeconds + 2000;
                }

                break;
              }

            }

            //结束时间前需要加上延时
            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "平移跟踪":{
                materialAnimationSecondsInfo.animationHideSeconds = materialAnimationSecondsInfo.animationHideSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.route.timeout * 1000
                break;
              }
              case "侧向跟踪":{
                materialAnimationSecondsInfo.animationHideSeconds = materialAnimationSecondsInfo.animationHideSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithChangeBearing.timeout * 1000
                break;
              }
              case "空中游览":{
                materialAnimationSecondsInfo.animationHideSeconds = materialAnimationSecondsInfo.animationHideSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndFlyByPath.timeout * 1000
                break;
              }
              case "模拟驾驶":{
                materialAnimationSecondsInfo.animationHideSeconds = materialAnimationSecondsInfo.animationHideSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithWatchNextPoint.timeout * 1000
                break;
              }

            }



            //素材显示时间
            materialAnimationSecondsInfo.showSeconds = materialAnimationSecondsInfo.animationHideSeconds - materialAnimationSecondsInfo.animationBeginSeconds

          }



        }



      }

      return materialAnimationSecondsInfo;
    },

    //素材线动效-沿线出现
    //第二个参数是该素材线的地球标记数据
    materialLineAnimation_showByLine(currLineId,materialMarkerDataLineList,animationDuration){
      //展示小车
      // this.sceneRoute3DModelShow = true;

      let lineIndex;   //该线在 标记数据-线 中的index
      let routes;   //该线的全部点位
      for(let i=0;i<materialMarkerDataLineList.line.features.length;i++){
        if(materialMarkerDataLineList.line.features[i].id === currLineId){
          lineIndex = i;
          routes = materialMarkerDataLineList.line.features[i].geometry.coordinates;
          break;
        }
      }

      //标记数据-线的第lineIndex项（即本线），仅保留第一个点
      let firstCoordinate = materialMarkerDataLineList.line.features[lineIndex].geometry.coordinates[0]
      materialMarkerDataLineList.line.features[lineIndex].geometry.coordinates = [];
      materialMarkerDataLineList.line.features[lineIndex].geometry.coordinates.push(firstCoordinate)
      this.map.getSource('sceneMaterialLine').setData(materialMarkerDataLineList.line)

      const routeDistance = turf.lineDistance(turf.lineString(routes));   //总路线长度

      //计算素材线上各点到起点的长度，在循环中判断线出现到的点距起点的长度，如果比某点到起点长度大，说明已经过某点
      const pointsDistance = [0];    //各点到起点的长度


      for(let i=1;i<routes.length;i++){
        let currRoute = routes.slice(0,i+1);
        pointsDistance.push(turf.lineDistance(turf.lineString(currRoute)))
      }
      let routeFinishPointIndex = 0;   //已经过的点
      //清空素材线的点中属于当前线的点展示，再插入属于此线的第一个点
      let linePointFeatures = []
      for(let i=materialMarkerDataLineList.linePoint.features.length-1;i>=0;i--){
        if(materialMarkerDataLineList.linePoint.features[i].id === currLineId){
          linePointFeatures.unshift(materialMarkerDataLineList.linePoint.features[i])
          materialMarkerDataLineList.linePoint.features.splice(i,1);
        }
      }
      this.map.getSource('sceneMaterialLinePoint').setData(materialMarkerDataLineList.linePoint)


      let start;
      let _this = this
      function frame(time) {
        if (!start) start = time;

        const phase = (time - start) / animationDuration;    //进度

        //线 沿线显示
        const alongRoute = turf.along(
            turf.lineString(routes),
            routeDistance * phase
        ).geometry.coordinates;
        materialMarkerDataLineList.line.features[lineIndex].geometry.coordinates.push(alongRoute);
        _this.map.getSource('sceneMaterialLine').setData(materialMarkerDataLineList.line)

        //小车动效
        // _this.sceneRoute3DModelCurrentPosition = alongRoute

        //当前经过第几个拐点，出现第几个拐点
        if(routeDistance * phase >= pointsDistance[routeFinishPointIndex]){
          // console.log("经过第"+routeFinishPointIndex+"个点")
          if(linePointFeatures[routeFinishPointIndex] !== undefined){
            materialMarkerDataLineList.linePoint.features.push(linePointFeatures[routeFinishPointIndex])
            _this.map.getSource('sceneMaterialLinePoint').setData(materialMarkerDataLineList.linePoint)
            routeFinishPointIndex++
          }
        }





        //_this.sceneItemPlaying用于判断是否录制点播放完成，如果完成停止内部素材的动效
        //materialHide是该素材是否应该隐藏了
        if(!_this.previewAnimationFrameStop && phase <= 1 && _this.sceneItemPlaying
            && !materialMarkerDataLineList.line.features[lineIndex].properties.materialHide){
          //继续预览，且进度没到1时，重复过程
          window.requestAnimationFrame(frame);
        }
        else{
          //隐藏小车
          // _this.sceneRoute3DModelShow = false;

          if(!_this.previewAnimationFrameStop && phase > 1 && _this.sceneItemPlaying
              && !materialMarkerDataLineList.line.features[lineIndex].properties.materialHide){
            //线出现完成，录制点动画仍在继续，显示线名
            for(let i=0;i<materialMarkerDataLineList.lineName.features.length;i++){
              if(materialMarkerDataLineList.lineName.features[i].id === currLineId){
                materialMarkerDataLineList.lineName.features[i].properties.totalVisible = 'visible';
                break;
              }
            }
            _this.map.getSource('sceneMaterialLineName').setData(materialMarkerDataLineList.lineName)
          }

        }
        // else if(!_this.previewAnimationFrameStop){
        //   // console.log("飞行结束")
        //   if(finishFun !== undefined){
        //     clearTimeout(_this.previewTemp)
        //     _this.previewTemp = setTimeout(()=>{
        //       finishFun()
        //     },0)
        //   }
        // }

      }

      window.requestAnimationFrame(frame);

    },



    //获取项目中常显素材的信息，在播放的解析地图数据中使用
    getAllShowInSceneMaterialMarkerData(){

      this.$store.state.allShowMaterialMarkerData = {
        pointList:[],
        lineList:{    //素材-线
          //线
          line:{
            'type': 'FeatureCollection',
            'features': []
          },
          //线名
          lineName:{
            'type': 'FeatureCollection',
            'features': []
          },
          //线拐点
          linePoint:{
            'type': 'FeatureCollection',
            'features': []
          },

        },
        polygonList:{
          //多边形
          polygon:{
            'type': 'FeatureCollection',
            'features': []
          },
          //多边形名
          polygonName:{
            'type': 'FeatureCollection',
            'features': []
          },
          //多边形拐点
          polygonPoint:{
            'type': 'FeatureCollection',
            'features': []
          },

        },
        imageList:[],

      }

      let allShowInSceneNum = 0;

      for(let j=0;j<this.$store.state.sceneList.length;j++){
        //当前录制点的素材信息
        let currMaterialInfo = this.$store.state.sceneList[j].materialInfo;
        //存储常显的素材信息
        for(let i=0;i<currMaterialInfo.materialList.length;i++){
          switch(currMaterialInfo.materialList[i].type){
            case "point":{
              if(currMaterialInfo.materialList[i].showSet.allShowInScenePoint){
                allShowInSceneNum++;
                // this.playMaterialInfo.materialMarkerData.pointList.push(currMaterialInfo.materialList[i])
                let currItem = JSON.parse(JSON.stringify(currMaterialInfo.materialList[i]))
                let newId = currItem.id + "_" + Date.parse(new Date())
                this.$set(currItem,'id',newId);
                this.$set(currItem.geoJson.geo,'id',newId);
                this.$set(currItem.geoJson.geo.properties,'id',newId);
                this.$store.state.allShowMaterialMarkerData.pointList.push(currItem)

              }

              break;
            }
            case "lineString": case "roadString":{
              if(currMaterialInfo.materialList[i].showSet.allShowInScenePoint){
                allShowInSceneNum++
                let currItem = JSON.parse(JSON.stringify(currMaterialInfo.materialList[i]))

                let newId = currItem.id + "_" + Date.parse(new Date())
                this.$set(currItem,'id',newId);
                this.$set(currItem.geoJson.geo,'id',newId);
                this.$set(currItem.geoJson.geo.properties,'id',newId);
                if(currItem.geoJson.points.length !== 0){
                  for(let k=0;k<currItem.geoJson.points.length;k++){
                    this.$set(currItem.geoJson.points[k],'id',newId);
                  }
                }

                //修改属性值
                currItem.geoJson.geo.properties.defaultStyle
                    = currItem.showSet.defaultStyle ? 'true' : 'false';
                currItem.geoJson.geo.properties.totalVisible
                    = currItem.showSet.totalVisible ? 'visible' : 'none';
                this.$store.state.allShowMaterialMarkerData.lineList.line.features.push(currItem.geoJson.geo);

                for(let j=0;j<currItem.geoJson.points.length;j++){
                  currItem.geoJson.points[j].properties.visible
                      = currItem.showSet.showPoint ? 'visible' : 'none';
                  currItem.geoJson.points[j].properties.totalVisible
                      = currItem.showSet.totalVisible ? 'visible' : 'none';
                  currItem.geoJson.points[j].properties.defaultStyle
                      = currItem.showSet.defaultStyle ? 'true' : 'false';
                  this.$store.state.allShowMaterialMarkerData.lineList.linePoint.features.push(currItem.geoJson.points[j])
                }

                this.$store.state.allShowMaterialMarkerData.lineList.lineName.features.push({
                  type: 'Feature',
                  id: currItem.geoJson.geo.id,
                  geometry: {
                    type:"Point",
                    coordinates:currItem.geoJson.geo.geometry.coordinates[0]
                  },
                  properties: {
                    "name": currItem.geoJson.geo.properties.name,
                    "totalVisible":currItem.showSet.totalVisible ? 'visible' : 'none',
                    "visible":currItem.showSet.showName ? 'visible' : 'none',
                  },
                })

              }

              break;
            }
            case "circle": case "rectangle": case "polygon":{
              if(currMaterialInfo.materialList[i].showSet.allShowInScenePoint){
                allShowInSceneNum++

                let currItem = JSON.parse(JSON.stringify(currMaterialInfo.materialList[i]))

                let newId = currItem.id + "_" + Date.parse(new Date())
                this.$set(currItem,'id',newId);
                this.$set(currItem.geoJson.geo,'id',newId);
                this.$set(currItem.geoJson.geo.properties,'id',newId);
                if(currItem.geoJson.points.length !== 0){
                  for(let k=0;k<currItem.geoJson.points.length;k++){
                    this.$set(currItem.geoJson.points[k],'id',newId);
                  }
                }

                currItem.geoJson.geo.properties.defaultStyle
                    = currItem.showSet.defaultStyle ? 'true' : 'false';
                currItem.geoJson.geo.properties.totalVisible
                    = currItem.showSet.totalVisible ? 'visible' : 'none';
                this.$store.state.allShowMaterialMarkerData.polygonList.polygon.features.push(currItem.geoJson.geo);

                for(let j=0;j<currItem.geoJson.points.length;j++){
                  currItem.geoJson.points[j].properties.visible
                      = currItem.showSet.showPoint ? 'visible' : 'none';
                  currItem.geoJson.points[j].properties.totalVisible
                      = currItem.showSet.totalVisible ? 'visible' : 'none';
                  currItem.geoJson.points[j].properties.defaultStyle
                      = currItem.showSet.defaultStyle ? 'true' : 'false';
                  this.$store.state.allShowMaterialMarkerData.polygonList.polygonPoint.features.push(currItem.geoJson.points[j])
                }

                this.$store.state.allShowMaterialMarkerData.polygonList.polygonName.features.push({
                  type: 'Feature',
                  geometry: {
                    type: 'Point',
                    coordinates: currItem.geoJson.geo.properties.center
                  },
                  id: currItem.geoJson.geo.id,
                  properties: {
                    "name":currItem.geoJson.geo.properties.name,
                    "totalVisible":currItem.showSet.totalVisible ? 'visible' : 'none',
                    "visible":currItem.showSet.showName ? 'visible' : 'none'
                  },
                })

              }

              break;
            }
            case "image":{
              if(currMaterialInfo.materialList[i].showSet.allShowInScenePoint){
                allShowInSceneNum++
                let currItem = JSON.parse(JSON.stringify(currMaterialInfo.materialList[i]))

                let newId = currItem.id + "_" + Date.parse(new Date())
                this.$set(currItem,'id',newId);
                this.$set(currItem.geoJson.geo,'id',newId);
                this.$set(currItem.geoJson.geo.properties,'id',newId);
                this.$store.state.allShowMaterialMarkerData.imageList.push(currItem)

              }
              break;
            }
          }
        }
      }

      let temp = setInterval(()=>{
        if(this.$store.state.allShowMaterialMarkerData.pointList.length
            + this.$store.state.allShowMaterialMarkerData.lineList.line.features.length
            + this.$store.state.allShowMaterialMarkerData.polygonList.polygon.features.length
            + this.$store.state.allShowMaterialMarkerData.imageList.length
            === allShowInSceneNum){
          clearInterval(temp)

          //数据全部处理完成
          this.map.getSource('sceneMaterialLine_allShow').setData(this.$store.state.allShowMaterialMarkerData.lineList.line)
          this.map.getSource('sceneMaterialLinePoint_allShow').setData(this.$store.state.allShowMaterialMarkerData.lineList.linePoint)
          this.map.getSource('sceneMaterialLineName_allShow').setData(this.$store.state.allShowMaterialMarkerData.lineList.lineName)
          this.map.getSource('sceneMaterialPolygon_allShow').setData(this.$store.state.allShowMaterialMarkerData.polygonList.polygon)
          this.map.getSource('sceneMaterialPolygonPoint_allShow').setData(this.$store.state.allShowMaterialMarkerData.polygonList.polygonPoint)
          this.map.getSource('sceneMaterialPolygonName_allShow').setData(this.$store.state.allShowMaterialMarkerData.polygonList.polygonName)

        }

      },100)


    },




    //隐藏某素材的地图标记
    hideMaterialMarker(currMaterialItem){
      switch(currMaterialItem.type){
        case "point":{

          break;
        }
        case "lineString": case "roadString":{
          currMaterialItem.showSet.totalVisible = false;
          //线
          let currLineListLine = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.line
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.line;
          for(let i=0;i<currLineListLine.features.length;i++){
            if(currLineListLine.features[i].id === currMaterialItem.id){
              currLineListLine.features[i].properties.totalVisible = "none";
              break;
            }
          }
          this.map.getSource('sceneMaterialLine').setData(currLineListLine)
          //线点
          let currLineListLinePoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.linePoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.linePoint;
          for(let i=currLineListLinePoint.features.length-1;i>=0;i--){
            if(currLineListLinePoint.features[i].id === currMaterialItem.id){
              currLineListLinePoint.features[i].properties.totalVisible = "none";
            }
          }
          this.map.getSource('sceneMaterialLinePoint').setData(currLineListLinePoint)
          //多边形名
          let currLineListName = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.lineName
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.lineName;
          for(let i=0;i<currLineListName.features.length;i++){
            if(currLineListName.features[i].id === currMaterialItem.id){
              currLineListName.features[i].properties.totalVisible = "none";
              break;
            }
          }
          this.map.getSource('sceneMaterialLineName').setData(currLineListName)


          break;
        }
        case "circle": case "rectangle": case "polygon":{
          currMaterialItem.showSet.totalVisible = false;
          //多边形填充+边框
          let currPolygonListPolygon = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygon
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygon;
          for(let i=0;i<currPolygonListPolygon.features.length;i++){
            if(currPolygonListPolygon.features[i].id === currMaterialItem.id){
              currPolygonListPolygon.features[i].properties.totalVisible = "none";
              break;
            }
          }
          this.map.getSource('sceneMaterialPolygon').setData(currPolygonListPolygon)
          //多边形点
          let currPolygonListPolygonPoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonPoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonPoint;
          for(let i=currPolygonListPolygonPoint.features.length-1;i>=0;i--){
            if(currPolygonListPolygonPoint.features[i].id === currMaterialItem.id){
              currPolygonListPolygonPoint.features[i].properties.totalVisible = "none";
            }
          }
          this.map.getSource('sceneMaterialPolygonPoint').setData(currPolygonListPolygonPoint)
          //多边形名
          let currPolygonListName = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonName
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonName;
          for(let i=0;i<currPolygonListName.features.length;i++){
            if(currPolygonListName.features[i].id === currMaterialItem.id){
              currPolygonListName.features[i].properties.totalVisible = "none";
              break;
            }
          }
          this.map.getSource('sceneMaterialPolygonName').setData(currPolygonListName)

          break;
        }


      }

    },

    //显示选中素材的置顶地图标记
    showChooseMaterialMarker(currMaterialItem){
      switch(currMaterialItem.type){
        case "point": case "image":{
          currMaterialItem.showSet.showTop = true;
          break;
        }
        case "lineString": case "roadString":{
          //线
          this.$store.state.currChooseMaterialMarkerData.lineList.line.features = [];
          let currLineListPolygon = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.line
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.line;
          for(let i=0;i<currLineListPolygon.features.length;i++){
            if(currLineListPolygon.features[i].id === currMaterialItem.id){
              this.$store.state.currChooseMaterialMarkerData.lineList.line.features.push(
                  JSON.parse(JSON.stringify(currLineListPolygon.features[i]))
              )
              break;
            }
          }
          this.map.getSource('sceneMaterialLine_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.line)
          //线点
          this.$store.state.currChooseMaterialMarkerData.lineList.linePoint.features = [];
          let currLineListLinePoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.linePoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.linePoint;
          for(let i=currLineListLinePoint.features.length-1;i>=0;i--){
            if(currLineListLinePoint.features[i].id === currMaterialItem.id){
              this.$store.state.currChooseMaterialMarkerData.lineList.linePoint.features.push(
                  JSON.parse(JSON.stringify(currLineListLinePoint.features[i]))
              )
            }
          }
          this.map.getSource('sceneMaterialLinePoint_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.linePoint)
          //线名
          this.$store.state.currChooseMaterialMarkerData.lineList.lineName.features = [];
          let currLineListName = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.lineName
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.lineName;
          for(let i=0;i<currLineListName.features.length;i++){
            if(currLineListName.features[i].id === currMaterialItem.id){
              console.log(currLineListName.features[i])
              this.$store.state.currChooseMaterialMarkerData.lineList.lineName.features.push(
                  JSON.parse(JSON.stringify(currLineListName.features[i]))
              )
              break;
            }
          }
          this.map.getSource('sceneMaterialLineName_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.lineName)

          break;
        }
        case "circle": case "rectangle": case "polygon":{
          //多边形填充+边框
          this.$store.state.currChooseMaterialMarkerData.polygonList.polygon.features = [];
          let currPolygonListPolygon = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygon
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygon;
          for(let i=0;i<currPolygonListPolygon.features.length;i++){
            if(currPolygonListPolygon.features[i].id === currMaterialItem.id){
              this.$store.state.currChooseMaterialMarkerData.polygonList.polygon.features.push(
                  JSON.parse(JSON.stringify(currPolygonListPolygon.features[i]))
              )
              break;
            }
          }
          this.map.getSource('sceneMaterialPolygon_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygon)
          //多边形点
          this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint.features = [];
          let currPolygonListPolygonPoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonPoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonPoint;
          for(let i=currPolygonListPolygonPoint.features.length-1;i>=0;i--){
            if(currPolygonListPolygonPoint.features[i].id === currMaterialItem.id){
              this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint.features.push(
                  JSON.parse(JSON.stringify(currPolygonListPolygonPoint.features[i]))
              )
            }
          }
          this.map.getSource('sceneMaterialPolygonPoint_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint)
          //多边形名
          this.$store.state.currChooseMaterialMarkerData.polygonList.polygonName.features = [];
          let currPolygonListName = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonName
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonName;
          for(let i=0;i<currPolygonListName.features.length;i++){
            if(currPolygonListName.features[i].id === currMaterialItem.id){
              console.log(currPolygonListName.features[i])
              this.$store.state.currChooseMaterialMarkerData.polygonList.polygonName.features.push(
                  JSON.parse(JSON.stringify(currPolygonListName.features[i]))
              )
              break;
            }
          }
          this.map.getSource('sceneMaterialPolygonName_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygonName)

          break;
        }


      }

    },

    //隐藏置顶地图标记
    hideChooseMaterialMarker(){
      switch(this.$store.state.currChooseMaterialItem.type){
        case "point": case "image":{
          this.$store.state.currChooseMaterialItem.showSet.showTop = false;
          break;
        }
        case "lineString": case "roadString":{
          //清空临时图层
          this.$store.state.currChooseMaterialMarkerData.lineList.line.features = [];
          this.$store.state.currChooseMaterialMarkerData.lineList.linePoint.features = [];
          this.$store.state.currChooseMaterialMarkerData.lineList.lineName.features = [];
          this.map.getSource('sceneMaterialLine_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.line)
          this.map.getSource('sceneMaterialLinePoint_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.linePoint)
          this.map.getSource('sceneMaterialLineName_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.lineName)

          break;
        }
        case "circle": case "rectangle": case "polygon":{
          //清空临时图层
          this.$store.state.currChooseMaterialMarkerData.polygonList.polygon.features = [];
          this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint.features = [];
          this.$store.state.currChooseMaterialMarkerData.polygonList.polygonName.features = [];
          this.map.getSource('sceneMaterialPolygon_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygon)
          this.map.getSource('sceneMaterialPolygonPoint_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint)
          this.map.getSource('sceneMaterialPolygonName_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygonName)

          break;
        }
      }
    },

    //恢复上次置顶标记的正常显示
    showMaterialMarker(){
      switch(this.$store.state.currChooseMaterialItem.type){
        case "point":{

          break;
        }
        case "lineString": case "roadString":{
          this.$store.state.currChooseMaterialItem.showSet.totalVisible = true;
          //线
          let currLineListLine = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.line
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.line;
          for(let i=0;i<currLineListLine.features.length;i++){
            if(currLineListLine.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currLineListLine.features[i].properties.totalVisible = "visible";
              break;
            }
          }
          this.map.getSource('sceneMaterialLine').setData(currLineListLine)
          //线点
          let currLineListLinePoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.linePoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.linePoint;
          for(let i=currLineListLinePoint.features.length-1;i>=0;i--){
            if(currLineListLinePoint.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currLineListLinePoint.features[i].properties.totalVisible = "visible";
            }
          }
          this.map.getSource('sceneMaterialLinePoint').setData(currLineListLinePoint)
          //线名
          let currLineListName = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.lineName
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.lineName;
          for(let i=0;i<currLineListName.features.length;i++){
            if(currLineListName.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currLineListName.features[i].properties.totalVisible = "visible";
              break;
            }
          }
          this.map.getSource('sceneMaterialLineName').setData(currLineListName)


          break;
        }
        case "circle": case "rectangle": case "polygon":{
          this.$store.state.currChooseMaterialItem.showSet.totalVisible = true;
          //多边形填充+边框
          let currPolygonListPolygon = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygon
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygon;
          for(let i=0;i<currPolygonListPolygon.features.length;i++){
            if(currPolygonListPolygon.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currPolygonListPolygon.features[i].properties.totalVisible = "visible";
              break;
            }
          }
          this.map.getSource('sceneMaterialPolygon').setData(currPolygonListPolygon)
          //多边形点
          let currPolygonListPolygonPoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonPoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonPoint;
          for(let i=currPolygonListPolygonPoint.features.length-1;i>=0;i--){
            if(currPolygonListPolygonPoint.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currPolygonListPolygonPoint.features[i].properties.totalVisible = "visible";
            }
          }
          this.map.getSource('sceneMaterialPolygonPoint').setData(currPolygonListPolygonPoint)
          //多边形名
          let currPolygonListName = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonName
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonName;
          for(let i=0;i<currPolygonListName.features.length;i++){
            if(currPolygonListName.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currPolygonListName.features[i].properties.totalVisible = "visible";
              break;
            }
          }
          this.map.getSource('sceneMaterialPolygonName').setData(currPolygonListName)

          break;
        }

      }
    },


    //点击素材列表中某项
    chooseMaterialItem(item){

      this.isPreviewing(()=>{

        //根据上次选中的素材类型，清除上次选中样式
        this.hideChooseMaterialMarker();
        this.showMaterialMarker();

        this.$store.state.currChooseMaterialItem = item;
        this.$store.state.currChooseMaterialItemId = item.id;
        let currMaterialList;
        if(this.$store.state.currChooseSceneItemIndex !== ''){
          currMaterialList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList
        }
        else{
          currMaterialList = this.$store.state.tempMaterialInfo.materialList
        }
        for(let i=0;i<currMaterialList.length;i++){
          if(currMaterialList[i].id === item.id){
            this.$store.state.currChooseMaterialItemIndex = i;
            break;
          }
        }

        //创建被选中时置顶的临时图层
        this.showChooseMaterialMarker(item);
        //隐藏底图上该项素材的正常图层
        this.hideMaterialMarker(item);


        this.$store.state.setMaterialAreaShow = true;
        setTimeout(()=>{
          this.rangeSliderChangeFun()
        },50)


        // let _this = this;
        const bbox = turf.bbox(item.geoJson.geo)
        this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]],{
          linear: false,
          animate: true,
          padding: {top: 120, bottom:130, left: 190, right: 500},
          // easing(t) {
          //   if(t === 1){
          //     _this.$store.state.setMaterialAreaShow = true;
          //   }
          //   return t
          // }
        })


      })


    },

    //点击地图上的素材图标方法
    clickMaterialItem(materialItemInfo){
      if(!this.materialListOpen){
        this.changeMaterialOpenState();
      }

      //列表滚动到该位置
      setTimeout(()=>{
        let materialList = this.$refs.materialList;
        if(materialList.scrollHeight > materialList.clientHeight){
          let currMaterialList;
          if(this.$store.state.currChooseSceneItemIndex !== ''){
            currMaterialList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList
          }
          else{
            currMaterialList = this.$store.state.tempMaterialInfo.materialList
          }
          for(let i=0;i<currMaterialList.length;i++){
            if(currMaterialList[i].id === materialItemInfo.id){
              materialList.scrollTop = i * 35 + 4;
              break;
            }
          }
        }
      },50)


      this.chooseMaterialItem(materialItemInfo)

    },
    //点击地图上的素材图标 图层，需要转一下参数再调用clickMaterialItem
    clickMaterialItem_mapLayer(e){
      let materialId = e.features[0].properties.id;
      let currMaterialList;
      if(this.$store.state.currChooseSceneItemIndex !== ''){
        currMaterialList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList
      }
      else{
        currMaterialList = this.$store.state.tempMaterialInfo.materialList
      }
      for(let i=0;i<currMaterialList.length;i++){
        if(currMaterialList[i].id === materialId){
          this.clickMaterialItem(currMaterialList[i])
          break;
        }
      }
    },


    //素材重新定位
    resetMaterialItemPosition(item){

      this.isPreviewing(()=>{
        //退出页面时弹出弹窗
        this.$store.state.globeQuitShowDialog = true;

        this.$store.state.setMaterialAreaShow = false;

        this.$store.state.snackbarType = 'info'
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "选择素材目标地图区域"

        this.resetMaterialItemPositionItem = item;   //不直接使用item，避免再点击下一个点的重新定位按钮时，有stop没有调用点击屏幕，然后导致两个点都被移动

        this.map.getCanvas().style.cursor = 'crosshair';
        document.getElementById("labelCanvas").style.cursor = 'crosshair';



        this.map.once("click",(e)=>{
          if(this.resetMaterialItemPositionItem !== ""){
            this.map.getCanvas().style.cursor = '';
            document.getElementById("labelCanvas").style.cursor = '';
            //修改列表数据
            this.resetMaterialItemPositionItem.geoJson.geo.geometry.coordinates = [e.lngLat.lng,e.lngLat.lat];
            //修改地图marker数据
            let currMaterialPointList;
            if(this.$store.state.currChooseSceneItemIndex !== ''){
              currMaterialPointList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.pointList
            }
            else{
              currMaterialPointList = this.$store.state.tempMaterialInfo.materialMarkerData.pointList
            }
            for(let i=0;i<currMaterialPointList.length;i++){
              if(currMaterialPointList[i].id === this.resetMaterialItemPositionItem.id){
                currMaterialPointList[i].geoJson.geo.geometry.coordinates = [e.lngLat.lng,e.lngLat.lat];
                break;
              }
            }
          }
        })

        //点击屏幕任意位置，退出定位状态
        document.addEventListener('click',()=>{
          this.map.getCanvas().style.cursor = '';
          document.getElementById("labelCanvas").style.cursor = '';
          this.resetMaterialItemPositionItem = ""
        }, {once:true});

      })



    },
    //图片素材重新定位
    resetMaterialItemPosition_image(item){

      this.isPreviewing(()=>{
        //退出页面时弹出弹窗
        this.$store.state.globeQuitShowDialog = true;

        this.$store.state.setMaterialAreaShow = false;

        this.$store.state.snackbarType = 'info'
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "选择素材目标地图区域"

        //展示选择图片素材中
        this.$store.state.sceneMaterialImageAddingDataList = [];
        this.$store.state.sceneMaterialImageAddingDataList.push(
            {
              thumbUrl:item.geoJson.geo.properties.thumbUrl,
              name:item.geoJson.geo.properties.fileName,
              id:item.id
            }
        )
        this.$store.state.sceneMaterialImageAdding = true;
      })



    },


    //素材删除
    deleteMaterialItem(item,index){
      if(this.$store.state.sceneMaterialImageAdding){
        //正在定位图片素材
        this.$store.state.sceneMaterialImageAddingDataList = [];
        this.$store.state.sceneMaterialImageAdding = false;
      }
      if(this.resetMaterialItemPositionItem !== ''){
        //正在定位点素材
        this.map.getCanvas().style.cursor = '';
        document.getElementById("labelCanvas").style.cursor = '';
        this.resetMaterialItemPositionItem = ""
      }

      this.isPreviewing(()=>{
        //退出页面时弹出弹窗
        this.$store.state.globeQuitShowDialog = true;

        //修改列表数据
        let currMaterialList;
        if(this.$store.state.currChooseSceneItemIndex !== ''){
          currMaterialList = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList
        }
        else{
          currMaterialList = this.$store.state.tempMaterialInfo.materialList
        }
        currMaterialList.splice(index,1);

        //修改地图marker数据
        let currMaterialMarkerData;
        if(this.$store.state.currChooseSceneItemIndex !== ''){
          currMaterialMarkerData = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData
        }
        else{
          currMaterialMarkerData = this.$store.state.tempMaterialInfo.materialMarkerData
        }
        switch(item.type){
          case "point":{
            for(let i=0;i<currMaterialMarkerData.pointList.length;i++){
              if(currMaterialMarkerData.pointList[i].id === item.id){
                currMaterialMarkerData.pointList.splice(i,1)
                break;
              }
            }
            break;
          }
          case "lineString": case "roadString":{
            //线
            for(let i=0;i<currMaterialMarkerData.lineList.line.features.length;i++){
              if(currMaterialMarkerData.lineList.line.features[i].id === item.id){
                currMaterialMarkerData.lineList.line.features.splice(i,1);
                this.map.getSource('sceneMaterialLine').setData(currMaterialMarkerData.lineList.line)
                break;
              }
            }
            //线点
            for(let i=currMaterialMarkerData.lineList.linePoint.features.length-1;i>=0;i--){
              if(currMaterialMarkerData.lineList.linePoint.features[i].id === item.id){
                currMaterialMarkerData.lineList.linePoint.features.splice(i,1);
                this.map.getSource('sceneMaterialLinePoint').setData(currMaterialMarkerData.lineList.linePoint)
              }
            }
            //线名
            for(let i=0;i<currMaterialMarkerData.lineList.lineName.features.length;i++){
              if(currMaterialMarkerData.lineList.lineName.features[i].id === item.id){
                currMaterialMarkerData.lineList.lineName.features.splice(i,1);
                this.map.getSource('sceneMaterialLineName').setData(currMaterialMarkerData.lineList.lineName)
                break;
              }
            }

            break;
          }
          case "circle": case "rectangle": case "polygon":{
            //多边形填充+边框
            for(let i=0;i<currMaterialMarkerData.polygonList.polygon.features.length;i++){
              if(currMaterialMarkerData.polygonList.polygon.features[i].id === item.id){
                currMaterialMarkerData.polygonList.polygon.features.splice(i,1);
                this.map.getSource('sceneMaterialPolygon').setData(currMaterialMarkerData.polygonList.polygon)
                break;
              }
            }
            //多边形点
            for(let i=currMaterialMarkerData.polygonList.polygonPoint.features.length-1;i>=0;i--){
              if(currMaterialMarkerData.polygonList.polygonPoint.features[i].id === item.id){
                currMaterialMarkerData.polygonList.polygonPoint.features.splice(i,1);
                this.map.getSource('sceneMaterialPolygonPoint').setData(currMaterialMarkerData.polygonList.polygonPoint)
              }
            }
            //多边形名
            for(let i=0;i<currMaterialMarkerData.polygonList.polygonName.features.length;i++){
              if(currMaterialMarkerData.polygonList.polygonName.features[i].id === item.id){
                currMaterialMarkerData.polygonList.polygonName.features.splice(i,1);
                this.map.getSource('sceneMaterialPolygonName').setData(currMaterialMarkerData.polygonList.polygonName)
                break;
              }
            }

            break;
          }
          case "image":{
            for(let i=0;i<currMaterialMarkerData.imageList.length;i++){
              if(currMaterialMarkerData.imageList[i].id === item.id){
                currMaterialMarkerData.imageList.splice(i,1)
                break;
              }
            }
            break;

          }

        }

        if(item.id === this.$store.state.currChooseMaterialItemId){
          //要删除的是当前选中的素材
          this.$store.state.setMaterialAreaShow = false;
        }


      })




    },

    //素材添加视野点
    addMaterialItemToViewPoint(item){
      if(this.$store.state.sceneMaterialImageAdding){
        //正在定位图片素材
        this.$store.state.sceneMaterialImageAddingDataList = [];
        this.$store.state.sceneMaterialImageAdding = false;
      }
      if(this.resetMaterialItemPositionItem !== ''){
        //正在定位点素材
        this.map.getCanvas().style.cursor = '';
        document.getElementById("labelCanvas").style.cursor = '';
        this.resetMaterialItemPositionItem = ""
      }


      this.isPreviewing(()=>{

        //获取要自动选中的视野点的index
        let nextViewPointIndex = this.$store.state.scenePointEditing
            ? this.$store.state.tempViewPointList.length
            : this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length

        //视野点栏折叠，自动打开
        if(!this.viewPointerListOpen){
          this.changeViewPointerListOpenState()
        }

        switch(item.type){
          case "point":{
            this.loadingDialogText = "视野点位添加中……";
            this.showLoadingDialog = true;
            this.addOneMaterialPointToViewPoint(item.geoJson.geo.geometry.coordinates[0],item.geoJson.geo.geometry.coordinates[1]);
            let temp = setInterval(()=>{
              if(!this.cutScreening) {
                clearInterval(temp);
                this.showLoadingDialog = false;
                //当前选中的视野点
                if(this.$store.state.scenePointEditing){
                  this.chooseViewItem(this.$store.state.tempViewPointList[nextViewPointIndex])
                }
                else{
                  this.chooseViewItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[nextViewPointIndex])
                }

                this.$store.state.snackbarType = 'success'
                this.$store.state.snackbarShow=true
                this.$store.state.snackbarText = "视野点位添加成功"

              }
            },1000)
            break;
          }
          case "lineString": case "roadString":{
            let pointList = item.geoJson.points;   //要转换的点列表
            if(pointList.length <= 20){
              //进行转换
              this.loadingDialogText = "视野点位添加中……";
              this.showLoadingDialog = true;
              //调用循环方法，逐一完成转换
              let i=0;
              this.addMaterialItemToViewPoint_multiple(i,pointList,nextViewPointIndex)
            }
            else{
              this.$store.state.snackbarShow = true
              this.$store.state.snackbarText = "节点数量大于20，无法添加"
              this.$store.state.snackbarType = 'error'

            }


            break;
          }
        }

      })



    },
    addMaterialItemToViewPoint_multiple(i,pointList,nextViewPointIndex){
      this.addOneMaterialPointToViewPoint(pointList[i].geometry.coordinates[0],pointList[i].geometry.coordinates[1]);
      let temp = setInterval(()=>{
        if(!this.cutScreening) {
          clearInterval(temp);

          if(i === pointList.length-1){
            //全部转换完成
            this.showLoadingDialog = false;
            //当前选中的视野点
            if(this.$store.state.scenePointEditing){
              this.chooseViewItem(this.$store.state.tempViewPointList[nextViewPointIndex])
            }
            else{
              this.chooseViewItem(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList[nextViewPointIndex])
            }

            this.$store.state.snackbarType = 'success'
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = "视野点位添加成功"
          }
          else{
            i++;
            this.addMaterialItemToViewPoint_multiple(i,pointList,nextViewPointIndex);
          }
        }
      },1000)

    },

    addOneMaterialPointToViewPoint(lng,lat){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      this.cutScreening = true;

      //当前视野点列表
      let currViewList = this.$store.state.scenePointEditing
          ? this.$store.state.tempViewPointList
          : this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList
      this.map.jumpTo(
          {
            center:[lng,lat],
            zoom:10,
            bearing:0,
            pitch:0,
          }
      )

      setTimeout(()=>{
        console.log("跳转完成")

        this.sceneFullMap.jumpTo({
          center:this.map.getCenter(),
          zoom:this.map.getZoom(),
          bearing:this.map.getBearing(),
          pitch:this.map.getPitch(),
        });

        setTimeout(()=>{
          //获取当前点位 截图地图区域
          html2canvas(this.$refs.sceneFullMap, {
            // width: 30, //截图宽度
            // height: this.$refs.globeMap.offsetHeight - 25, //截图高度
            backgroundColor: null, //画出来的图片有白色的边框,不要可设置背景为透明色（null）
            useCORS: true, //支持图片跨域
            scale: 1, //设置放大的倍数
          }).then((canvas) => {
            console.log(canvas)

            //添加视野点位，暂无缩略图
            this.$axios({
              method:"get",
              url:"/authorApi/POI/searchFromLocation",
              params:{
                lat:this.map.getCenter().lat,
                lon:this.map.getCenter().lng
              }
            }).then((resultData_poi)=>{
              resultData_poi = resultData_poi.data;
              if(resultData_poi.message === "ok"){
                //视野点名称
                let viewPointName;
                if(resultData_poi.result.city !== ""){
                  if(resultData_poi.result.name !== ""){
                    viewPointName = resultData_poi.result.city + " · " + resultData_poi.result.name;
                  }
                  else{
                    let num = this.$store.state.tempViewPointList.length+1;
                    viewPointName = resultData_poi.result.city + " · 视野点" + num;
                  }
                }
                else if(resultData_poi.result.province !== ""){
                  if(resultData_poi.result.name !== ""){
                    viewPointName = resultData_poi.result.province + " · " + resultData_poi.result.name;
                  }
                  else{
                    let num = this.$store.state.tempViewPointList.length+1;
                    viewPointName = resultData_poi.result.province + " · 视野点" + num;
                  }
                }
                else if(resultData_poi.result.city !== ""){
                  if(resultData_poi.result.name !== ""){
                    viewPointName = resultData_poi.result.city + " · " + resultData_poi.result.name;
                  }
                  else{
                    let num = this.$store.state.tempViewPointList.length+1;
                    viewPointName = resultData_poi.result.city + " · 视野点" + num;
                  }
                }
                else{
                  if(resultData_poi.result.name !== ""){
                    viewPointName = "其他 · " + resultData_poi.result.name;
                  }
                  else{
                    let num = this.$store.state.tempViewPointList.length+1;
                    viewPointName = "其他 · 视野点" + num;
                  }
                }

                //获取新id
                this.$utils.getNewId((newId)=>{
                  //添加视野点位，暂无缩略图
                  currViewList.push(
                      {
                        viewId:newId,
                        lng:lng,
                        lat:lat,
                        zoom:10,
                        pitch:0,
                        bearing:0,
                        name:viewPointName,
                        isZoomBasis:currViewList.length === 0 ? true : false,
                        viewPicture:"",
                        viewThumb:"",
                      },
                  )

                  //滚动条自动滚动到底部
                  this.viewListScrollToBottom();

                  //第一个点自动设为视野基准点
                  if(currViewList.length === 1){
                    if(this.$store.state.scenePointEditing){
                      if(this.$store.state.currChooseSceneItemIndex !== ''){
                        this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].zoomBasis = currViewList[0].zoom;
                      }
                      else{
                        this.$store.state.tempSceneZoomBasis = currViewList[0].zoom;
                      }
                    }
                    else{
                      this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].zoomBasis = currViewList[0].zoom;
                    }
                  }

                  //修改该录制点的动效(从第一个点增加到多点)
                  if(!this.$store.state.scenePointEditing && currViewList.length === 2){
                    if(this.$store.state.currChooseSceneItemIndex !== ''){
                      this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].pointAnimation = "平移跟踪";
                    }
                  }


                  // 把生成的base64位图片上传到服务器,生成在线图片地址
                  let url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64
                  //上传后台
                  let file = this.$utils.base64ToFile(url,"视野点位.jpg");
                  let paramData = new FormData();
                  paramData.append('multipartFile',file);
                  this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
                      .then((resultData)=>{
                        resultData = resultData.data;
                        console.log(resultData)
                        if(resultData.status === 200){
                          //补充点位图
                          currViewList[currViewList.length - 1].viewPicture = url;
                          currViewList[currViewList.length - 1].viewThumb = resultData.data.thumb;

                          this.cutScreening = false;
                        }
                        else{
                          console.log(resultData.status + resultData.message);
                        }
                      })
                      .catch(()=>{

                      })
                })

              }
              else{
                console.log(resultData_poi.status + resultData_poi.message);
              }
            }).catch((err)=>{
              console.log(err);
            });

          });
        },500)


      },1000)


    },



    //素材显示设置/////////////////////////////////////////////////////////////////////////////////////////////
    //滑块移动结束后修改填充部分宽度，使刻度线对齐
    rangeSliderChangeFun(){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      if(this.$store.state.currChooseMaterialItem.showSet.allShowInScenePoint){
        //勾选了在项目中常显，滑块disabled，没有v-slider__track-fill元素


      }
      else{
        let rangeSliderFillArea = this.$refs.setMaterialRangeSlider.$el.querySelector(".v-slider__track-fill");
        if(rangeSliderFillArea.style.width.indexOf("calc") !== -1 && rangeSliderFillArea.style.width !== "calc(0% + 0px)"){
          setTimeout(()=>{
            let newAreaWidth = rangeSliderFillArea.offsetWidth + 2;
            rangeSliderFillArea.style.width = newAreaWidth + "px"
          },200)
        }

        //调整素材出现 素材消失文字位置
        setTimeout(()=>{
          let rangeSliderBeginLeft = rangeSliderFillArea.style.left;
          this.setMaterialRangeSliderBeginLeft = rangeSliderBeginLeft.slice(0,rangeSliderBeginLeft.length-1) + " - 30px)";
          this.setMaterialRangeSliderEndLeft = rangeSliderBeginLeft.slice(0,rangeSliderBeginLeft.length-1) + " - 30px + " + rangeSliderFillArea.style.width + ")";
        },200)
      }


    },

    // //素材刻度尺上方点位显示
    // setMaterialAreaRangeSliderPointShow(index){
    //   let currViewPointNum = this.$store.state.scenePointEditing
    //       ? this.$store.state.tempViewPointList.length
    //       : this.$store.state.currChooseSceneItemIndex !== ''
    //           ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length
    //           : 0
    //   console.log(currViewPointNum)
    //
    //
    //
    //   return true;
    // },


    //改变 默认样式
    changeMaterialShowSet_defaultStyle(){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      switch(this.$store.state.currChooseMaterialItem.type){
        case "point":{
          let currPointList = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.pointList
              : this.$store.state.tempMaterialInfo.materialMarkerData.pointList;
          for(let i=0;i<currPointList.length;i++){
            if(currPointList[i].id === this.$store.state.currChooseMaterialItem.id){
              currPointList[i].showSet.defaultStyle = this.$store.state.currChooseMaterialItem.showSet.defaultStyle;
              break;
            }
          }
          break;
        }
        case "lineString": case "roadString":{
          //线样式
          let currLine = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.line
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.line;
          for(let i=0;i<currLine.features.length;i++){
            if(currLine.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currLine.features[i].properties.defaultStyle = this.$store.state.currChooseMaterialItem.showSet.defaultStyle ? 'true' : 'false';
              break;
            }
          }
          this.map.getSource('sceneMaterialLine').setData(currLine)
          //临时线样式（只有一项）
          this.$store.state.currChooseMaterialMarkerData.lineList.line.features[0].properties.defaultStyle = this.$store.state.currChooseMaterialItem.showSet.defaultStyle ? 'true' : 'false';
          this.map.getSource('sceneMaterialLine_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.line)

          //线点样式
          let currLinePoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.linePoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.linePoint;
          for(let i=0;i<currLinePoint.features.length;i++){
            if(currLinePoint.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currLinePoint.features[i].properties.defaultStyle = this.$store.state.currChooseMaterialItem.showSet.defaultStyle ? 'true' : 'false';
            }
          }
          this.map.getSource('sceneMaterialLinePoint').setData(currLinePoint)
          //临时线点样式（数组里所有点都属于当前素材）
          for(let i=0;i<this.$store.state.currChooseMaterialMarkerData.lineList.linePoint.features.length;i++){
            this.$store.state.currChooseMaterialMarkerData.lineList.linePoint.features[i].properties.defaultStyle = this.$store.state.currChooseMaterialItem.showSet.defaultStyle ? 'true' : 'false';
          }
          this.map.getSource('sceneMaterialLinePoint_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.linePoint)


          break;
        }
        case "circle": case "rectangle": case "polygon":{
          //多边形填充+边框样式
          let currPolygon = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygon
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygon;
          for(let i=0;i<currPolygon.features.length;i++){
            if(currPolygon.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currPolygon.features[i].properties.defaultStyle = this.$store.state.currChooseMaterialItem.showSet.defaultStyle ? 'true' : 'false';
              break;
            }
          }
          this.map.getSource('sceneMaterialPolygon').setData(currPolygon)
          //临时多边形填充+边框样式（只有一项）
          this.$store.state.currChooseMaterialMarkerData.polygonList.polygon.features[0].properties.defaultStyle = this.$store.state.currChooseMaterialItem.showSet.defaultStyle ? 'true' : 'false';
          this.map.getSource('sceneMaterialPolygon_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygon)

          //多边形点样式
          let currPolygonPoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonPoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonPoint;
          for(let i=0;i<currPolygonPoint.features.length;i++){
            if(currPolygonPoint.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currPolygonPoint.features[i].properties.defaultStyle = this.$store.state.currChooseMaterialItem.showSet.defaultStyle ? 'true' : 'false';
            }
          }
          this.map.getSource('sceneMaterialPolygonPoint').setData(currPolygonPoint)
          //临时多边形点样式（数组里所有点都属于当前素材）
          for(let i=0;i<this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint.features.length;i++){
            this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint.features[i].properties.defaultStyle = this.$store.state.currChooseMaterialItem.showSet.defaultStyle ? 'true' : 'false';
          }
          this.map.getSource('sceneMaterialPolygonPoint_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint)

          break;
        }
      }
    },
    //改变 素材标题显隐
    changeMaterialShowSet_showName(){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      switch(this.$store.state.currChooseMaterialItem.type){
        case "point":{
          let currPointList = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.pointList
              : this.$store.state.tempMaterialInfo.materialMarkerData.pointList;
          for(let i=0;i<currPointList.length;i++){
            if(currPointList[i].id === this.$store.state.currChooseMaterialItem.id){
              this.$set(currPointList[i].showSet,"showName",this.$store.state.currChooseMaterialItem.showSet.showName)
              break;
            }
          }

          break;
        }
        case "lineString": case "roadString":{
          //线名
          let currLineName = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.lineName
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.lineName;
          for(let i=0;i<currLineName.features.length;i++){
            if(currLineName.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currLineName.features[i].properties.visible = this.$store.state.currChooseMaterialItem.showSet.showName ? 'visible' : 'none';
              break;
            }
          }
          this.map.getSource('sceneMaterialLineName').setData(currLineName)

          //临时线名
          this.$store.state.currChooseMaterialMarkerData.lineList.lineName.features[0].properties.visible = this.$store.state.currChooseMaterialItem.showSet.showName ? 'visible' : 'none';
          this.map.getSource('sceneMaterialLineName_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.lineName)


          break;
        }
        case "circle": case "rectangle": case "polygon":{
          //多边形名
          let currPolygonName = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonName
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonName;
          for(let i=0;i<currPolygonName.features.length;i++){
            if(currPolygonName.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currPolygonName.features[i].properties.visible = this.$store.state.currChooseMaterialItem.showSet.showName ? 'visible' : 'none';
              break;
            }
          }
          this.map.getSource('sceneMaterialPolygonName').setData(currPolygonName)
          //临时多边形名
          this.$store.state.currChooseMaterialMarkerData.polygonList.polygonName.features[0].properties.visible = this.$store.state.currChooseMaterialItem.showSet.showName ? 'visible' : 'none';
          this.map.getSource('sceneMaterialPolygonName_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygonName)


          break;
        }
      }
    },
    //改变 节点显隐
    changeMaterialShowSet_showPoint(){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      switch(this.$store.state.currChooseMaterialItem.type){
        //素材-点 没有此选项
        case "lineString": case "roadString":{
          //线点
          let currLinePoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.lineList.linePoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.lineList.linePoint;
          for(let i=0;i<currLinePoint.features.length;i++){
            if(currLinePoint.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currLinePoint.features[i].properties.visible = this.$store.state.currChooseMaterialItem.showSet.showPoint ? 'visible' : 'none';
            }
          }
          this.map.getSource('sceneMaterialLinePoint').setData(currLinePoint)
          //临时多边形点（数组里所有点都属于当前素材）
          for(let i=0;i<this.$store.state.currChooseMaterialMarkerData.lineList.linePoint.features.length;i++){
            this.$store.state.currChooseMaterialMarkerData.lineList.linePoint.features[i].properties.visible = this.$store.state.currChooseMaterialItem.showSet.showPoint ? 'visible' : 'none';
          }
          this.map.getSource('sceneMaterialLinePoint_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.lineList.linePoint)


          break;
        }
        case "circle": case "rectangle": case "polygon":{
          //多边形点
          let currPolygonPoint = this.$store.state.currChooseSceneItemIndex !== ''
              ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.polygonList.polygonPoint
              : this.$store.state.tempMaterialInfo.materialMarkerData.polygonList.polygonPoint;
          for(let i=0;i<currPolygonPoint.features.length;i++){
            if(currPolygonPoint.features[i].id === this.$store.state.currChooseMaterialItem.id){
              currPolygonPoint.features[i].properties.visible = this.$store.state.currChooseMaterialItem.showSet.showPoint ? 'visible' : 'none';
            }
          }
          this.map.getSource('sceneMaterialPolygonPoint').setData(currPolygonPoint)
          //临时多边形点（数组里所有点都属于当前素材）
          for(let i=0;i<this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint.features.length;i++){
            this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint.features[i].properties.visible = this.$store.state.currChooseMaterialItem.showSet.showPoint ? 'visible' : 'none';
          }
          this.map.getSource('sceneMaterialPolygonPoint_currChooseMaterial').setData(this.$store.state.currChooseMaterialMarkerData.polygonList.polygonPoint)


          break;
        }
      }


    },
    //改变 显示标记图片
    changeMaterialShowSet_showMarkerImage(){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      let currPointList = this.$store.state.currChooseSceneItemIndex !== ''
          ? this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.pointList
          : this.$store.state.tempMaterialInfo.materialMarkerData.pointList;
      for(let i=0;i<currPointList.length;i++){
        if(currPointList[i].id === this.$store.state.currChooseMaterialItem.id){
          currPointList[i].showSet.showMarkerImage = this.$store.state.currChooseMaterialItem.showSet.showMarkerImage;
          break;
        }
      }

    },


    //改变 设置在整个录制点常显
    changeMaterialShowSet_allShowInScenePoint(){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      if(!this.$store.state.currChooseMaterialItem.showSet.allShowInScenePoint){
        setTimeout(()=>{
          this.rangeSliderChangeFun()
        },50)

      }

    },


    //判断是否正在选中素材，因为地球上图层有变化，分情况处理
    isMaterialShow(nextFun){
      if(this.$store.state.setMaterialAreaShow){
        this.$store.state.setMaterialAreaShow = false;
        //等待素材显隐处理完成
        let materialAreaHideTemp = setInterval(()=>{
          if(this.$store.state.currChooseMaterialItemIndex === ""){
            clearInterval(materialAreaHideTemp)
            nextFun()
          }
        },100)
      }
      else{
        //不选择任何录制点
        nextFun()
      }

    },



    //样例/////////////////////////////////////////////////////////////////////////////////////////////
    //正在编辑，确定添加样例
    chooseExampleItemNotSaveDialogOK(){
      //取消编辑状态
      this.viewPointerListCancel();

      this.chooseExampleItem_notSaveDialogShow = false;
      this.$refs.mainGlobeScene.addExampleToSceneList(this.nextExampleItemId)
    },


    addExampleToSceneList(exampleId){
      this.$refs.mainGlobeScene.addExampleToSceneList(exampleId)
    },



    //弹窗蒙层等/////////////////////////////////////////////////////////////////////////////////////////////

    //退出录屏弹窗 隐藏
    hideQuitScenePageDialog(){
      this.quitScenePageDialogShow = false;
    },
    //弹窗 确定退出录屏
    quitScenePageOK(){
      this.mainArea = this.nextMainArea
      this.nextMainArea = ""
      setTimeout(()=>{
        this.map.getCanvas().style.cursor = 'grab'
        document.getElementById("labelCanvas").style.cursor = 'grab';
      },100)
    },

    //添加录制点 完成 按钮引导蒙层显示
    sceneGuideMantle_viewFinishBtnAvailable_show(){
      this.$store.state.sceneViewPointAreaShow = true
      this.$store.state.scenePointEditing = true
      setTimeout(()=>{
        this.sceneGuideMantle_viewFinishBtnAvailable = true;

        //蒙层中间露出
        let clipLeftTopX = (this.$refs.viewFinishBtn.getBoundingClientRect().left - 20) + "px"
        let clipLeftTopY= (this.$refs.viewFinishBtn.getBoundingClientRect().top - 20) + "px"
        let clipLeftBottomX = (this.$refs.viewFinishBtn.getBoundingClientRect().left - 20) + "px"
        let clipLeftBottomY= (this.$refs.viewFinishBtn.getBoundingClientRect().bottom + 20) + "px"
        let clipRightBottomX = (this.$refs.viewFinishBtn.getBoundingClientRect().right + 20) + "px"
        let clipRightBottomY= (this.$refs.viewFinishBtn.getBoundingClientRect().bottom + 20) + "px"
        let clipRightTopX = (this.$refs.viewFinishBtn.getBoundingClientRect().right + 20) + "px"
        let clipRightTopY= (this.$refs.viewFinishBtn.getBoundingClientRect().top - 20) + "px"
        this.sceneGuideMantle_viewFinishBtnAvailable_clipPathStyle =
            "polygon(0% 0%,0% 100%,"+clipLeftBottomX+" 100%,"+clipLeftTopX+" "+clipLeftTopY+","+clipRightTopX+" "+clipRightTopY+","
            +clipRightBottomX+" "+clipRightBottomY+","+clipLeftBottomX+" "+clipLeftBottomY+","+clipLeftBottomX+" 100%,100% 100%,100% 0%)"

        //箭头位置
        let leftInt = this.$refs.viewFinishBtn.getBoundingClientRect().left+30;
        this.sceneGuideMantle_arrowPositionLeft = leftInt + "px";
        let topInt = this.$refs.viewFinishBtn.getBoundingClientRect().bottom+5;
        this.sceneGuideMantle_arrowPositionTop = topInt + "px";
        this.sceneGuideMantle_arrowShow = true;

      },100)

    },



    //销毁录制栏时，停止当前预览等
    destroyedStopPreviewFun(){
      if(this.previewing){
        this.sceneItemPlaying = false;
        this.previewing = false;
        this.$store.state.sceneCurrPlayItem = "";

        this.previewAnimationFrameStop = true;
        clearInterval(this.previewIntervalTemp)
        clearTimeout(this.previewTemp)

        this.animationAllScreenMapMantleName = "";
        this.animationAllScreenMapMantleDuration = "";
        this.animationAllScreenMantleShow = false;
        this.animationAllScreenBackground = "";
        this.animationAllScreenMantleName = "";
        this.animationAllScreenMantleDuration = "";
        this.animationAllScreenMantleCenterShow = false;
        this.animationAllScreenCenterBackground = "";
        this.animationAllScreenMantleCenterName = "";
        this.animationAllScreenMantleCenterDuration = "";
        this.animationWindowMantleShow = false;
        this.animationWindowBackground = "";
        this.animationWindowMantleDuration = "";

        this.map.stop();


      }


    },



    // //旧版本方法/////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // //进入录屏
    // intoGlobeOperationScene(){
    //   this.cleanMapOnEvent()
    //   this.clearAllMeasure()
    //   this.closeEditCard()
    //   this.drawToolsChoose='selectTool'
    //   this.drawToolsOldChose = 'selectTool'
    //
    //
    //   // //数据恢复初始化
    //   // this.globeOperationSceneList = [];
    //   // this.globeOperationSceneListShow = true;
    //   // this.currClickItemIndex = -1;
    //   // this.currOpenPanelItemIndex = -1;
    //   // this.editSceneNameShow = false;
    //   // this.flyPanelParamShow = false;
    //   // this.pointPanelParamShow = false;
    //
    //   this.animationAllScreenMantleShow = false;
    //   this.animationAllScreenMantleName = "";
    //   this.animationAllScreenMantleDuration = "";
    //   this.animationAllScreenBackground = "";
    //   this.animationAllScreenMantleCenterShow = false;
    //   this.animationAllScreenMantleCenterName = "";
    //   this.animationAllScreenMantleCenterDuration = "";
    //   this.animationAllScreenCenterBackground = "";
    //   this.animationWindowMantleShow = false;
    //   this.animationWindowMantleDuration = "";
    //   this.animationWindowBackground = "";
    //
    //
    //   // //记录进入录屏时的地球视角
    //   // this.mapCameraOptions = this.map.getFreeCameraOptions()
    //
    //   //关闭地球设置弹窗
    //   if(this.globeSetShow){
    //     this.globeSetShow = false;
    //   }
    //
    //
    //
    //
    // },
    // //按下esc退出场景
    // keyUpInScene(e){
    //   this.isDrawingLine(()=>{
    //     this.isPreviewing(()=>{
    //       console.log(e.keyCode)
    //       if (e.keyCode === 27) {
    //         //esc 退出场景
    //         e.stopPropagation();
    //         this.quitSceneFun();
    //
    //       }
    //     })
    //   })
    // },
    //退出场景的方法
    // quitSceneFun(){
    //   if(this.$store.state.sceneList.length === 0){
    //     //退出录屏
    //     // document.removeEventListener('keyup', this.keyUpInScene);
    //     setTimeout(()=>{
    //       this.map.resize()
    //     },0)
    //
    //     // if(this.currOpenPanelItemIndex !== -1){
    //     //   //有面板正在展开
    //     //   //可能有路径正在展示，隐藏
    //     //   if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pointType === "路径"){
    //     //     //隐藏路径图层
    //     //     if(this.map.getSource('sceneDrawLine_points')){
    //     //       this.map.removeLayer("sceneDrawLine_points");
    //     //       this.map.removeSource("sceneDrawLine_points");
    //     //     }
    //     //     if(this.map.getSource('sceneDrawLine_line')){
    //     //       this.map.removeLayer("sceneDrawLine_line");
    //     //       this.map.removeSource("sceneDrawLine_line");
    //     //     }
    //     //     if(this.map.getSource('sceneDrawLine_lineMove')){
    //     //       this.map.removeLayer("sceneDrawLine_lineMove");
    //     //       this.map.removeSource("sceneDrawLine_lineMove");
    //     //     }
    //     //   }
    //     // }
    //
    //
    //     // if(this.map.getCanvas().style.cursor === "crosshair") {
    //     //   //正在绘制路径
    //     //   this.finishDrawLine()
    //     // }
    //
    //     //解除对跟随鼠标tips的监听
    //     // this.globeOperationSceneTip = false;
    //     // this.map.getCanvas().removeEventListener("mouseenter",this.getGlobeOperationSceneTipPosition_mouseenterFun)
    //     // this.map.getCanvas().removeEventListener("mousemove",this.getGlobeOperationSceneTipPosition_mousemoveFun)
    //     // this.map.getCanvas().removeEventListener("mouseleave",this.getGlobeOperationSceneTipPosition_mouseleaveFun)
    //
    //
    //     //恢复地球视野为进入录屏时的初始状态
    //     // this.map.setFreeCameraOptions(this.mapCameraOptions)
    //
    //   }
    //   else{
    //     this.quitScenePageDialogShow = true;
    //   }
    // },
    //

    //
    //
    // //根据鼠标位置获取操作tips位置
    // getGlobeOperationSceneTipPosition_mouseenterFun(){
    //   this.map.getCanvas().addEventListener("mousemove",this.getGlobeOperationSceneTipPosition_mousemoveFun)
    //   this.map.getCanvas().addEventListener("mouseleave",this.getGlobeOperationSceneTipPosition_mouseleaveFun)
    // },
    // getGlobeOperationSceneTipPosition_mousemoveFun(e){
    //   this.globeOperationSceneTipLeft = e.clientX + 10 + "px";
    //   this.globeOperationSceneTipTop = e.clientY - 30 + "px";
    //   this.globeOperationSceneTip = true;
    // },
    // getGlobeOperationSceneTipPosition_mouseleaveFun(){
    //   this.globeOperationSceneTip = false;
    //   this.map.getCanvas().removeEventListener("mousemove",this.getGlobeOperationSceneTipPosition_mousemoveFun)
    //   this.map.getCanvas().removeEventListener("mouseleave",this.getGlobeOperationSceneTipPosition_mouseleaveFun)
    // },
    //
    //
    // //添加飞行点位
    // addFlyPoint(){
    //   if(!this.cutScreening){
    //     this.cutScreening = true;
    //     this.isDrawingLine(()=>{
    //       this.isPreviewing(()=>{
    //
    //         //退出页面时弹出弹窗
    //         this.$store.state.globeQuitShowDialog = true;
    //
    //         if(this.globeOperationSceneList.length === 0){
    //           //第一个点位
    //           this.map.getCanvas().removeEventListener("mouseenter",this.getGlobeOperationSceneTipPosition_mouseenterFun)
    //         }
    //         //获取当前点位 截图地图区域
    //         html2canvas(this.$refs.globeMap, {
    //           // width: 30, //截图宽度
    //           // height: this.$refs.globeMap.offsetHeight - 25, //截图高度
    //           backgroundColor: null, //画出来的图片有白色的边框,不要可设置背景为透明色（null）
    //           useCORS: true, //支持图片跨域
    //           scale: 1, //设置放大的倍数
    //         }).then((canvas) => {
    //
    //           //添加点位，暂无缩略图
    //           let newSceneName;
    //           if(this.globeOperationSceneList.length !== 0){
    //             let newSceneNameIndex = 1;
    //             for(let i=0;i<this.globeOperationSceneList.length;i++){
    //               let prevSceneName = this.globeOperationSceneList[i].sceneName;
    //               let prevSceneNameIndex = prevSceneName.slice(2,prevSceneName.length);
    //
    //               if(prevSceneNameIndex.indexOf("（")){
    //                 prevSceneNameIndex = prevSceneNameIndex.slice(0,prevSceneNameIndex.indexOf("（"));
    //               }
    //
    //               if(prevSceneNameIndex !== ""){
    //                 if(parseInt(prevSceneNameIndex)+1 > newSceneNameIndex){
    //                   newSceneNameIndex = parseInt(prevSceneNameIndex)+1
    //                 }
    //               }
    //
    //             }
    //
    //             newSceneName = "视野"+newSceneNameIndex + "（" + this.map.getCenter().lng.toFixed(2) + ", " + this.map.getCenter().lat.toFixed(2) + "）";
    //           }
    //           else{
    //             newSceneName = "视野1" + "（" + this.map.getCenter().lng.toFixed(2) + ", " + this.map.getCenter().lat.toFixed(2) + "）";
    //           }
    //
    //           this.globeOperationSceneList.push(
    //               {
    //                 sceneName:newSceneName,
    //                 sceneThumb:"",
    //                 scenePicture:"",
    //                 sceneCenter:this.map.getCenter(),
    //                 sceneZoom:this.map.getZoom(),
    //                 scenePitch:this.map.getPitch(),
    //                 sceneBearing:this.map.getBearing(),
    //
    //                 flyPanelOpen:false,   //飞行设置面板展开
    //                 pointPanelOpen:false,   //点位设置面板展开
    //
    //                 //飞行设置
    //                 flyType:"跳转",
    //                 //跳转参数
    //                 flyParam:{
    //                   duration:5,
    //                   minZoom:6,
    //                 },
    //                 //平移参数
    //                 easeParam:{
    //                   duration:5,
    //                 },
    //                 //切换参数
    //                 jumpParam:{
    //                   type:"淡出",
    //                   duration:3,
    //                 },
    //
    //                 //点位设置
    //                 pointType:"无效果",
    //                 //旋转参数
    //                 rotateParam:{
    //                   duration:5,
    //                   speed:0.1,
    //                   direction:1
    //                 },
    //                 //俯视参数
    //                 pitchParam:{
    //                   duration:5,
    //                   pitchValue:60
    //                 },
    //                 //路径参数
    //                 pathParam:{
    //                   speed:5000,
    //                   height:8000,
    //                   routePoints:[],
    //                   drawLineData:{
    //                     //用于展示的数据
    //                     jsonPoint:{
    //                       'type': 'FeatureCollection',
    //                       'features': []
    //                     },
    //                     jsonLine:{
    //                       'type': 'FeatureCollection',
    //                       'features': []
    //                     },
    //                     jsonLineMove:{
    //                       'type': 'FeatureCollection',
    //                       'features': []
    //                     },
    //                   },
    //                 }
    //
    //
    //               },
    //           )
    //
    //           // 把生成的base64位图片上传到服务器,生成在线图片地址
    //           let url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64
    //           //上传后台
    //           let file = this.$utils.base64ToFile(url,"飞行点位.jpg");
    //           let paramData = new FormData();
    //           paramData.append('multipartFile',file);
    //           this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
    //               .then((resultData)=>{
    //                 resultData = resultData.data;
    //                 if(resultData.status === 200){
    //                   //补充点位缩略图
    //                   this.globeOperationSceneList[this.globeOperationSceneList.length - 1].sceneThumb = resultData.data.thumb;
    //                   // this.globeOperationSceneList[this.globeOperationSceneList.length - 1].scenePicture = resultData.data.picture;
    //                   this.globeOperationSceneList[this.globeOperationSceneList.length - 1].scenePicture = url;
    //
    //                   this.cutScreening = false;
    //                 }
    //                 else{
    //                   console.log(resultData.status + resultData.message);
    //                 }
    //               })
    //               .catch(()=>{
    //
    //               })
    //         });
    //
    //
    //       })
    //
    //     })
    //   }
    //
    //
    // },
    //
    // //删除飞行点位
    // deleteSceneItem(index){
    //   this.isDrawingLine(()=>{
    //     this.isPreviewing(()=>{
    //       if(this.currClickItemIndex === index){
    //         //被删除场景正在选中
    //         if(this.currOpenPanelItemIndex === index){
    //           //当前场景面板正在打开
    //           //可能有路径正在展示，隐藏
    //           if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pointType === "路径"){
    //             //隐藏路径图层
    //             if(this.map.getSource('sceneDrawLine_points')){
    //               this.map.removeLayer("sceneDrawLine_points");
    //               this.map.removeSource("sceneDrawLine_points");
    //             }
    //             if(this.map.getSource('sceneDrawLine_line')){
    //               this.map.removeLayer("sceneDrawLine_line");
    //               this.map.removeSource("sceneDrawLine_line");
    //             }
    //             if(this.map.getSource('sceneDrawLine_lineMove')){
    //               this.map.removeLayer("sceneDrawLine_lineMove");
    //               this.map.removeSource("sceneDrawLine_lineMove");
    //             }
    //           }
    //           this.currOpenPanelItemIndex = -1
    //         }
    //         else{
    //           if(this.currOpenPanelItemIndex > index){
    //             this.currOpenPanelItemIndex --;
    //           }
    //         }
    //         this.currClickItemIndex = -1;
    //       }
    //       else{
    //         if(this.currClickItemIndex > index){
    //           this.currClickItemIndex --;
    //         }
    //       }
    //       this.globeOperationSceneList.splice(index,1)
    //
    //       //场景已经全部删除，退出页面时不弹出弹窗
    //       if(this.globeOperationSceneList.length === 0){
    //         this.$store.state.globeQuitShowDialog = false;
    //       }
    //
    //     })
    //
    //
    //   })
    //
    // },
    //
    // //进入编辑场景名称
    // intoEditSceneName(e,index){
    //   this.isDrawingLine(()=>{
    //     this.isPreviewing(()=>{
    //       if(this.currClickItemIndex === index){
    //         this.editSceneNameShow = true;
    //         //该双击场景名称的下一个元素，是输入框
    //         let currTextFieldDom = e.target.nextSibling.querySelector("input")
    //         setTimeout(()=>{
    //           currTextFieldDom.focus()
    //           currTextFieldDom.select();
    //         },0)
    //       }
    //     })
    //
    //   })
    //
    // },
    //
    //
    // //点击某个场景，不是面板按钮
    // clickSceneItem(item,index){
    //   this.isDrawingLine(()=>{
    //     this.isPreviewing(()=>{
    //       this.map.flyTo({
    //         center: item.sceneCenter,
    //         zoom: item.sceneZoom,
    //         pitch: item.scenePitch,
    //         bearing:item.sceneBearing,
    //       })
    //       this.currClickItemIndex = index;
    //
    //       //如果有某个场景的面板正打开，需要将它关闭
    //       if(this.currOpenPanelItemIndex !== -1){
    //         //可能有路径正在展示，隐藏
    //         if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pointType === "路径"){
    //           //隐藏路径图层
    //           if(this.map.getSource('sceneDrawLine_points')){
    //             this.map.removeLayer("sceneDrawLine_points");
    //             this.map.removeSource("sceneDrawLine_points");
    //           }
    //           if(this.map.getSource('sceneDrawLine_line')){
    //             this.map.removeLayer("sceneDrawLine_line");
    //             this.map.removeSource("sceneDrawLine_line");
    //           }
    //           if(this.map.getSource('sceneDrawLine_lineMove')){
    //             this.map.removeLayer("sceneDrawLine_lineMove");
    //             this.map.removeSource("sceneDrawLine_lineMove");
    //           }
    //         }
    //         //关闭面板
    //         this.globeOperationSceneList[this.currOpenPanelItemIndex].flyPanelOpen = false;
    //         this.globeOperationSceneList[this.currOpenPanelItemIndex].pointPanelOpen = false;
    //         this.currOpenPanelItemIndex = -1;
    //       }
    //     })
    //
    //   })
    //
    //
    // },
    //
    //
    // //点击飞行面板开关
    // clickFlyPanelBtn(item,index){
    //   if(index !== this.globeOperationSceneList.length - 1){
    //     //不是最后一个场景
    //     this.isDrawingLine(()=>{
    //       this.isPreviewing(()=>{
    //         if(item.pointPanelOpen){
    //           //点位面板展开，将其关闭
    //           item.pointPanelOpen = false;
    //           //旧的打开点位面板的场景，处于路径状态
    //           if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pointType === "路径"){
    //             //隐藏路径图层
    //             if(this.map.getSource('sceneDrawLine_points')){
    //               this.map.removeLayer("sceneDrawLine_points");
    //               this.map.removeSource("sceneDrawLine_points");
    //             }
    //             if(this.map.getSource('sceneDrawLine_line')){
    //               this.map.removeLayer("sceneDrawLine_line");
    //               this.map.removeSource("sceneDrawLine_line");
    //             }
    //             if(this.map.getSource('sceneDrawLine_lineMove')){
    //               this.map.removeLayer("sceneDrawLine_lineMove");
    //               this.map.removeSource("sceneDrawLine_lineMove");
    //             }
    //           }
    //         }
    //         item.flyPanelOpen = !item.flyPanelOpen;
    //
    //         if(item.flyPanelOpen){
    //           //该场景的面板打开了
    //           if(this.currOpenPanelItemIndex !== -1){
    //             if(this.currOpenPanelItemIndex !== index){
    //               //有原本打开面板的场景，且不是当前点击的场景，序号index，将其关闭
    //               //旧的打开点位面板的场景，处于路径状态
    //               if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pointPanelOpen
    //                   && this.globeOperationSceneList[this.currOpenPanelItemIndex].pointType === "路径"){
    //                 //隐藏路径图层
    //                 if(this.map.getSource('sceneDrawLine_points')){
    //                   this.map.removeLayer("sceneDrawLine_points");
    //                   this.map.removeSource("sceneDrawLine_points");
    //                 }
    //                 if(this.map.getSource('sceneDrawLine_line')){
    //                   this.map.removeLayer("sceneDrawLine_line");
    //                   this.map.removeSource("sceneDrawLine_line");
    //                 }
    //                 if(this.map.getSource('sceneDrawLine_lineMove')){
    //                   this.map.removeLayer("sceneDrawLine_lineMove");
    //                   this.map.removeSource("sceneDrawLine_lineMove");
    //                 }
    //               }
    //
    //               this.globeOperationSceneList[this.currOpenPanelItemIndex].flyPanelOpen = false;
    //               this.globeOperationSceneList[this.currOpenPanelItemIndex].pointPanelOpen = false;
    //               this.currOpenPanelItemIndex = index;
    //             }
    //           }
    //           else{
    //             this.currOpenPanelItemIndex = index;
    //           }
    //         }
    //         else{
    //           //该场景面板关闭了
    //           this.currOpenPanelItemIndex = -1;
    //         }
    //
    //         //更多参数设置关闭
    //         this.flyPanelParamShow = false;
    //         // this.flyPointParamShow = false;
    //
    //         //点击开关按钮相当于点击了该场景
    //         this.map.flyTo({
    //           center: item.sceneCenter,
    //           zoom: item.sceneZoom,
    //           pitch: item.scenePitch,
    //           bearing:item.sceneBearing,
    //         })
    //         this.currClickItemIndex = index;
    //       })
    //
    //     })
    //   }
    //
    //
    //
    // },
    // //点击点位面板开关
    // clickPointPanelBtn(item,index){
    //   this.isDrawingLine(()=>{
    //     this.isPreviewing(()=>{
    //
    //       if(item.flyPanelOpen){
    //         //飞行面板展开，将其关闭
    //         item.flyPanelOpen = false;
    //       }
    //       item.pointPanelOpen = !item.pointPanelOpen
    //       if(item.pointPanelOpen){
    //         //该场景的面板打开了
    //         if(this.currOpenPanelItemIndex !== -1){
    //           if(this.currOpenPanelItemIndex !== index){
    //             //有原本打开面板的场景，且不是当前点击的场景，序号index，将其关闭
    //             this.globeOperationSceneList[this.currOpenPanelItemIndex].flyPanelOpen = false;
    //             this.globeOperationSceneList[this.currOpenPanelItemIndex].pointPanelOpen = false;
    //
    //             //旧的打开点位面板的场景，处于路径状态
    //             if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pointType === "路径"){
    //               //隐藏路径图层
    //               if(this.map.getSource('sceneDrawLine_points')){
    //                 this.map.removeLayer("sceneDrawLine_points");
    //                 this.map.removeSource("sceneDrawLine_points");
    //               }
    //               if(this.map.getSource('sceneDrawLine_line')){
    //                 this.map.removeLayer("sceneDrawLine_line");
    //                 this.map.removeSource("sceneDrawLine_line");
    //               }
    //               if(this.map.getSource('sceneDrawLine_lineMove')){
    //                 this.map.removeLayer("sceneDrawLine_lineMove");
    //                 this.map.removeSource("sceneDrawLine_lineMove");
    //               }
    //             }
    //             this.currOpenPanelItemIndex = index;
    //           }
    //         }
    //         else{
    //           this.currOpenPanelItemIndex = index;
    //         }
    //
    //         //如果该点位类型是路径，需要展示对应路径
    //         if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pointType === "路径"){
    //           //添加图层
    //           this.initDrawLineLayer();
    //         }
    //
    //       }
    //       else{
    //         //该场景面板关闭了
    //         //旧的打开点位面板的场景，处于路径状态
    //         if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pointType === "路径"){
    //           //隐藏路径图层
    //           if(this.map.getSource('sceneDrawLine_points')){
    //             this.map.removeLayer("sceneDrawLine_points");
    //             this.map.removeSource("sceneDrawLine_points");
    //           }
    //           if(this.map.getSource('sceneDrawLine_line')){
    //             this.map.removeLayer("sceneDrawLine_line");
    //             this.map.removeSource("sceneDrawLine_line");
    //           }
    //           if(this.map.getSource('sceneDrawLine_lineMove')){
    //             this.map.removeLayer("sceneDrawLine_lineMove");
    //             this.map.removeSource("sceneDrawLine_lineMove");
    //           }
    //         }
    //
    //         this.currOpenPanelItemIndex = -1;
    //       }
    //
    //       //更多参数设置关闭
    //       this.flyPanelParamShow = false;
    //       // this.flyPointParamShow = false;
    //
    //
    //       //点击开关按钮相当于点击了该场景
    //       this.map.flyTo({
    //         center: item.sceneCenter,
    //         zoom: item.sceneZoom,
    //         pitch: item.scenePitch,
    //         bearing:item.sceneBearing,
    //       })
    //       this.currClickItemIndex = index;
    //     })
    //
    //   })
    //
    //
    //
    // },
    //
    //
    // //点击点位面板的类型，路径或非路径有特殊操作
    // choosePointType(sceneItem,pointType){
    //
    //   if(pointType !== "路径"){
    //     //路径暂时不可用
    //
    //
    //     this.isDrawingLine(()=>{
    //       this.isPreviewing(()=>{
    //         sceneItem.pointType = pointType;
    //         if(pointType === "路径"){
    //           this.initDrawLine()
    //           //显示第一步操作tips
    //           this.globeOperationSceneTipContent = "左键开始绘制路径";
    //           this.map.getCanvas().addEventListener("mouseenter",this.getGlobeOperationSceneTipPosition_mouseenterFun)
    //         }
    //         else{
    //           //其他类型，结束绘制，清空图层
    //           this.finishDrawLine();
    //           this.clearDrawLineLayer()
    //           //解除对画线操作tips位置的监听
    //           this.globeOperationSceneTip = false;
    //           this.map.getCanvas().removeEventListener("mouseenter",this.getGlobeOperationSceneTipPosition_mouseenterFun)
    //           this.map.getCanvas().removeEventListener("mousemove",this.getGlobeOperationSceneTipPosition_mousemoveFun)
    //           this.map.getCanvas().removeEventListener("mouseleave",this.getGlobeOperationSceneTipPosition_mouseleaveFun)
    //         }
    //       })
    //
    //     })
    //
    //   }
    //
    //
    //
    //
    // },
    //
    // //初始化地图上绘制线方法
    // initDrawLine(){
    //   this.map.getCanvas().style.cursor = 'crosshair';
    //   this.map.doubleClickZoom.disable()
    //
    //   //添加图层
    //   this.initDrawLineLayer();
    //
    //   //单击添加点
    //   this.map.on("click",this.drawLineClickFun)
    //
    //   //双击 添加点+结束绘制
    //   this.map.on("dblclick",this.drawLineDblclickFun)
    //
    //   //鼠标移动中展示移动中线
    //   this.map.on("mousemove",this.drawLineMouseMoveFun)
    //
    //   //右键 结束绘制
    //   this.map.on('contextmenu', this.drawLineContextmenuFun);
    //
    // },
    // initDrawLineLayer(){
    //
    //   this.map.addSource('sceneDrawLine_points', {
    //     type: 'geojson',
    //     data: this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint
    //   });
    //   this.map.addLayer({
    //     id: 'sceneDrawLine_points',
    //     type: 'circle',
    //     source: 'sceneDrawLine_points',
    //     layout:{
    //       'visibility':"visible"
    //     },
    //     paint: {
    //       'circle-color': '#2A82E4',
    //       'circle-radius': 3,
    //       "circle-stroke-width": 2,
    //       "circle-stroke-color": "#FFFFFF",
    //       "circle-stroke-opacity": 1
    //     }
    //   });
    //   this.map.addSource('sceneDrawLine_line', {
    //     type: 'geojson',
    //     data: this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLine
    //   });
    //   this.map.addLayer({
    //     id: 'sceneDrawLine_line',
    //     type: 'line',
    //     source: 'sceneDrawLine_line',
    //     layout:{
    //       'visibility':"visible"
    //     },
    //     paint: {
    //       'line-color': "#2A82E4",
    //       'line-width': 3,
    //       'line-opacity': 1
    //     }
    //   });
    //   this.map.addSource('sceneDrawLine_lineMove', {
    //     type: 'geojson',
    //     data: this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLineMove
    //   });
    //   this.map.addLayer({
    //     id: 'sceneDrawLine_lineMove',
    //     type: 'line',
    //     source: 'sceneDrawLine_lineMove',
    //     paint: {
    //       'line-color': "#2A82E4",
    //       'line-width': 3,
    //       'line-opacity': 1,
    //       "line-dasharray": [3, 1]
    //     }
    //   });
    // },
    // //结束画线绘制
    // finishDrawLine(){
    //   this.map.off("click",this.drawLineClickFun);
    //   this.map.off("dblclick",this.drawLineDblclickFun);
    //   this.map.off("mousemove",this.drawLineMouseMoveFun);
    //   this.map.off('contextmenu', this.drawLineContextmenuFun);
    //   this.map.getCanvas().style.cursor = 'grab';
    //   this.drawingLine = false;
    //   setTimeout(()=>{
    //     this.map.doubleClickZoom.enable()
    //   },0)
    // },
    // //清空球上图层等
    // clearDrawLineLayer(){
    //   //初始化点 线 的值和样式
    //   this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint = {
    //     'type': 'FeatureCollection',
    //     'features': []
    //   }
    //   this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLine = {
    //     'type': 'FeatureCollection',
    //     'features': []
    //   }
    //   this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLineMove = {
    //     'type': 'FeatureCollection',
    //     'features': []
    //   }
    //
    //   if(this.map.getSource('sceneDrawLine_points')){
    //     this.map.removeLayer("sceneDrawLine_points");
    //     this.map.removeSource("sceneDrawLine_points");
    //   }
    //   if(this.map.getSource('sceneDrawLine_line')){
    //     this.map.removeLayer("sceneDrawLine_line");
    //     this.map.removeSource("sceneDrawLine_line");
    //   }
    //   if(this.map.getSource('sceneDrawLine_lineMove')){
    //     this.map.removeLayer("sceneDrawLine_lineMove");
    //     this.map.removeSource("sceneDrawLine_lineMove");
    //   }
    //
    //   this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.routePoints = []
    // },
    //
    //
    // //重新绘制
    // redrawLine(){
    //   this.isPreviewing(()=>{
    //     this.clearDrawLineLayer();
    //     this.initDrawLine();
    //   })
    //
    // },
    //
    // //画线 单击的操作
    // drawLineClickFun(e){
    //   if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.routePoints.length > 0){
    //     //不是第一个点，判断当前点是否重复
    //     if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.routePoints[this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.routePoints.length - 1][0] !== e.lngLat.lng
    //         || this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.routePoints[this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.routePoints.length - 1][1] !== e.lngLat.lat){
    //       //该点不重复，应当添加
    //       this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLine.features.push({
    //         type: 'Feature',
    //         geometry: {
    //           type: 'LineString',
    //           coordinates: [
    //             this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint.features[this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint.features.length - 1].geometry.coordinates,
    //             [e.lngLat.lng,e.lngLat.lat]
    //           ]
    //         }
    //       });
    //       this.map.getSource('sceneDrawLine_line').setData(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLine);
    //       //清除移动中线
    //       this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLineMove.features = [];
    //       this.map.getSource('sceneDrawLine_lineMove').setData(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLineMove);
    //
    //       //添加点
    //       this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint.features.push({
    //         type: 'Feature',
    //         geometry: {
    //           type: 'Point',
    //           coordinates: [e.lngLat.lng,e.lngLat.lat]
    //         },
    //       });
    //       this.map.getSource('sceneDrawLine_points').setData(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint);
    //       this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.routePoints.push([e.lngLat.lng,e.lngLat.lat])
    //
    //       if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.routePoints.length === 2){
    //         //第二个点，解除对画线第二步操作tips位置的监听
    //         this.globeOperationSceneTip = false;
    //         this.map.getCanvas().removeEventListener("mouseenter",this.getGlobeOperationSceneTipPosition_mouseenterFun)
    //         this.map.getCanvas().removeEventListener("mousemove",this.getGlobeOperationSceneTipPosition_mousemoveFun)
    //         this.map.getCanvas().removeEventListener("mouseleave",this.getGlobeOperationSceneTipPosition_mouseleaveFun)
    //       }
    //
    //
    //
    //     }
    //   }
    //   else{
    //     //第一个点，直接添加即可
    //     this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint.features.push({
    //       type: 'Feature',
    //       geometry: {
    //         type: 'Point',
    //         coordinates: [e.lngLat.lng,e.lngLat.lat]
    //       },
    //     });
    //     this.map.getSource('sceneDrawLine_points').setData(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint);
    //     this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.routePoints.push([e.lngLat.lng,e.lngLat.lat])
    //     //解除对画线第一步操作tips位置的监听，显示第二步操作tips
    //     this.globeOperationSceneTipContent = "单击继续绘制路径，右键结束路径绘制";
    //
    //     //进入绘制中
    //     this.drawingLine = true;
    //
    //   }
    // },
    // //画线 双击的操作
    // drawLineDblclickFun(e){
    //   //单击添加点
    //   this.drawLineClickFun(e)
    //   //结束画线
    //   this.finishDrawLine()
    // },
    // //画线 鼠标移动的操作
    // drawLineMouseMoveFun(e){
    //   if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint.features.length > 0){
    //     //不是第一个点，需要画移动中
    //     this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLineMove.features = [{
    //       type: 'Feature',
    //       geometry: {
    //         type: 'LineString',
    //         coordinates: [
    //           this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint.features[this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint.features.length - 1].geometry.coordinates,
    //           [e.lngLat.lng,e.lngLat.lat]
    //         ]
    //       }
    //     }];
    //     this.map.getSource('sceneDrawLine_lineMove').setData(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLineMove);
    //   }
    // },
    // //画线 右键操作
    // drawLineContextmenuFun(){
    //   if(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonPoint.features.length > 0){
    //     //不是第一个点，清除移动中线
    //     this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLineMove.features = [];
    //     this.map.getSource('sceneDrawLine_lineMove').setData(this.globeOperationSceneList[this.currOpenPanelItemIndex].pathParam.drawLineData.jsonLineMove);
    //   }
    //   //结束画线
    //   this.finishDrawLine()
    //
    //   //解除对画线操作tips位置的监听
    //   this.globeOperationSceneTip = false;
    //   this.map.getCanvas().removeEventListener("mouseenter",this.getGlobeOperationSceneTipPosition_mouseenterFun)
    //   this.map.getCanvas().removeEventListener("mousemove",this.getGlobeOperationSceneTipPosition_mousemoveFun)
    //   this.map.getCanvas().removeEventListener("mouseleave",this.getGlobeOperationSceneTipPosition_mouseleaveFun)
    //
    // },
    //
    // //判断是否在画线中，并处理
    // isDrawingLine(nextFun){
    //   if(this.drawingLine){
    //     this.$store.state.snackbarType = 'error'
    //     this.$store.state.snackbarShow = true;
    //     this.$store.state.snackbarText = '绘制未结束，请先结束绘制';
    //   }
    //   else{
    //     if(nextFun !== undefined){
    //       nextFun();
    //     }
    //   }
    // },
    //
    //
    // //点击飞行面板的预览
    // flyPanelPreview(item,index){
    //   this.isPreviewing(()=>{
    //     this.previewing = true;
    //     this.previewingType = "fly+" + item.flyType + "+" + item.jumpParam.type
    //
    //     let nextSceneItem = this.globeOperationSceneList[index+1];   //下一个场景
    //     switch(item.flyType){
    //       case "跳转":{
    //         this.flyToFun(nextSceneItem.sceneCenter.lng,nextSceneItem.sceneCenter.lat,nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
    //             nextSceneItem.scenePitch,item.flyParam.duration,item.flyParam.minZoom,
    //             ()=>{this.previewing = false;this.jumpToSceneItem(item)}
    //         )
    //         break;
    //       }
    //       case "平移":{
    //         this.easeToFun(nextSceneItem.sceneCenter.lng,nextSceneItem.sceneCenter.lat,nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
    //             nextSceneItem.scenePitch,item.easeParam.duration,
    //             ()=>{this.previewing = false;this.jumpToSceneItem(item)}
    //         )
    //         break;
    //       }
    //       case "切换":{
    //         switch(item.jumpParam.type){
    //           case "淡出":{
    //             this.pageAnimationAllScreen("blackToTransparent",item.jumpParam.duration,item.scenePicture,
    //                 ()=>{this.previewing = false;this.jumpToSceneItem(item)}
    //             )
    //             this.jumpToSceneItem(nextSceneItem)
    //
    //             break;
    //           }
    //           case "浮出":{
    //             this.pageAnimationAllScreen("height100To0",item.jumpParam.duration,item.scenePicture,
    //                 ()=>{this.previewing = false;this.jumpToSceneItem(item)}
    //             )
    //             this.jumpToSceneItem(nextSceneItem)
    //
    //             break;
    //           }
    //           case "缩放":{
    //             this.pageAnimationAllScreenCenter("allScreenToCenter",item.jumpParam.duration,item.scenePicture,
    //                 ()=>{this.previewing = false;this.jumpToSceneItem(item)}
    //             )
    //             this.jumpToSceneItem(nextSceneItem)
    //
    //             break;
    //           }
    //           case "百叶窗":{
    //             this.pageAnimationWindowClose(item.jumpParam.duration,item.scenePicture,
    //                 ()=>{this.previewing = false;this.jumpToSceneItem(item)}
    //             )
    //             this.jumpToSceneItem(nextSceneItem)
    //
    //             break;
    //           }
    //
    //         }
    //
    //
    //         break;
    //       }
    //
    //       case "无效果":{
    //         this.jumpToFun(nextSceneItem.sceneCenter.lng,nextSceneItem.sceneCenter.lat,nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
    //             nextSceneItem.scenePitch,
    //             ()=>{this.previewing = false;this.jumpToSceneItem(item)}
    //         )
    //         break;
    //       }
    //
    //     }
    //
    //   })
    //
    //
    //
    // },
    // //点击点位面板的预览
    // pointPanelPreview(item){
    //   this.isDrawingLine(()=>{
    //     this.isPreviewing(()=>{
    //       this.previewing = true;
    //       this.previewingType = "point+"+item.pointType
    //
    //       switch(item.pointType){
    //         case "旋转":{
    //           this.rotateToByDuration(item.rotateParam.speed,item.rotateParam.direction,item.rotateParam.duration,
    //               ()=>{this.previewing = false;this.jumpToSceneItem(item)}
    //           )
    //           break;
    //         }
    //         case "俯视":{
    //           this.setPitchFun(item.pitchParam.pitchValue,item.pitchParam.duration,
    //               ()=>{this.previewing = false;this.jumpToSceneItem(item)}
    //           )
    //           break;
    //         }
    //         case "路径":{
    //           if(item.pathParam.routePoints.length > 1){
    //
    //             this.isDrawingLine(()=>{
    //               //隐藏绘制的路径
    //               this.map.setLayoutProperty('sceneDrawLine_points', 'visibility', 'none');
    //               this.map.setLayoutProperty('sceneDrawLine_line', 'visibility', 'none');
    //
    //               //飞行预览开始
    //               this.previewAnimationFrameStop = false;
    //               this.flyByPath(item.pathParam.routePoints,item.pathParam.speed,item.pathParam.height,
    //                   ()=>{
    //                     this.previewing = false;
    //                     this.map.setLayoutProperty('sceneDrawLine_points', 'visibility', 'visible');
    //                     this.map.setLayoutProperty('sceneDrawLine_line', 'visibility', 'visible');
    //                     this.jumpToSceneItem(item)
    //                   })
    //             })
    //
    //           }
    //           else{
    //             this.$store.state.snackbarType = 'error'
    //             this.$store.state.snackbarText = '当前暂无路径，请先绘制路径'
    //             this.$store.state.snackbarShow = true;
    //
    //             this.previewing = false;
    //           }
    //
    //           break;
    //         }
    //         case "无效果":{
    //           this.previewing = false;
    //
    //           break;
    //         }
    //
    //
    //       }
    //     })
    //
    //
    //   })
    //
    // },
    //
    //
    //
    //
    // //全屏播放
    // scenePlay(){
    //   console.log("播放")
    //
    //   this.createExample()
    //
    //   this.isDrawingLine(()=>{
    //     this.isPreviewing(()=>{
    //       if(this.globeOperationSceneList.length > 0){
    //         document.removeEventListener('keyup', this.keyUpInScene);
    //         document.addEventListener('keyup', this.escQuitFullScreen);
    //         //隐藏绘制的路径
    //         if(this.map.getLayer('sceneDrawLine_points') !== undefined){
    //           if(this.map.getLayoutProperty('sceneDrawLine_points', 'visibility') === 'visible'){
    //             this.fullScreenHiddenPath = true;
    //             this.map.setLayoutProperty('sceneDrawLine_points', 'visibility', 'none');
    //             this.map.setLayoutProperty('sceneDrawLine_line', 'visibility', 'none');
    //           }
    //         }
    //         //隐藏比例尺
    //         document.querySelector('.mapboxgl-ctrl-scale').style.visibility = 'hidden'
    //
    //         //屏蔽mapbox的鼠标交互
    //         this.map.boxZoom.disable();
    //         this.map.scrollZoom.disable();
    //         this.map.dragPan.disable();
    //         this.map.dragRotate.disable();
    //         this.map.doubleClickZoom.disable();
    //         this.map.touchZoomRotate.disable();
    //
    //
    //         this.$store.state.globeSceneFullScreen = true
    //         setTimeout(()=>{
    //           this.map.resize()
    //         },0)
    //
    //
    //         //显示即将开始蒙层
    //         this.jumpToSceneItem(this.globeOperationSceneList[0])
    //         this.fullScreenPlayBeginMantleSecond = 3;
    //         this.fullScreenPlayBeginMantle = true;
    //
    //         //倒计时
    //         clearInterval(this.previewIntervalTemp)
    //         this.previewIntervalTemp = setInterval(()=>{
    //           if(this.fullScreenPlayBeginMantleSecond === 1){
    //             clearInterval(this.previewIntervalTemp);
    //           }
    //           this.fullScreenPlayBeginMantleSecond = this.fullScreenPlayBeginMantleSecond - 1;
    //         },1000)
    //
    //         clearTimeout(this.previewTemp)
    //         this.previewTemp = setTimeout(()=>{
    //           this.fullScreenPlayBeginMantle = false;
    //           //开始全屏飞行
    //           clearTimeout(this.previewTemp)
    //           this.previewTemp = setTimeout(()=>{
    //             this.pointChange(0)
    //           },1000)
    //
    //
    //         },3000)
    //
    //
    //       }
    //       else{
    //         this.$store.state.snackbarText = "当前无可播放内容，请至少添加1个内容"
    //         this.$store.state.snackbarType = 'error'
    //         this.$store.state.snackbarShow=true
    //       }
    //
    //     })
    //   })
    //
    // },
    // //全屏播放 点位效果
    // pointChange(i){
    //   if(i < this.globeOperationSceneList.length){
    //
    //     let currSceneItem = this.globeOperationSceneList[i];   //当前场景
    //
    //     //进行点位效果
    //     this.previewing = true;
    //     this.previewingType = "point+"+currSceneItem.pointType
    //     console.log(this.previewingType)
    //     switch(currSceneItem.pointType){
    //       case "旋转":{
    //         this.rotateToByDuration(currSceneItem.rotateParam.speed * this.screenPlaySpeed,currSceneItem.rotateParam.direction,currSceneItem.rotateParam.duration / this.screenPlaySpeed,
    //             ()=>{this.previewing = false;this.flyChange(i)}
    //         )
    //         break;
    //       }
    //       case "俯视":{
    //         this.setPitchFun(currSceneItem.pitchParam.pitchValue,currSceneItem.pitchParam.duration / this.screenPlaySpeed,
    //             ()=>{this.previewing = false;this.flyChange(i)}
    //         )
    //         break;
    //       }
    //       case "路径":{
    //         if(currSceneItem.pathParam.routePoints.length > 1){
    //           //飞行预览开始
    //           this.previewAnimationFrameStop = false;
    //           this.flyByPath(currSceneItem.pathParam.routePoints,currSceneItem.pathParam.speed / this.screenPlaySpeed,currSceneItem.pathParam.height,
    //               ()=>{
    //                 this.previewing = false;
    //                 this.flyChange(i)
    //               })
    //         }
    //         else{
    //           this.previewing = false;
    //           this.flyChange(i)
    //         }
    //
    //         break;
    //       }
    //       case "无效果":{
    //         this.previewing = false;
    //         this.flyChange(i)
    //
    //         break;
    //       }
    //
    //
    //     }
    //   }
    //   else{
    //     console.log("播放结束")
    //     this.quitFullScreenFun()
    //   }
    //
    // },
    // //全屏播放 飞行效果
    // flyChange(i){
    //   if(i !== this.globeOperationSceneList.length - 1){
    //
    //     let currSceneItem = this.globeOperationSceneList[i];   //当前场景
    //     let nextSceneItem = this.globeOperationSceneList[i+1];   //下一个场景
    //
    //     this.previewing = true;
    //     this.previewingType = "fly+" + currSceneItem.flyType + "+" + currSceneItem.jumpParam.type
    //     console.log(this.previewingType)
    //
    //     switch(currSceneItem.flyType){
    //       case "跳转":{
    //         this.flyToFun(nextSceneItem.sceneCenter.lng,nextSceneItem.sceneCenter.lat,nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
    //             nextSceneItem.scenePitch,currSceneItem.flyParam.duration / this.screenPlaySpeed,currSceneItem.flyParam.minZoom,
    //             ()=>{this.previewing = false;this.pointChange(i+1)}
    //         )
    //         break;
    //       }
    //       case "平移":{
    //         this.easeToFun(nextSceneItem.sceneCenter.lng,nextSceneItem.sceneCenter.lat,nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
    //             nextSceneItem.scenePitch,currSceneItem.easeParam.duration / this.screenPlaySpeed,
    //             ()=>{this.previewing = false;this.pointChange(i+1)}
    //         )
    //         break;
    //       }
    //       case "切换":{
    //         switch(currSceneItem.jumpParam.type){
    //           case "淡出":{
    //             this.pageAnimationAllScreen("blackToTransparent",currSceneItem.jumpParam.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
    //                 ()=>{this.previewing = false;this.pointChange(i+1)}
    //             )
    //             this.jumpToSceneItem(nextSceneItem)
    //
    //             break;
    //           }
    //           case "浮出":{
    //             this.pageAnimationAllScreen("height100To0",currSceneItem.jumpParam.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
    //                 ()=>{this.previewing = false;this.pointChange(i+1)}
    //             )
    //             this.jumpToSceneItem(nextSceneItem)
    //
    //             break;
    //           }
    //           case "缩放":{
    //             this.pageAnimationAllScreenCenter("allScreenToCenter",currSceneItem.jumpParam.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
    //                 ()=>{this.previewing = false;this.pointChange(i+1)}
    //             )
    //             this.jumpToSceneItem(nextSceneItem)
    //
    //             break;
    //           }
    //           case "百叶窗":{
    //             this.pageAnimationWindowClose(currSceneItem.jumpParam.duration / this.screenPlaySpeed,currSceneItem.scenePicture,
    //                 ()=>{this.previewing = false;this.pointChange(i+1)}
    //             )
    //             this.jumpToSceneItem(nextSceneItem)
    //
    //             break;
    //           }
    //
    //         }
    //
    //
    //         break;
    //       }
    //
    //       case "无效果":{
    //         this.jumpToFun(nextSceneItem.sceneCenter.lng,nextSceneItem.sceneCenter.lat,nextSceneItem.sceneZoom,nextSceneItem.sceneBearing,
    //             nextSceneItem.scenePitch,
    //             ()=>{this.previewing = false;this.pointChange(i+1)}
    //         )
    //         break;
    //       }
    //
    //     }
    //
    //   }
    //   else{
    //     console.log("播放结束")
    //     this.quitFullScreenFun()
    //   }
    // },
    // //中间打断全屏播放，处理动效停止
    // scenePlayStop(){
    //
    //   //当前正有跳转在进行
    //   if(this.previewing){
    //
    //     let panelType = this.previewingType.split("+")[0];
    //     let previewType = this.previewingType.split("+")[1];
    //
    //     if(panelType === "fly"){
    //       switch(previewType){
    //         case "跳转": case "平移":{
    //           this.map.stop();
    //           break;
    //         }
    //         case "切换":{
    //           switch(this.previewingType.split("+")[2]){
    //             case "淡出": case "浮出":{
    //               clearTimeout(this.previewTemp)
    //               this.animationAllScreenMantleShow = false;
    //               this.animationAllScreenBackground = "";
    //               this.animationAllScreenMantleName = "";
    //               this.animationAllScreenMantleDuration = "";
    //
    //               break;
    //             }
    //             case "缩放":{
    //               clearTimeout(this.previewTemp)
    //               this.animationAllScreenMantleCenterShow = false;
    //               this.animationAllScreenCenterBackground = "";
    //               this.animationAllScreenMantleCenterName = "";
    //               this.animationAllScreenMantleCenterDuration = "";
    //
    //               break;
    //             }
    //             case "百叶窗":{
    //               clearTimeout(this.previewTemp)
    //               this.animationWindowMantleShow = false;
    //               this.animationWindowBackground = "";
    //               this.animationWindowMantleDuration = "";
    //
    //               break;
    //             }
    //
    //           }
    //
    //           break;
    //         }
    //         case "无效果":{
    //           clearTimeout(this.previewTemp)
    //           break;
    //         }
    //
    //       }
    //     }
    //     else if(panelType === "point"){
    //       switch(previewType){
    //         case "旋转":{
    //           clearInterval(this.previewIntervalTemp)
    //           clearTimeout(this.previewTemp)
    //           break;
    //         }
    //         case "俯视":{
    //           this.map.stop();
    //           clearTimeout(this.previewTemp)
    //           break;
    //         }
    //         case "路径":{
    //           clearTimeout(this.previewTemp)
    //           this.previewAnimationFrameStop = true;
    //
    //           break;
    //         }
    //
    //       }
    //
    //     }
    //
    //     //跳转结束
    //     this.previewing = false;
    //
    //   }
    //   else{
    //     //可能在初始蒙层处延时，也可能正好一段播放结束
    //     clearInterval(this.previewIntervalTemp)
    //     clearTimeout(this.previewTemp)
    //     this.fullScreenPlayBeginMantle = false;
    //   }
    //
    // },




  },



}
</script>

<style scoped>


</style>
